import React, { useEffect, useState } from "react";
import image1 from "../../img/employerImage.png";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import nextSectionImage from "../../img/employersectionImage.png";
import api from "../../Api.js";
import { usePopup } from "../Common/PopupContext";
import { useHistory } from "react-router-dom";
import Vectorcandidate from "../../img/Vector.png";
import VisitorTracker from "../Common/VisitorTracker.js";
import health_bgimage from "../../img/health_bgimage.png";
import Login from "../Website/Login";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
const settings = {
  dots: false,
  infinite: false, // Enable infinite loop
  speed: 5000,
  slidesToShow: 5, // Show 5 slides at a time
  slidesToScroll: 1,
  autoplay: true, // Optional: Add autoplay functionality
  autoplaySpeed: 2000, // Optional: Set autoplay speed (in milliseconds)
  responsive: [
    {
      breakpoint: 1100, // Adjust for screens less than 1000px
      settings: {
        slidesToShow: 3, // Show 3 slides at a time on medium screens
      },
    },
    {
      breakpoint: 800, // Adjust for screens less than 700px
      settings: {
        slidesToShow: 2, // Show 2 slides at a time on smaller screens
      },
    },
    {
      breakpoint: 600, // Adjust for screens less than 500px
      settings: {
        slidesToShow: 1, // Show 1 slide at a time on extra small screens
      },
    },
  ],
};

const HealthRecruiter = () => {
  const history = useHistory();
  const [Animate, setAnimate] = useState(false);
  const submitform = (formId) => {
    const formData = {};
    const form = document.getElementById(formId);

    for (var i = 0; i < form.elements.length; i++) {
      var element = form.elements[i];

      if (element.name && element.type !== "submit") {
        var nameParts = element.name.split("[");

        if (nameParts.length > 1) {
          var currentObj = formData;

          for (var j = 0; j < nameParts.length - 1; j++) {
            var key = nameParts[j].replace("]", "");
            if (!currentObj[key]) {
              currentObj[key] = {};
            }
            currentObj = currentObj[key];
          }
          var key = nameParts[nameParts.length - 1].replace("]", "");

          if (key === "tags") {
            if (!currentObj[key]) {
              currentObj[key] = [];
            }
            currentObj[key] = currentObj[key].concat(
              element.value.split(",").map((tag) => tag.trim())
            );
          } else {
            if (currentObj[key]) {
              if (!Array.isArray(currentObj[key])) {
                currentObj[key] = [currentObj[key]];
              }
              currentObj[key].push(element.value);
            } else {
              currentObj[key] = element.value;
            }
          }
        } else {
          formData[element.name] = element.value;
        }
      }
    }
    return formData;
  };

  const handleSubmit = async (e) => {
    var formData = submitform("contactus");
    e.preventDefault();
    try {
      const response = await api.contactus(formData);
    } catch (error) {}
  };
  useEffect(() => {
    setAnimate(true);
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "data:text/javascript;base64,LyogQWxsaSBBSSB3aWRnZXQgZm9yIHd3dy5oaXJlcHJvcy5jby51ayAqLwooZnVuY3Rpb24gKHcsZCxzLG8sZixqcyxmanMpIHt3WydBbGxpSlNXaWRnZXQnXT1vO3dbb10gPSB3W29dIHx8IGZ1bmN0aW9uICgpIHsgKHdbb10ucSA9IHdbb10ucSB8fCBbXSkucHVzaChhcmd1bWVudHMpIH07anMgPSBkLmNyZWF0ZUVsZW1lbnQocyksIGZqcyA9IGQuZ2V0RWxlbWVudHNCeVRhZ05hbWUocylbMF07anMuaWQgPSBvOyBqcy5zcmMgPSBmOyBqcy5hc3luYyA9IDE7IGZqcy5wYXJlbnROb2RlLmluc2VydEJlZm9yZShqcywgZmpzKTt9KHdpbmRvdywgZG9jdW1lbnQsICdzY3JpcHQnLCAnYWxsaScsICdodHRwczovL3N0YXRpYy5hbGxpYWkuY29tL3dpZGdldC92MS5qcycpKTthbGxpKCdpbml0JywgJ3NpdGVfV3RkekJOTUs2aUVORGN0eScpO2FsbGkoJ29wdGltaXplJywgJ2FsbCcpOw==";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  /* ======= For Popup ====== */
  const { openPopup } = usePopup();

  const handleClosePopup = (message) => {
    //console.log(message);
    openPopup();
  };

  const handleClickEmployee = () => {
    const popup = (
      <Login
        onClose={() => handleClosePopup("Popup closed")}
        employee="employee"
      />
    );
    openPopup(popup);
  };
  useEffect(() => {
    AOS.init({
      duration: 1500, // Animation duration in milliseconds
      offset: 10, // Offset value for the animation trigger point
      easing: "ease-in-out", // Easing option for the animation
      mirror: true, // Animate elements when scrolling back
      once: true, // Only animate once
      anchorPlacement: "top-center", // Anchor placement for the animation trigger
    });
    AOS.refresh(); // Refresh AOS to detect changes
  }, []);
  const departments = [
    {
      id: 1,
      name: "Human Resources",
      svg: (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.5711 61.884C38.0877 61.884 40.5013 60.8843 42.2808 59.1048M35.5711 61.884C33.0544 61.884 30.6409 60.8843 28.8613 59.1048M35.5711 61.884V69M42.2808 59.1048C44.0603 57.3252 45.0601 54.9117 45.0601 52.395M42.2808 59.1048L47.3131 64.137M45.0601 52.395C45.0601 49.8784 44.0603 47.4648 42.2808 45.6853M45.0601 52.395H52.1761M42.2808 45.6853C40.5013 43.9058 38.0877 42.906 35.5711 42.906M42.2808 45.6853L47.3131 40.653M35.5711 42.906C33.0544 42.906 30.6409 43.9058 28.8613 45.6853M35.5711 42.906V35.79M28.8613 45.6853C27.0818 47.4648 26.0821 49.8784 26.0821 52.395M28.8613 45.6853L23.8291 40.653M26.0821 52.395C26.0821 54.9117 27.0818 57.3252 28.8613 59.1048M26.0821 52.395H18.9661M28.8613 59.1048L23.8291 64.137M33.9901 35.79H37.1521M46.1941 39.534L48.4321 41.772M52.1761 50.814V53.976M48.4321 63.018L46.1941 65.256M37.1521 69H33.9901M24.9481 65.256L22.7131 63.018M18.9661 53.976V50.814M22.7131 41.772L24.9481 39.534"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.0711 27.0121C25.7361 25.3341 23.9937 22.9587 23.0945 20.2276C22.1954 17.4964 22.1858 14.5505 23.0672 11.8136C23.9486 9.07669 25.6756 6.68997 27.9996 4.99687C30.3236 3.30378 33.1248 2.3916 36.0001 2.3916C38.8754 2.3916 41.6766 3.30378 44.0006 4.99687C46.3246 6.68997 48.0515 9.07669 48.933 11.8136C49.8144 14.5505 49.8048 17.4964 48.9056 20.2276C48.0065 22.9587 46.264 25.3341 43.9291 27.0121C48.9638 28.6774 53.3458 31.8867 56.4526 36.1843C59.5595 40.4819 61.2332 45.6491 61.2361 50.9521V69.6091"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.764 69.6087V50.9547C10.7663 45.6512 12.4397 40.4833 15.5466 36.1852C18.6535 31.887 23.0358 28.6772 28.071 27.0117"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 2,
      name: "Dental Services",
      svg: (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M41.9999 14.9997C40.4999 16.4997 37.4909 16.2357 32.9999 12.5277M32.9999 12.5277C33.6639 11.9837 34.3529 11.3577 35.0669 10.6497C41.9849 3.79768 51.4049 5.13868 55.8179 10.6497C57.6959 12.9957 61.3769 17.4927 59.4629 28.4997M32.9999 12.5277C32.3359 11.9837 31.6469 11.3577 30.9329 10.6497C24.0149 3.79768 14.5949 5.13868 10.1819 10.6497C7.13395 14.4597 -0.66605 23.9397 18.4259 57.7197C19.2179 59.1177 20.7929 59.9997 22.4879 59.9997C25.1939 59.9997 27.3089 57.8397 27.3959 55.3197C27.5339 51.4107 28.2899 47.0547 30.3989 44.9997M47.9999 50.9997L50.0519 53.0517C50.4929 53.4927 50.7149 53.7147 50.9819 53.6997C51.2519 53.6847 51.4469 53.4417 51.8369 52.9527L56.9999 46.4997M38.9999 46.3617V47.5197C38.9999 51.1257 38.9999 52.9287 39.4439 54.5787C39.9987 56.6253 41.0427 58.5063 42.4859 60.0597C43.6559 61.3257 45.2039 62.3097 48.2969 64.2807C49.6799 65.1627 50.3729 65.6037 51.1109 65.8107C52.0199 66.0627 52.9829 66.0627 53.8919 65.8107C54.6269 65.6037 55.3199 65.1627 56.7029 64.2807C59.7959 62.3097 61.3439 61.3257 62.5139 60.0597C63.9572 58.5063 65.0012 56.6253 65.5559 54.5787C65.9999 52.9287 65.9999 51.1287 65.9999 47.5197V46.3617C65.9999 44.1177 65.9999 42.9957 65.5739 42.0477C65.3066 41.4625 64.931 40.9332 64.4669 40.4877C63.7079 39.7677 62.6309 39.3717 60.4769 38.5827L56.0549 36.9627C54.2969 36.3207 53.4179 35.9997 52.4999 35.9997C51.5819 35.9997 50.7029 36.3207 48.9449 36.9657L44.5229 38.5857C42.3689 39.3717 41.2919 39.7647 40.5329 40.4877C40.0678 40.9329 39.6911 41.4623 39.4229 42.0477C38.9999 42.9957 38.9999 44.1177 38.9999 46.3617Z"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 3,
      name: "Veterinary Services",
      svg: (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.6113 27.1796C29.9665 26.6094 32.4548 23.5537 32.8335 19.9033C33.218 16.191 34.0849 1.27256 28.4847 2.22152C13.958 4.68536 14.9775 29.1524 26.6113 27.1796ZM45.7244 27.1796C57.3553 29.1524 58.3748 4.68536 43.8481 2.22008C38.2494 1.27112 39.1148 16.1895 39.4978 19.9018C39.878 23.5537 42.3692 26.6094 45.7244 27.1796ZM20.6439 38.7068C20.6439 36.7657 19.9513 35.006 18.8353 33.7258C16.9993 31.3268 11.163 26.4754 9.73017 27.7182C6.73929 30.3188 6.83577 36.7196 8.63721 41.3708C9.56313 43.957 11.7994 45.7758 14.413 45.7758C17.8532 45.7758 20.6439 42.6106 20.6439 38.7068ZM62.6012 27.7182C61.1713 26.4754 55.335 31.3268 53.499 33.7258C52.383 35.006 51.6889 36.7657 51.6889 38.7068C51.6889 42.6106 54.4825 45.7758 57.9198 45.7758C60.5348 45.7758 62.7726 43.957 63.6985 41.3708C65.4956 36.7196 65.595 30.3188 62.6012 27.7182ZM50.8854 49.717C45.5919 47.0775 45.7561 41.9943 44.5522 37.3561C43.5946 33.6567 40.2034 30.9207 36.1671 30.9207C34.2951 30.9164 32.4721 31.5192 30.9716 32.6388C29.4712 33.7583 28.3743 35.3342 27.8454 37.13C26.5566 41.5681 27.3327 46.7348 21.5626 49.6825C16.8754 51.2103 14.9775 53.4394 14.9775 58.7113C14.9775 62.9938 18.6538 67.5788 23.3986 68.149C28.6921 68.9468 32.822 67.9042 36.1671 65.9977C39.5122 67.9042 43.6393 68.9454 48.9414 68.149C53.6833 67.5788 57.361 63.0111 57.361 58.7113C57.3596 53.3242 55.5826 51.3169 50.8854 49.717ZM44.6401 56.1596H39.1522L39.1594 61.9196H33.1748L33.1834 56.1596H27.3601V50.3996H33.1849L33.1762 44.6396H39.1609L39.1537 50.3996H44.6401V56.1596Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 4,
      name: "Health Insurance",
      svg: (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.5 10.5C25.5 9.30653 25.9741 8.16193 26.818 7.31802C27.6619 6.47411 28.8065 6 30 6H42C43.1935 6 44.3381 6.47411 45.182 7.31802C46.0259 8.16193 46.5 9.30653 46.5 10.5H51C52.1935 10.5 53.3381 10.9741 54.182 11.818C55.0259 12.6619 55.5 13.8065 55.5 15V37.5H52.5V15C52.5 14.6022 52.342 14.2206 52.0607 13.9393C51.7794 13.658 51.3978 13.5 51 13.5H46.5C46.5 14.6935 46.0259 15.8381 45.182 16.682C44.3381 17.5259 43.1935 18 42 18H30C28.8065 18 27.6619 17.5259 26.818 16.682C25.9741 15.8381 25.5 14.6935 25.5 13.5H21C20.6022 13.5 20.2206 13.658 19.9393 13.9393C19.658 14.2206 19.5 14.6022 19.5 15V57C19.5 57.3978 19.658 57.7794 19.9393 58.0607C20.2206 58.342 20.6022 58.5 21 58.5H39V61.5H21C19.8065 61.5 18.6619 61.0259 17.818 60.182C16.9741 59.3381 16.5 58.1935 16.5 57V15C16.5 13.8065 16.9741 12.6619 17.818 11.818C18.6619 10.9741 19.8065 10.5 21 10.5H25.5ZM30 9C29.6022 9 29.2206 9.15804 28.9393 9.43934C28.658 9.72064 28.5 10.1022 28.5 10.5V13.5C28.5 13.8978 28.658 14.2794 28.9393 14.5607C29.2206 14.842 29.6022 15 30 15H42C42.3978 15 42.7794 14.842 43.0607 14.5607C43.342 14.2794 43.5 13.8978 43.5 13.5V10.5C43.5 10.1022 43.342 9.72064 43.0607 9.43934C42.7794 9.15804 42.3978 9 42 9H30ZM34.5 24V28.5H30V31.5H34.5V36H37.5V31.5H42V28.5H37.5V24H34.5ZM42 40.5C41.6022 40.5 41.2206 40.658 40.9393 40.9393C40.658 41.2206 40.5 41.6022 40.5 42V52.1835C40.5001 53.912 40.9269 55.6137 41.7425 57.1377C42.5581 58.6616 43.7373 59.9607 45.1755 60.9195L50.1675 64.2495C50.414 64.414 50.7037 64.5017 51 64.5017C51.2963 64.5017 51.586 64.414 51.8325 64.2495L56.8245 60.9195C58.2625 59.9608 59.4416 58.662 60.2572 57.1384C61.0728 55.6147 61.4997 53.9132 61.5 52.185V42C61.5 41.6022 61.342 41.2206 61.0607 40.9393C60.7794 40.658 60.3978 40.5 60 40.5H42ZM56.5605 49.0605L50.5605 55.0605C50.2792 55.3417 49.8977 55.4997 49.5 55.4997C49.1023 55.4997 48.7208 55.3417 48.4395 55.0605L45.4395 52.0605L47.5605 49.9395L49.5 51.879L54.4395 46.9395L56.5605 49.0605Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 5,
      name: "Long-Term Care & Elderly Services",
      svg: (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27 22.5C28.5913 22.5 30.1174 21.8679 31.2426 20.7426C32.3678 19.6174 33 18.0913 33 16.5C33 14.9087 32.3678 13.3826 31.2426 12.2574C30.1174 11.1321 28.5913 10.5 27 10.5C25.4087 10.5 23.8826 11.1321 22.7573 12.2574C21.6321 13.3826 21 14.9087 21 16.5C21 18.0913 21.6321 19.6174 22.7573 20.7426C23.8826 21.8679 25.4087 22.5 27 22.5ZM18.774 31.4025C19.0052 31.1254 19.2474 30.8577 19.5 30.6V57C19.4995 57.7674 19.7931 58.5057 20.3204 59.0633C20.8477 59.6208 21.5685 59.955 22.3347 59.9973C23.1009 60.0396 23.8542 59.7866 24.4396 59.2905C25.025 58.7944 25.3981 58.0928 25.482 57.33L26.685 46.5H27.315L28.518 57.33C28.6019 58.0928 28.975 58.7944 29.5604 59.2905C30.1458 59.7866 30.899 60.0396 31.6652 59.9973C32.4314 59.955 33.1523 59.6208 33.6796 59.0633C34.2069 58.5057 34.5005 57.7674 34.5 57V36.54C34.725 35.346 35.5665 33.6165 36.894 31.992C38.0835 33.4545 38.883 35.001 39.192 36.168C39.1605 38.6445 37.167 47.913 36.348 51.6315C36.3028 51.8311 36.2996 52.0378 36.3385 52.2387C36.3773 52.4396 36.4574 52.6302 36.5738 52.7985C36.6901 52.9669 36.84 53.1092 37.0142 53.2166C37.1883 53.324 37.3829 53.3941 37.5855 53.4225C43.125 54.183 47.9115 54.1815 53.4045 53.4825C54.429 53.352 55.0275 52.2165 54.6555 51.252C53.55 48.3825 51.75 42.423 51.75 34.017V29.628C52.335 30.078 52.95 30.669 53.562 31.4025C55.1475 33.303 56.1315 35.4795 56.2605 36.8325C56.3265 37.4189 56.6203 37.956 57.0785 38.3279C57.5367 38.6997 58.1227 38.8767 58.7101 38.8207C59.2976 38.7646 59.8395 38.48 60.2191 38.0281C60.5987 37.5762 60.7856 36.9933 60.7395 36.405C60.495 33.831 58.9395 30.8235 57.018 28.521C55.152 26.283 52.3395 24 49.185 24H42.243C40.3185 24 38.4915 24.7725 36.9 25.872C35.3145 24.7725 33.492 24 31.572 24H23.151C19.9965 24 17.1855 26.283 15.318 28.521C13.398 30.8235 11.841 33.831 11.5965 36.405C11.5504 36.9933 11.7372 37.5762 12.1168 38.0281C12.4964 38.48 13.0384 38.7646 13.6258 38.8207C14.2133 38.8767 14.7993 38.6997 15.2575 38.3279C15.7157 37.956 16.0095 37.4189 16.0755 36.8325C16.2045 35.4795 17.1885 33.303 18.7755 31.4025"
            fill="#003366"
          />
          <path
            d="M45.75 22.5C47.3413 22.5 48.8674 21.8679 49.9926 20.7426C51.1179 19.6174 51.75 18.0913 51.75 16.5C51.75 14.9087 51.1179 13.3826 49.9926 12.2574C48.8674 11.1321 47.3413 10.5 45.75 10.5C44.1587 10.5 42.6326 11.1321 41.5074 12.2574C40.3821 13.3826 39.75 14.9087 39.75 16.5C39.75 18.0913 40.3821 19.6174 41.5074 20.7426C42.6326 21.8679 44.1587 22.5 45.75 22.5ZM59.25 39C58.2554 39 57.3016 39.3951 56.5984 40.0983C55.8951 40.8016 55.5 41.7554 55.5 42.75V44.2695C55.5 44.6673 55.658 45.0489 55.9393 45.3302C56.2206 45.6115 56.6022 45.7695 57 45.7695C57.3978 45.7695 57.7794 45.6115 58.0607 45.3302C58.342 45.0489 58.5 44.6673 58.5 44.2695V42.75C58.5 42.5511 58.579 42.3603 58.7197 42.2197C58.8603 42.079 59.0511 42 59.25 42C59.4489 42 59.6397 42.079 59.7803 42.2197C59.921 42.3603 60 42.5511 60 42.75V58.5C60 58.8978 60.158 59.2794 60.4393 59.5607C60.7206 59.842 61.1022 60 61.5 60C61.8978 60 62.2794 59.842 62.5607 59.5607C62.842 59.2794 63 58.8978 63 58.5V42.75C63 41.7554 62.6049 40.8016 61.9017 40.0983C61.1984 39.3951 60.2446 39 59.25 39ZM38.25 59.082V55.728C40.0358 55.9586 41.8321 56.0998 43.632 56.151L42.672 59.673C42.5296 60.1998 42.2005 60.6569 41.7461 60.9592C41.2917 61.2614 40.7429 61.3882 40.2019 61.3159C39.661 61.2436 39.1648 60.9771 38.8057 60.5662C38.4466 60.1552 38.2491 59.6277 38.25 59.082ZM48.8295 59.673L47.8485 56.0775C49.6565 55.9627 51.4586 55.7701 53.25 55.5V59.082C53.2496 59.6268 53.0515 60.1529 52.6925 60.5627C52.3336 60.9725 51.8381 61.2381 51.2982 61.3103C50.7582 61.3825 50.2104 61.2564 49.7564 60.9552C49.3024 60.6541 48.973 60.1985 48.8295 59.673Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 6,
      name: "General",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.613 15.936C37.3502 15.936 37.1 15.759 37.1 15.5004V8.94958C37.1 8.69094 36.958 8.48 36.694 8.48H16.3049C16.041 8.48 15.9 8.69094 15.9 8.94958V15.5004C15.9 15.759 15.6149 15.9 15.3499 15.9H1.53594C1.27518 15.9 1.06 16.183 1.06 16.4385V23.7207C1.06 23.9772 1.27518 24.38 1.53594 24.38H23.7811C24.045 24.38 24.38 23.9772 24.38 23.7207V22.1678C24.38 21.9091 24.4775 21.2 24.7404 21.2H28.2607C28.5235 21.2 28.62 21.9091 28.62 22.1678V23.7207C28.62 23.9772 28.955 24.38 29.2168 24.38H51.4609C51.7259 24.38 51.94 23.9772 51.94 23.7207V16.4385C51.94 16.182 51.7259 15.9 51.4619 15.9H37.6491L37.613 15.936ZM19.1786 15.9C18.9157 15.9 19.08 15.759 19.08 15.5014V11.7777C19.08 11.518 18.9157 11.66 19.1786 11.66H33.8214C34.0843 11.66 33.92 11.518 33.92 11.7777V15.5014C33.92 15.759 34.0843 15.9 33.8214 15.9H19.1786ZM28.6783 31.4947C28.6783 31.7512 28.5235 31.8 28.2607 31.8H24.7404C24.4775 31.8 24.38 31.9134 24.38 31.6569V26.4226C24.38 26.1661 24.045 25.44 23.7822 25.44H1.53594C1.27518 25.44 1.06 26.1661 1.06 26.4226V41.9294C1.06167 42.0546 1.11251 42.1741 1.20156 42.2622C1.2906 42.3502 1.41071 42.3997 1.53594 42.4H51.4619C51.5874 42.4003 51.7078 42.3512 51.7973 42.2633C51.8868 42.1754 51.938 42.0558 51.94 41.9304V26.4226C51.94 26.1661 51.7259 25.44 51.4619 25.44H29.2168C28.955 25.44 28.62 26.1661 28.62 26.4226V31.6569L28.6783 31.4947Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 7,
      name: "Information Technology",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_4_21" fill="white">
            <path d="M48.8594 38.1631H47.1255V15.4932C47.1233 13.8453 46.4676 12.2656 45.3023 11.1005C44.137 9.93541 42.5572 9.28002 40.9094 9.27811H12.0906C10.4433 9.28139 8.86451 9.93767 7.70026 11.1031C6.53602 12.2685 5.88133 13.8479 5.87969 15.4953V38.1652H4.14062C3.95696 38.1652 3.78081 38.2381 3.65094 38.368C3.52107 38.4979 3.4481 38.674 3.4481 38.8577V40.3618C3.44947 41.2532 3.80429 42.1078 4.43475 42.7381C5.0652 43.3683 5.91986 43.7229 6.81133 43.724H46.1876C47.0791 43.7229 47.9338 43.3683 48.5642 42.7381C49.1947 42.1078 49.5495 41.2532 49.5509 40.3618V38.8556C49.5509 38.6721 49.478 38.4961 49.3484 38.3663C49.2187 38.2365 49.0429 38.1634 48.8594 38.1631ZM7.25955 15.4932C7.26147 14.2125 7.77107 12.9848 8.67666 12.0792C9.58224 11.1736 10.8099 10.664 12.0906 10.6621H40.9094C42.1906 10.6638 43.4189 11.1735 44.3247 12.0796C45.2306 12.9856 45.7401 14.214 45.7415 15.4953V38.1652H7.25851L7.25955 15.4932ZM48.1658 40.3597C48.1653 40.8842 47.9567 41.387 47.5858 41.7579C47.215 42.1287 46.7121 42.3373 46.1876 42.3379H6.81236C6.28788 42.3373 5.78504 42.1287 5.41418 41.7579C5.04332 41.387 4.83473 40.8842 4.83418 40.3597V39.5481H48.1658V40.3597Z" />
          </mask>
          <path
            d="M48.8594 38.1631H47.1255V15.4932C47.1233 13.8453 46.4676 12.2656 45.3023 11.1005C44.137 9.93541 42.5572 9.28002 40.9094 9.27811H12.0906C10.4433 9.28139 8.86451 9.93767 7.70026 11.1031C6.53602 12.2685 5.88133 13.8479 5.87969 15.4953V38.1652H4.14062C3.95696 38.1652 3.78081 38.2381 3.65094 38.368C3.52107 38.4979 3.4481 38.674 3.4481 38.8577V40.3618C3.44947 41.2532 3.80429 42.1078 4.43475 42.7381C5.0652 43.3683 5.91986 43.7229 6.81133 43.724H46.1876C47.0791 43.7229 47.9338 43.3683 48.5642 42.7381C49.1947 42.1078 49.5495 41.2532 49.5509 40.3618V38.8556C49.5509 38.6721 49.478 38.4961 49.3484 38.3663C49.2187 38.2365 49.0429 38.1634 48.8594 38.1631ZM7.25955 15.4932C7.26147 14.2125 7.77107 12.9848 8.67666 12.0792C9.58224 11.1736 10.8099 10.664 12.0906 10.6621H40.9094C42.1906 10.6638 43.4189 11.1735 44.3247 12.0796C45.2306 12.9856 45.7401 14.214 45.7415 15.4953V38.1652H7.25851L7.25955 15.4932ZM48.1658 40.3597C48.1653 40.8842 47.9567 41.387 47.5858 41.7579C47.215 42.1287 46.7121 42.3373 46.1876 42.3379H6.81236C6.28788 42.3373 5.78504 42.1287 5.41418 41.7579C5.04332 41.387 4.83473 40.8842 4.83418 40.3597V39.5481H48.1658V40.3597Z"
            fill="#003366"
          />
          <path
            d="M48.8594 38.1631L48.8653 34.1631H48.8594V38.1631ZM47.1255 38.1631H43.1255V42.1631H47.1255V38.1631ZM47.1255 15.4932H51.1255L51.1255 15.4879L47.1255 15.4932ZM40.9094 9.27811L40.914 5.27811H40.9094V9.27811ZM12.0906 9.27811V5.2781L12.0826 5.27811L12.0906 9.27811ZM5.87969 15.4953L1.87969 15.4913V15.4953H5.87969ZM5.87969 38.1652V42.1652H9.87969V38.1652H5.87969ZM3.4481 38.8577H-0.551895H3.4481ZM3.4481 40.3618H-0.5519L-0.55189 40.3679L3.4481 40.3618ZM6.81133 43.724L6.80641 47.724H6.81133V43.724ZM46.1876 43.724V47.724L46.1925 47.724L46.1876 43.724ZM49.5509 40.3618L53.5509 40.3679V40.3618H49.5509ZM49.5509 38.8556L45.5509 38.8556V38.8556H49.5509ZM7.25955 15.4932L3.25955 15.4872L3.25955 15.493L7.25955 15.4932ZM12.0906 10.6621V6.66211L12.0846 6.66212L12.0906 10.6621ZM40.9094 10.6621L40.9145 6.66211H40.9094V10.6621ZM45.7415 15.4953H49.7415L49.7415 15.491L45.7415 15.4953ZM45.7415 38.1652V42.1652H49.7415V38.1652H45.7415ZM7.25851 38.1652L3.25851 38.165L3.25833 42.1652H7.25851V38.1652ZM48.1658 40.3597L52.1658 40.3639V40.3597H48.1658ZM46.1876 42.3379V46.3379L46.1918 46.3379L46.1876 42.3379ZM6.81236 42.3379L6.80818 46.3379H6.81236V42.3379ZM4.83418 40.3597H0.834177L0.834181 40.3639L4.83418 40.3597ZM4.83418 39.5481V35.5481H0.834179V39.5481H4.83418ZM48.1658 39.5481H52.1658V35.5481H48.1658V39.5481ZM48.8594 34.1631H47.1255V42.1631H48.8594V34.1631ZM51.1255 38.1631V15.4932H43.1255V38.1631H51.1255ZM51.1255 15.4879C51.1219 12.7809 50.0448 10.1858 48.1305 8.27185L42.4742 13.9292C42.8905 14.3454 43.1247 14.9098 43.1255 15.4985L51.1255 15.4879ZM48.1305 8.27185C46.2162 6.35788 43.621 5.28126 40.914 5.27811L40.9047 13.2781C41.4934 13.2788 42.0578 13.5129 42.4742 13.9292L48.1305 8.27185ZM40.9094 5.27811H12.0906V13.2781H40.9094V5.27811ZM12.0826 5.27811C9.37654 5.28351 6.78297 6.3616 4.87042 8.27606L10.5301 13.9301C10.946 13.5137 11.5101 13.2793 12.0986 13.2781L12.0826 5.27811ZM4.87042 8.27606C2.95788 10.1905 1.88238 12.7852 1.87969 15.4913L9.87968 15.4992C9.88027 14.9107 10.1142 14.3464 10.5301 13.9301L4.87042 8.27606ZM1.87969 15.4953V38.1652H9.87969V15.4953H1.87969ZM5.87969 34.1652H4.14062V42.1652H5.87969V34.1652ZM4.14062 34.1652C2.89611 34.1652 1.70254 34.6595 0.822512 35.5396L6.47937 41.1964C5.85908 41.8167 5.0178 42.1652 4.14062 42.1652V34.1652ZM0.822512 35.5396C-0.0575156 36.4196 -0.551895 37.6132 -0.551895 38.8577H7.4481C7.4481 39.7349 7.09965 40.5762 6.47937 41.1964L0.822512 35.5396ZM-0.551895 38.8577V40.3618H7.4481V38.8577H-0.551895ZM-0.55189 40.3679C-0.548894 42.3183 0.227388 44.188 1.60675 45.5669L7.26274 39.9092C7.38118 40.0276 7.44784 40.1881 7.4481 40.3556L-0.55189 40.3679ZM1.60675 45.5669C2.98612 46.9459 4.85599 47.7216 6.80641 47.724L6.81624 39.724C6.98373 39.7242 7.14429 39.7908 7.26274 39.9092L1.60675 45.5669ZM6.81133 47.724H46.1876V39.724H6.81133V47.724ZM46.1925 47.724C48.143 47.7216 50.0128 46.9459 51.3922 45.5669L45.7362 39.9092C45.8547 39.7908 46.0152 39.7242 46.1827 39.724L46.1925 47.724ZM51.3922 45.5669C52.7716 44.188 53.5479 42.3183 53.5508 40.3679L45.5509 40.3556C45.5511 40.1882 45.6178 40.0276 45.7362 39.9092L51.3922 45.5669ZM53.5509 40.3618V38.8556H45.5509V40.3618H53.5509ZM53.5509 38.8556C53.5509 37.6123 53.0574 36.4198 52.1789 35.54L46.5178 41.1926C45.8986 40.5725 45.5509 39.7319 45.5509 38.8556L53.5509 38.8556ZM52.1789 35.54C51.3004 34.6602 50.1087 34.165 48.8653 34.1631L48.8534 42.1631C47.9771 42.1618 47.1371 41.8128 46.5178 41.1926L52.1789 35.54ZM11.2595 15.4992C11.2599 15.2773 11.3482 15.0646 11.5051 14.9076L5.84823 9.25079C4.19396 10.9051 3.26306 13.1477 3.25955 15.4872L11.2595 15.4992ZM11.5051 14.9076C11.662 14.7507 11.8747 14.6624 12.0966 14.6621L12.0846 6.66212C9.74516 6.66562 7.5025 7.59652 5.84823 9.25079L11.5051 14.9076ZM12.0906 14.6621H40.9094V6.66211H12.0906V14.6621ZM40.9042 14.6621C41.1262 14.6624 41.3391 14.7507 41.496 14.9077L47.1535 9.25146C45.4987 7.59632 43.255 6.66512 40.9145 6.66211L40.9042 14.6621ZM41.496 14.9077C41.653 15.0647 41.7412 15.2775 41.7415 15.4995L49.7415 15.491C49.739 13.1505 48.8082 10.9066 47.1535 9.25146L41.496 14.9077ZM41.7415 15.4953V38.1652H49.7415V15.4953H41.7415ZM45.7415 34.1652H7.25851V42.1652H45.7415V34.1652ZM11.2585 38.1654L11.2595 15.4934L3.25955 15.493L3.25851 38.165L11.2585 38.1654ZM44.1658 40.3555C44.1664 39.8206 44.3791 39.3077 44.7574 38.9295L50.4142 44.5863C51.5342 43.4663 52.1642 41.9478 52.1658 40.3639L44.1658 40.3555ZM44.7574 38.9295C45.1357 38.5512 45.6485 38.3384 46.1835 38.3379L46.1918 46.3379C47.7757 46.3362 49.2943 45.7063 50.4142 44.5863L44.7574 38.9295ZM46.1876 38.3379H6.81236V46.3379H46.1876V38.3379ZM6.81654 38.3379C7.35148 38.3384 7.86435 38.5512 8.24261 38.9295L2.58575 44.5863C3.70574 45.7063 5.22429 46.3362 6.80818 46.3379L6.81654 38.3379ZM8.24261 38.9295C8.62087 39.3077 8.83362 39.8206 8.83418 40.3555L0.834181 40.3639C0.835836 41.9478 1.46577 43.4663 2.58575 44.5863L8.24261 38.9295ZM8.83418 40.3597V39.5481H0.834179V40.3597H8.83418ZM4.83418 43.5481H48.1658V35.5481H4.83418V43.5481ZM44.1658 39.5481V40.3597H52.1658V39.5481H44.1658Z"
            fill="#003366"
            mask="url(#path-1-inside-1_4_21)"
          />
          <path
            d="M41.8068 15.5408H35.7253C35.6341 15.5414 35.5439 15.5599 35.4598 15.5955C35.3758 15.631 35.2996 15.6828 35.2357 15.7478L32.8351 18.1442C32.6209 16.5333 31.8023 15.0641 30.5452 14.0342C29.288 13.0044 27.6864 12.4909 26.0648 12.5979C24.4432 12.7049 22.923 13.4244 21.8121 14.6105C20.7012 15.7966 20.0827 17.3607 20.082 18.9858V22.8335L17.0552 25.8582H11.2584C11.1652 25.8546 11.0723 25.8698 10.9852 25.903C10.8981 25.9361 10.8186 25.9865 10.7515 26.0511C10.6843 26.1158 10.6309 26.1933 10.5944 26.279C10.5579 26.3648 10.5391 26.457 10.5391 26.5502C10.5391 26.6434 10.5579 26.7356 10.5944 26.8214C10.6309 26.9071 10.6843 26.9847 10.7515 27.0493C10.8186 27.1139 10.8981 27.1643 10.9852 27.1974C11.0723 27.2306 11.1652 27.2458 11.2584 27.2422H17.3399C17.4312 27.2419 17.5214 27.2234 17.6055 27.1879C17.6896 27.1523 17.7657 27.1004 17.8295 27.0352L20.1907 24.675C20.4683 26.2337 21.3149 27.6337 22.5664 28.6034H22.4173C20.8997 28.6054 19.4448 29.2091 18.3717 30.2822C17.2986 31.3553 16.6948 32.8102 16.6929 34.3279V36.1704C16.6929 36.3541 16.7659 36.5302 16.8958 36.6601C17.0256 36.79 17.2018 36.8629 17.3854 36.8629C17.5691 36.8629 17.7453 36.79 17.8751 36.6601C18.005 36.5302 18.078 36.3541 18.078 36.1704V34.3279C18.0801 33.1777 18.538 32.0752 19.3514 31.2619C20.1647 30.4486 21.2671 29.9907 22.4173 29.9885H30.5847C31.7349 29.9907 32.8374 30.4486 33.6507 31.2619C34.464 32.0752 34.9219 33.1777 34.9241 34.3279V36.1704C34.9241 36.3541 34.9971 36.5302 35.1269 36.6601C35.2568 36.79 35.4329 36.8629 35.6166 36.8629C35.8003 36.8629 35.9764 36.79 36.1063 36.6601C36.2362 36.5302 36.3091 36.3541 36.3091 36.1704V34.3279C36.3072 32.8102 35.7035 31.3553 34.6304 30.2822C33.5573 29.2091 32.1023 28.6054 30.5847 28.6034H30.4336C31.2039 28.0089 31.8282 27.2462 32.2588 26.3736C32.6894 25.501 32.9148 24.5415 32.918 23.5684V20.0168L36.0079 16.9258H41.8048C41.8957 16.9258 41.9858 16.9079 42.0698 16.8731C42.1538 16.8383 42.2302 16.7873 42.2945 16.723C42.3588 16.6587 42.4098 16.5824 42.4446 16.4983C42.4794 16.4143 42.4973 16.3243 42.4973 16.2333C42.4973 16.1424 42.4794 16.0523 42.4446 15.9683C42.4098 15.8843 42.3588 15.8079 42.2945 15.7436C42.2302 15.6793 42.1538 15.6283 42.0698 15.5935C41.9858 15.5587 41.8957 15.5408 41.8048 15.5408H41.8068ZM31.536 23.5684C31.536 24.9041 31.0054 26.185 30.061 27.1295C29.1166 28.0739 27.8356 28.6045 26.5 28.6045C25.1644 28.6045 23.8834 28.0739 22.939 27.1295C21.9945 26.185 21.464 24.9041 21.464 23.5684V18.9858C21.464 17.6502 21.9945 16.3692 22.939 15.4248C23.8834 14.4803 25.1644 13.9498 26.5 13.9498C27.8356 13.9498 29.1166 14.4803 30.061 15.4248C31.0054 16.3692 31.536 17.6502 31.536 18.9858V23.5684Z"
            fill="#003366"
          />
          <path
            d="M41.8069 18.1152H37.1093C37.0162 18.1116 36.9233 18.1269 36.8362 18.16C36.7491 18.1932 36.6696 18.2436 36.6024 18.3082C36.5353 18.3728 36.4818 18.4503 36.4453 18.536C36.4088 18.6218 36.39 18.714 36.39 18.8072C36.39 18.9004 36.4088 18.9927 36.4453 19.0784C36.4818 19.1642 36.5353 19.2417 36.6024 19.3063C36.6696 19.3709 36.7491 19.4213 36.8362 19.4545C36.9233 19.4876 37.0162 19.5028 37.1093 19.4992H41.8069C41.9 19.5028 41.9929 19.4876 42.08 19.4545C42.1671 19.4213 42.2466 19.3709 42.3138 19.3063C42.3809 19.2417 42.4343 19.1642 42.4708 19.0784C42.5073 18.9927 42.5261 18.9004 42.5261 18.8072C42.5261 18.714 42.5073 18.6218 42.4708 18.536C42.4343 18.4503 42.3809 18.3728 42.3138 18.3082C42.2466 18.2436 42.1671 18.1932 42.08 18.16C41.9929 18.1269 41.9 18.1116 41.8069 18.1152Z"
            fill="#003366"
          />
          <path
            d="M11.2594 24.6678H15.9569C16.0501 24.6714 16.143 24.6561 16.2301 24.623C16.3172 24.5898 16.3967 24.5394 16.4638 24.4748C16.531 24.4102 16.5844 24.3327 16.6209 24.247C16.6574 24.1612 16.6762 24.069 16.6762 23.9758C16.6762 23.8826 16.6574 23.7903 16.6209 23.7046C16.5844 23.6188 16.531 23.5413 16.4638 23.4767C16.3967 23.4121 16.3172 23.3617 16.2301 23.3285C16.143 23.2954 16.0501 23.2802 15.9569 23.2838H11.2594C11.1663 23.2802 11.0734 23.2954 10.9863 23.3285C10.8992 23.3617 10.8197 23.4121 10.7525 23.4767C10.6853 23.5413 10.6319 23.6188 10.5954 23.7046C10.5589 23.7903 10.5401 23.8826 10.5401 23.9758C10.5401 24.069 10.5589 24.1612 10.5954 24.247C10.6319 24.3327 10.6853 24.4102 10.7525 24.4748C10.8197 24.5394 10.8992 24.5898 10.9863 24.623C11.0734 24.6561 11.1663 24.6714 11.2594 24.6678Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 8,
      name: "Finance",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6966 48.5833 48.5834 38.6966 48.5834 26.5C48.5834 14.3034 38.6966 4.41666 26.5 4.41666C14.3034 4.41666 4.41669 14.3034 4.41669 26.5C4.41669 38.6966 14.3034 48.5833 26.5 48.5833Z"
            stroke="#003366"
            strokeWidth="3"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 24.2917H33.125M19.875 30.9167H33.125M26.5088 24.2917V37.5417M33.125 16.5625L26.5 23.1875L19.875 16.5625"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 9,
      name: "Engineering",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.31876 46.375V40.1917C2.31876 38.9771 2.6316 37.8361 3.2573 36.7687C3.88299 35.7014 4.74792 34.8917 5.85209 34.3396C7.72917 33.3826 9.84549 32.5729 12.201 31.9104C14.5566 31.2479 17.1514 30.9167 19.9854 30.9167C22.8195 30.9167 25.4142 31.2479 27.7698 31.9104C30.1254 32.5729 32.2417 33.3826 34.1188 34.3396C35.2229 34.8917 36.0879 35.7014 36.7135 36.7687C37.3392 37.8361 37.6521 38.9771 37.6521 40.1917V46.375H2.31876ZM19.9854 28.7083C17.5563 28.7083 15.4767 27.8434 13.7469 26.1135C12.017 24.3837 11.1521 22.3042 11.1521 19.875H10.6C10.2688 19.875 10.0023 19.7742 9.80059 19.5725C9.5989 19.3708 9.49731 19.1036 9.49584 18.7708C9.49437 18.4381 9.59595 18.1709 9.80059 17.9692C10.0052 17.7675 10.2717 17.6667 10.6 17.6667H11.1521C11.1521 16.0104 11.557 14.5198 12.3667 13.1948C13.1764 11.8698 14.2438 10.8208 15.5688 10.0479V12.1458C15.5688 12.4771 15.6703 12.7443 15.8735 12.9475C16.0767 13.1506 16.3431 13.2515 16.6729 13.25C17.0027 13.2485 17.2699 13.1477 17.4745 12.9475C17.6792 12.7472 17.78 12.48 17.7771 12.1458V9.16458C18.1083 9.05417 18.458 8.97172 18.826 8.91725C19.1941 8.86278 19.5806 8.83481 19.9854 8.83333C20.3903 8.83186 20.7767 8.85983 21.1448 8.91725C21.5129 8.97467 21.8625 9.05711 22.1938 9.16458V12.1458C22.1938 12.4771 22.2953 12.7443 22.4985 12.9475C22.7017 13.1506 22.9681 13.2515 23.2979 13.25C23.6277 13.2485 23.8949 13.1477 24.0995 12.9475C24.3042 12.7472 24.405 12.48 24.4021 12.1458V10.0479C25.7271 10.8208 26.7944 11.8698 27.6042 13.1948C28.4139 14.5198 28.8188 16.0104 28.8188 17.6667H29.3708C29.7021 17.6667 29.9693 17.7682 30.1725 17.9714C30.3756 18.1746 30.4765 18.4411 30.475 18.7708C30.4735 19.1006 30.3727 19.3678 30.1725 19.5725C29.9722 19.7771 29.705 19.8779 29.3708 19.875H28.8188C28.8188 22.3042 27.9538 24.3837 26.224 26.1135C24.4941 27.8434 22.4146 28.7083 19.9854 28.7083ZM19.9854 24.2917C21.2 24.2917 22.2401 23.8596 23.1058 22.9954C23.9715 22.1312 24.4036 21.0911 24.4021 19.875H15.5688C15.5688 21.0896 16.0016 22.1297 16.8673 22.9954C17.7329 23.861 18.7723 24.2931 19.9854 24.2917ZM36.5479 33.125L36.2167 31.4688C35.9958 31.3951 35.7846 31.3127 35.5829 31.2214C35.3812 31.1301 35.1876 30.9917 35.0021 30.8062L33.4563 31.3583L32.3521 29.3708L33.5667 28.2667V26.9417L32.3521 25.8375L33.4563 23.85L35.0021 24.4021C35.1493 24.2549 35.3333 24.126 35.5542 24.0156C35.775 23.9052 35.9958 23.8132 36.2167 23.7396L36.5479 22.0833H38.7563L39.0875 23.7396C39.3083 23.8132 39.5292 23.9052 39.75 24.0156C39.9708 24.126 40.1549 24.2549 40.3021 24.4021L41.8479 23.85L42.9521 25.8375L41.7375 26.9417V28.2667L42.9521 29.3708L41.8479 31.3583L40.3021 30.8062C40.1181 30.9903 39.9252 31.1287 39.7235 31.2214C39.5218 31.3142 39.3098 31.3966 39.0875 31.4688L38.7563 33.125H36.5479ZM37.6521 29.2604C38.0938 29.2604 38.4802 29.0948 38.8115 28.7635C39.1427 28.4323 39.3083 28.0458 39.3083 27.6042C39.3083 27.1625 39.1427 26.776 38.8115 26.4448C38.4802 26.1135 38.0938 25.9479 37.6521 25.9479C37.2104 25.9479 36.824 26.1135 36.4927 26.4448C36.1615 26.776 35.9958 27.1625 35.9958 27.6042C35.9958 28.0458 36.1615 28.4323 36.4927 28.7635C36.824 29.0948 37.2104 29.2604 37.6521 29.2604ZM41.6271 22.0833L41.1854 19.7646C40.8542 19.6542 40.5509 19.5165 40.2756 19.3516C40.0003 19.1867 39.7515 18.9931 39.5292 18.7708L37.2104 19.5438L35.6646 16.8938L37.5417 15.2375C37.4681 15.0535 37.4313 14.9062 37.4313 14.7958V13.9125C37.4313 13.8021 37.4681 13.6549 37.5417 13.4708L35.6646 11.8146L37.2104 9.16458L39.5292 9.9375C39.75 9.71667 39.9988 9.52307 40.2756 9.35671C40.5524 9.19035 40.8556 9.05269 41.1854 8.94375L41.6271 6.625H44.7188L45.1604 8.94375C45.4917 9.05417 45.7957 9.19256 46.0725 9.35892C46.3492 9.52528 46.5973 9.71814 46.8167 9.9375L49.1354 9.16458L50.6813 11.8146L48.8042 13.4708C48.8778 13.6549 48.9146 13.8021 48.9146 13.9125V14.7958C48.9146 14.9062 48.8778 15.0535 48.8042 15.2375L50.6813 16.8938L49.1354 19.5438L46.8167 18.7708C46.5958 18.9917 46.3478 19.1853 46.0725 19.3516C45.7972 19.518 45.4931 19.6556 45.1604 19.7646L44.7188 22.0833H41.6271ZM43.1729 17.1146C43.9458 17.1146 44.5995 16.8474 45.1339 16.313C45.6683 15.7785 45.9348 15.1256 45.9333 14.3542C45.9319 13.5827 45.6647 12.9291 45.1317 12.3932C44.5988 11.8573 43.9458 11.5908 43.1729 11.5938C42.4 11.5967 41.7463 11.8639 41.2119 12.3954C40.6775 12.9268 40.411 13.5798 40.4125 14.3542C40.414 15.1286 40.6812 15.7822 41.2141 16.3152C41.7471 16.8481 42.4 17.1146 43.1729 17.1146Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 10,
      name: "Sales",
      svg: (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M46.875 9.375V6.25H42.1875V3.125H39.0625V6.25H37.5C35.7766 6.25 34.375 7.65312 34.375 9.375V12.5C34.375 14.2234 35.7766 15.625 37.5 15.625H43.75V18.75H34.375V21.875H39.0625V25H42.1875V21.875H43.75C45.4734 21.875 46.875 20.4734 46.875 18.75V15.625C46.875 13.9031 45.4734 12.5 43.75 12.5H37.5V9.375H46.875ZM37.5 31.25V34.375H41.5406L35.9375 39.9781L32.3563 36.3953C32.0637 36.1026 31.667 35.938 31.2531 35.9375H31.25C30.8362 35.938 30.4395 36.1026 30.1469 36.3953L21.875 44.6656L24.0844 46.875L31.2516 39.7094L34.8328 43.2922C35.1258 43.5851 35.5232 43.7497 35.9375 43.7497C36.3518 43.7497 36.7492 43.5851 37.0422 43.2922L43.75 36.5844V40.625H46.875V31.25H37.5ZM6.25 46.875H3.125V39.0625C3.125 33.0312 8.03125 28.125 14.0625 28.125H23.4375C26.5453 28.125 29.5156 29.4531 31.5891 31.7703L29.2609 33.8547C28.5281 33.0353 27.6307 32.3797 26.6272 31.9309C25.6237 31.482 24.5368 31.25 23.4375 31.25H14.0625C9.75469 31.25 6.25 34.7547 6.25 39.0625V46.875ZM18.75 25C21.6508 25 24.4328 23.8477 26.484 21.7965C28.5352 19.7453 29.6875 16.9633 29.6875 14.0625C29.6875 11.1617 28.5352 8.3797 26.484 6.32852C24.4328 4.27734 21.6508 3.125 18.75 3.125C15.8492 3.125 13.0672 4.27734 11.016 6.32852C8.96484 8.3797 7.8125 11.1617 7.8125 14.0625C7.8125 16.9633 8.96484 19.7453 11.016 21.7965C13.0672 23.8477 15.8492 25 18.75 25ZM18.75 6.25C20.822 6.25 22.8091 7.0731 24.2743 8.53823C25.7394 10.0034 26.5625 11.9905 26.5625 14.0625C26.5625 16.1345 25.7394 18.1216 24.2743 19.5868C22.8091 21.0519 20.822 21.875 18.75 21.875C16.678 21.875 14.6909 21.0519 13.2257 19.5868C11.7606 18.1216 10.9375 16.1345 10.9375 14.0625C10.9375 11.9905 11.7606 10.0034 13.2257 8.53823C14.6909 7.0731 16.678 6.25 18.75 6.25Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 11,
      name: "Education",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 6.625L2.20833 19.875L11.0417 24.6892V37.9392L26.5 46.375L41.9583 37.9392V24.6892L46.375 22.2821V37.5417H50.7917V19.875L26.5 6.625ZM41.5608 19.875L26.5 28.09L11.4392 19.875L26.5 11.66L41.5608 19.875ZM37.5417 35.3333L26.5 41.34L15.4583 35.3333V27.0963L26.5 33.125L37.5417 27.0963V35.3333Z"
            fill="#003366"
          />
          <path
            d="M26.5 6.625L2.20833 19.875L11.0417 24.6892V37.9392L26.5 46.375L41.9583 37.9392V24.6892L46.375 22.2821V37.5417H50.7917V19.875L26.5 6.625ZM41.5608 19.875L26.5 28.09L11.4392 19.875L26.5 11.66L41.5608 19.875ZM37.5417 35.3333L26.5 41.34L15.4583 35.3333V27.0963L26.5 33.125L37.5417 27.0963V35.3333Z"
            stroke="black"
          />
        </svg>
      ),
    },
    {
      id: 12,
      name: "Customer Service",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_5_120)">
            <path
              d="M48 41.9999H42.6797C43.4297 42.828 44 43.7499 44.3906 44.7655C44.7812 45.7812 44.9844 46.8593 45 47.9999H42C42 47.1718 41.8438 46.3984 41.5312 45.6796C41.2188 44.9609 40.7891 44.3202 40.2422 43.7577C39.6953 43.1952 39.0625 42.7655 38.3438 42.4687C37.625 42.1718 36.8438 42.0155 36 41.9999C35.1719 41.9999 34.3984 42.1562 33.6797 42.4687C32.9609 42.7812 32.3203 43.2109 31.7578 43.7577C31.1953 44.3046 30.7656 44.9374 30.4688 45.6562C30.1719 46.3749 30.0156 47.1562 30 47.9999H27C27 47.1718 26.8438 46.3984 26.5312 45.6796C26.2188 44.9609 25.7891 44.3202 25.2422 43.7577C24.6953 43.1952 24.0625 42.7655 23.3438 42.4687C22.625 42.1718 21.8438 42.0155 21 41.9999C20.1719 41.9999 19.3984 42.1562 18.6797 42.4687C17.9609 42.7812 17.3203 43.2109 16.7578 43.7577C16.1953 44.3046 15.7656 44.9374 15.4688 45.6562C15.1719 46.3749 15.0156 47.1562 15 47.9999H12C12 47.1874 12.1094 46.3905 12.3281 45.6093C12.5469 44.828 12.8516 44.1015 13.2422 43.4296C13.6328 42.7577 14.125 42.1327 14.7188 41.5546C15.3125 40.9765 15.9609 40.4999 16.6641 40.1249C16.1328 39.578 15.7266 38.9452 15.4453 38.2265C15.1641 37.5077 15.0156 36.7655 15 35.9999C15 34.9218 15.2656 33.9296 15.7969 33.0234C16.3281 32.1171 17.0625 31.3905 18 30.8437V23.9999C18 23.5312 18.1016 23.0859 18.3047 22.664C18.5078 22.2421 18.8047 21.8905 19.1953 21.6093C18.3359 20.4687 17.2812 19.5859 16.0312 18.9609C14.7812 18.3359 13.4375 18.0155 12 17.9999C10.75 17.9999 9.58594 18.2343 8.50781 18.703C7.42969 19.1718 6.47656 19.8124 5.64844 20.6249C4.82031 21.4374 4.17188 22.3984 3.70312 23.5077C3.23438 24.6171 3 25.7812 3 26.9999H0C0 25.8593 0.15625 24.7577 0.46875 23.6952C0.78125 22.6327 1.22656 21.6249 1.80469 20.6718C2.38281 19.7187 3.09375 18.8749 3.9375 18.1405C4.78125 17.4062 5.70312 16.7734 6.70312 16.2421C5.53125 15.3984 4.625 14.3437 3.98438 13.078C3.34375 11.8124 3.01562 10.453 3 8.99992C3 7.76555 3.23438 6.60149 3.70312 5.50774C4.17188 4.41399 4.8125 3.46086 5.625 2.64836C6.4375 1.83586 7.39062 1.18742 8.48438 0.703049C9.57812 0.218674 10.75 -0.0157013 12 -7.62939e-05C13.2344 -7.62939e-05 14.3984 0.234299 15.4922 0.703049C16.5859 1.1718 17.5391 1.81242 18.3516 2.62492C19.1641 3.43742 19.8125 4.39836 20.2969 5.50774C20.7812 6.61711 21.0156 7.78117 21 8.99992C21 10.453 20.6797 11.8124 20.0391 13.078C19.3984 14.3437 18.4844 15.4062 17.2969 16.2655C18.3594 16.7968 19.3203 17.4609 20.1797 18.2577C21.0391 19.0546 21.7734 19.9687 22.3828 20.9999H30.75C31.2344 20.9999 31.6562 20.9296 32.0156 20.789C32.375 20.6484 32.7109 20.4609 33.0234 20.2265C33.3359 19.9921 33.6562 19.7499 33.9844 19.4999C34.3125 19.2499 34.6719 19.0077 35.0625 18.7734C35.4531 18.539 35.9062 18.3593 36.4219 18.2343C36.9375 18.1093 37.5469 18.0312 38.25 17.9999H45C45.4219 17.9999 45.8125 18.078 46.1719 18.2343C46.5312 18.3905 46.8438 18.6015 47.1094 18.8671C47.375 19.1327 47.5938 19.453 47.7656 19.828C47.9375 20.203 48.0156 20.5937 48 20.9999V41.9999ZM12 14.9999C12.8281 14.9999 13.6016 14.8437 14.3203 14.5312C15.0391 14.2187 15.6797 13.789 16.2422 13.2421C16.8047 12.6952 17.2344 12.0624 17.5312 11.3437C17.8281 10.6249 17.9844 9.84367 18 8.99992C18 8.1718 17.8438 7.39836 17.5312 6.67961C17.2188 5.96086 16.7891 5.32024 16.2422 4.75774C15.6953 4.19524 15.0625 3.76555 14.3438 3.46867C13.625 3.1718 12.8438 3.01555 12 2.99992C11.1719 2.99992 10.3984 3.15617 9.67969 3.46867C8.96094 3.78117 8.32031 4.21086 7.75781 4.75774C7.19531 5.30461 6.76562 5.93742 6.46875 6.65617C6.17188 7.37492 6.01562 8.15617 6 8.99992C6 9.82805 6.15625 10.6015 6.46875 11.3202C6.78125 12.039 7.21094 12.6796 7.75781 13.2421C8.30469 13.8046 8.9375 14.2343 9.65625 14.5312C10.375 14.828 11.1562 14.9843 12 14.9999ZM21 38.9999C21.4219 38.9999 21.8125 38.9218 22.1719 38.7655C22.5312 38.6093 22.8438 38.3984 23.1094 38.1327C23.375 37.8671 23.5938 37.5468 23.7656 37.1718C23.9375 36.7968 24.0156 36.4062 24 35.9999C24 35.578 23.9219 35.1874 23.7656 34.828C23.6094 34.4687 23.3984 34.1562 23.1328 33.8905C22.8672 33.6249 22.5469 33.4062 22.1719 33.2343C21.7969 33.0624 21.4062 32.9843 21 32.9999C20.5781 32.9999 20.1875 33.078 19.8281 33.2343C19.4688 33.3905 19.1562 33.6015 18.8906 33.8671C18.625 34.1327 18.4062 34.453 18.2344 34.828C18.0625 35.203 17.9844 35.5937 18 35.9999C18 36.4218 18.0781 36.8124 18.2344 37.1718C18.3906 37.5312 18.6016 37.8437 18.8672 38.1093C19.1328 38.3749 19.4531 38.5937 19.8281 38.7655C20.2031 38.9374 20.5938 39.0155 21 38.9999ZM36 38.9999C36.4219 38.9999 36.8125 38.9218 37.1719 38.7655C37.5312 38.6093 37.8438 38.3984 38.1094 38.1327C38.375 37.8671 38.5938 37.5468 38.7656 37.1718C38.9375 36.7968 39.0156 36.4062 39 35.9999C39 35.578 38.9219 35.1874 38.7656 34.828C38.6094 34.4687 38.3984 34.1562 38.1328 33.8905C37.8672 33.6249 37.5469 33.4062 37.1719 33.2343C36.7969 33.0624 36.4062 32.9843 36 32.9999C35.5781 32.9999 35.1875 33.078 34.8281 33.2343C34.4688 33.3905 34.1562 33.6015 33.8906 33.8671C33.625 34.1327 33.4062 34.453 33.2344 34.828C33.0625 35.203 32.9844 35.5937 33 35.9999C33 36.4218 33.0781 36.8124 33.2344 37.1718C33.3906 37.5312 33.6016 37.8437 33.8672 38.1093C34.1328 38.3749 34.4531 38.5937 34.8281 38.7655C35.2031 38.9374 35.5938 39.0155 36 38.9999ZM45 26.9999H38.25C37.5469 26.9999 36.9375 26.9296 36.4219 26.789C35.9062 26.6484 35.4531 26.4609 35.0625 26.2265C34.6719 25.9921 34.3203 25.7499 34.0078 25.4999C33.6953 25.2499 33.375 25.0077 33.0469 24.7734C32.7188 24.539 32.375 24.3593 32.0156 24.2343C31.6562 24.1093 31.2344 24.0312 30.75 23.9999H21V29.9999C21.8281 29.9999 22.6016 30.1562 23.3203 30.4687C24.0391 30.7812 24.6797 31.2109 25.2422 31.7577C25.8047 32.3046 26.2344 32.9374 26.5312 33.6562C26.8281 34.3749 26.9844 35.1562 27 35.9999C27 36.7655 26.8594 37.5077 26.5781 38.2265C26.2969 38.9452 25.8828 39.578 25.3359 40.1249C26.6328 40.8437 27.6875 41.8124 28.5 43.0312C29.3125 41.8124 30.3672 40.8437 31.6641 40.1249C31.1328 39.578 30.7266 38.9452 30.4453 38.2265C30.1641 37.5077 30.0156 36.7655 30 35.9999C30 35.1718 30.1562 34.3984 30.4688 33.6796C30.7812 32.9609 31.2109 32.3202 31.7578 31.7577C32.3047 31.1952 32.9375 30.7655 33.6562 30.4687C34.375 30.1718 35.1562 30.0155 36 29.9999C36.8281 29.9999 37.6016 30.1562 38.3203 30.4687C39.0391 30.7812 39.6797 31.2109 40.2422 31.7577C40.8047 32.3046 41.2344 32.9374 41.5312 33.6562C41.8281 34.3749 41.9844 35.1562 42 35.9999C42 36.5312 41.9297 37.0468 41.7891 37.5468C41.6484 38.0468 41.4375 38.5312 41.1562 38.9999H45V26.9999ZM45 20.9999H38.25C37.8906 20.9999 37.5703 21.039 37.2891 21.1171C37.0078 21.1952 36.7422 21.2968 36.4922 21.4218C36.2422 21.5468 36 21.703 35.7656 21.8905C35.5312 22.078 35.2812 22.2812 35.0156 22.4999C35.2656 22.7187 35.5078 22.914 35.7422 23.0859C35.9766 23.2577 36.2266 23.414 36.4922 23.5546C36.7578 23.6952 37.0234 23.8046 37.2891 23.8827C37.5547 23.9609 37.875 23.9999 38.25 23.9999H45V20.9999Z"
              fill="#003366"
            />
          </g>
          <defs>
            <clipPath id="clip0_5_120">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      id: 13,
      name: "Design",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.845 3.09376C10.0737 3.29307 10.2301 3.56242 10.2898 3.85987C10.3495 4.15731 10.3091 4.46614 10.175 4.73826C10.1506 4.81847 10.1385 4.90192 10.1392 4.98576C10.1392 5.15901 10.1832 5.48901 10.5985 5.90151C10.7992 6.10226 10.9532 6.24526 11.121 6.40201C11.2585 6.52851 11.4042 6.66051 11.5885 6.84201C11.946 7.18301 12.3227 7.58451 12.661 8.08776C13.3622 9.14101 13.75 10.4583 13.75 12.375C13.75 13.4255 13.5767 14.41 13.2605 15.2818C12.364 17.7568 10.3482 19.25 8.25 19.25C6.15175 19.25 4.136 17.754 3.2395 15.2818C2.90879 14.3486 2.74315 13.365 2.75 12.375C2.75 11.4785 2.98925 10.4088 3.31925 9.42151C3.64925 8.43426 4.11125 7.40851 4.64475 6.58351C5.28 5.51101 6.17375 4.61176 6.86675 4.00676C7.24808 3.6743 7.6445 3.35955 8.05475 3.06351L8.13725 3.00851L8.162 2.98926L8.17025 2.98376L8.17575 2.98101C8.42791 2.81292 8.72854 2.73285 9.03091 2.75324C9.33327 2.77363 9.62043 2.89334 9.84775 3.09376M8.25 22C9.99671 22.0044 11.6891 21.3929 13.0295 20.273C13.0845 20.4453 13.1367 20.6195 13.1862 20.7955C13.75 22.8635 13.75 25.421 13.75 27.3983V27.5C13.75 33.1595 12.6912 36.52 11.4922 38.5193C11.038 39.3055 10.4433 40.0018 9.73775 40.5735C9.4571 40.7907 9.15264 40.9752 8.83025 41.1235C8.83025 41.1235 8.481 41.25 8.25 41.25C8.05175 41.2343 7.85656 41.1917 7.66975 41.1235C7.34735 40.9752 7.04289 40.7907 6.76225 40.5735C6.05672 40.0018 5.46204 39.3055 5.00775 38.5193C3.80875 36.5228 2.75 33.1595 2.75 27.5V27.401C2.75 25.421 2.75 22.8663 3.31375 20.7928C3.36141 20.6204 3.41366 20.4463 3.4705 20.2703C4.80978 21.3932 6.50226 22.0076 8.25 22.0055M19.2445 30.1813C18.2913 30.0749 17.3536 29.858 16.4505 29.535C16.4835 28.842 16.5 28.127 16.5 27.39V26.576C17.3525 26.9803 18.2765 27.2635 19.2445 27.401V22C19.2445 20.5413 19.824 19.1424 20.8554 18.1109C21.8869 17.0795 23.2858 16.5 24.7445 16.5H30.1482C29.9295 14.9795 29.35 13.5335 28.4582 12.2827C27.5664 11.0319 26.3881 10.0128 25.022 9.31045C23.6558 8.60811 22.1413 8.24297 20.6052 8.24555C19.069 8.24813 17.5558 8.61834 16.192 9.32526C15.976 8.42622 15.6196 7.56685 15.136 6.77876C16.9183 5.89789 18.8867 5.45943 20.8744 5.50048C22.8621 5.54153 24.8107 6.06089 26.5551 7.0146C28.2996 7.96831 29.7886 9.32828 30.8961 10.9794C32.0036 12.6305 32.6969 14.5241 32.9175 16.5H35.7417C37.2004 16.5 38.5994 17.0795 39.6308 18.1109C40.6623 19.1424 41.2417 20.5413 41.2417 22V33C41.2417 34.4587 40.6623 35.8576 39.6308 36.8891C38.5994 37.9205 37.2004 38.5 35.7417 38.5H24.7417C23.2831 38.5 21.8841 37.9205 20.8527 36.8891C19.8212 35.8576 19.2417 34.4587 19.2417 33L19.2445 30.1813ZM32.9202 19.25C32.6087 22.0405 31.3575 24.6421 29.3721 26.6276C27.3866 28.613 24.785 29.8643 21.9945 30.1758V33C21.9945 33.7294 22.2842 34.4288 22.8 34.9446C23.3157 35.4603 24.0152 35.75 24.7445 35.75H35.7445C36.4738 35.75 37.1733 35.4603 37.689 34.9446C38.2048 34.4288 38.4945 33.7294 38.4945 33V22C38.4945 21.2707 38.2048 20.5712 37.689 20.0555C37.1733 19.5397 36.4738 19.25 35.7445 19.25H32.9202ZM30.1482 19.25H24.7445C24.0152 19.25 23.3157 19.5397 22.8 20.0555C22.2842 20.5712 21.9945 21.2707 21.9945 22V27.4038C24.0518 27.1073 25.9578 26.1528 27.4276 24.6831C28.8973 23.2133 29.8518 21.3073 30.1482 19.25Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 14,
      name: "Business Dev",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.5 46.5H34.458C34.1573 46.4916 33.8661 46.393 33.6221 46.217C33.3782 46.041 33.1928 45.7957 33.09 45.513L28.386 32.5755L25.3785 39.591C25.2629 39.8608 25.0706 40.0907 24.8256 40.2522C24.5806 40.4138 24.2935 40.5 24 40.5H18V37.5H23.01L27.12 27.909C27.3645 27.3435 27.9435 26.985 28.542 27C28.8427 27.0084 29.1339 27.107 29.3779 27.283C29.6218 27.459 29.8072 27.7043 29.91 27.987L34.614 40.926L37.6215 33.909C37.7371 33.6392 37.9294 33.4093 38.1744 33.2477C38.4194 33.0862 38.7065 33 39 33H45V36H39.99L35.88 45.591C35.7643 45.861 35.5718 46.0911 35.3265 46.2527C35.0811 46.4143 34.7938 46.5003 34.5 46.5Z"
            fill="#003366"
          />
          <path
            d="M13.5 37.5H6V15H42V28.5H45V15C45 13.3455 43.6545 12 42 12H33V6C33 4.3455 31.6545 3 30 3H18C16.3455 3 15 4.3455 15 6V12H6C4.3455 12 3 13.3455 3 15V37.5C3 39.1545 4.3455 40.5 6 40.5H13.5V37.5ZM18 6H30V12H18V6Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 15,
      name: "Legal",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 6C21.46 6 19.2 7.6 18.36 10H5.99999V14H9.89999L3.99999 28C3.05999 32 5.99999 34 11 34C16 34 19.12 32 18 28L12.1 14H18.34C19 15.7 20.3 17 22 17.66V40H3.99999V44H44V40H26V17.64C27.7 17 29 15.7 29.64 14H35.9L30 28C29.06 32 32 34 37 34C42 34 45.12 32 44 28L38.1 14H42V10H29.66C28.8 7.6 26.54 6 24 6ZM24 10C24.5304 10 25.0391 10.2107 25.4142 10.5858C25.7893 10.9609 26 11.4696 26 12C26 12.5304 25.7893 13.0391 25.4142 13.4142C25.0391 13.7893 24.5304 14 24 14C23.4696 14 22.9608 13.7893 22.5858 13.4142C22.2107 13.0391 22 12.5304 22 12C22 11.4696 22.2107 10.9609 22.5858 10.5858C22.9608 10.2107 23.4696 10 24 10ZM11 20.5L14 28H7.99999L11 20.5ZM37 20.5L40 28H34L37 20.5Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 16, // Assign a unique ID
      name: "Manufacturing",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.95 42V36H14.15L9.05 19.3C8.15 18.8 7.41 18.067 6.826 17.1C6.243 16.133 5.951 15.1 5.95 14C5.95 12.333 6.533 10.917 7.7 9.75C8.867 8.583 10.283 8 11.95 8C13.25 8 14.409 8.375 15.426 9.126C16.443 9.877 17.151 10.835 17.55 12H23.95V10C23.95 9.433 24.142 8.959 24.526 8.576C24.91 8.193 25.385 8.001 25.95 8C26.25 8 26.542 8.067 26.826 8.2C27.11 8.333 27.351 8.533 27.55 8.8L30.95 5.6C31.25 5.3 31.609 5.108 32.026 5.024C32.443 4.94 32.851 4.999 33.25 5.2L41.05 8.8C41.45 9 41.725 9.292 41.876 9.676C42.027 10.06 42.018 10.435 41.85 10.8C41.65 11.2 41.359 11.459 40.976 11.576C40.593 11.693 40.218 11.668 39.85 11.5L32.65 8.2L27.95 12.6V15.4L32.65 19.7L39.85 16.4C40.217 16.233 40.6 16.217 41 16.35C41.4 16.483 41.683 16.733 41.85 17.1C42.05 17.5 42.067 17.883 41.9 18.25C41.733 18.617 41.45 18.9 41.05 19.1L33.25 22.8C32.85 23 32.442 23.058 32.026 22.974C31.61 22.89 31.251 22.699 30.95 22.4L27.55 19.2C27.35 19.4 27.109 19.583 26.826 19.75C26.543 19.917 26.251 20 25.95 20C25.383 20 24.909 19.809 24.526 19.426C24.143 19.043 23.951 18.568 23.95 18V16H17.55C17.45 16.267 17.342 16.517 17.226 16.75C17.11 16.983 16.951 17.233 16.75 17.5L26.75 36H33.95V42H7.95ZM11.95 16C12.517 16 12.992 15.808 13.376 15.424C13.76 15.04 13.951 14.565 13.95 14C13.949 13.435 13.757 12.96 13.376 12.576C12.995 12.192 12.519 12 11.95 12C11.381 12 10.906 12.192 10.526 12.576C10.146 12.96 9.954 13.435 9.95 14C9.946 14.565 10.138 15.041 10.526 15.426C10.914 15.811 11.389 16.003 11.95 16Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 17,
      name: "R&D",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M45.525 37.95L35.7 28.125C34.275 26.7 31.95 26.625 30.375 27.9L26.55 24.075C30.9 18.525 30.525 10.5 25.425 5.40001C19.95 -0.0749876 10.95 -0.0749876 5.47502 5.40001C2.45571e-05 10.875 2.45571e-05 19.875 5.47502 25.35C8.25002 28.125 11.85 29.475 15.45 29.475C18.525 29.475 21.6 28.5 24.15 26.475L27.975 30.3C26.625 31.875 26.7 34.2 28.2 35.625L38.025 45.45C38.775 46.2 39.825 46.575 40.8 46.575C41.775 46.575 42.825 46.2 43.575 45.45L45.525 43.5C47.025 42 47.025 39.525 45.525 37.95ZM7.80002 23.025C3.60002 18.825 3.60002 12 7.80002 7.80001C9.90002 5.70001 12.675 4.65001 15.375 4.65001C18.075 4.65001 20.85 5.70001 22.95 7.80001C27.15 12 27.15 18.825 22.95 23.025C18.825 27.225 12 27.225 7.80002 23.025ZM43.125 41.175L41.175 43.125C40.95 43.35 40.575 43.35 40.35 43.125L30.525 33.3C30.3 33.075 30.3 32.7 30.525 32.475L32.475 30.525C32.55 30.45 32.7 30.375 32.85 30.375C33 30.375 33.15 30.45 33.225 30.525L43.05 40.35C43.35 40.575 43.35 40.95 43.125 41.175Z"
            fill="#003366"
          />
          <path
            d="M11.7 14.4H15.375C16.275 14.4 17.1 13.65 17.1 12.675C17.1 11.7 16.35 10.95 15.375 10.95H11.7C10.8 10.95 9.97498 11.7 9.97498 12.675C9.97498 13.65 10.725 14.4 11.7 14.4ZM19.35 16.575H11.7C10.8 16.575 9.97498 17.325 9.97498 18.3C9.97498 19.275 10.725 20.025 11.7 20.025H19.35C20.25 20.025 21.075 19.275 21.075 18.3C21.075 17.325 20.25 16.575 19.35 16.575Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 18,
      name: "Consulting",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.825 17.7C18.825 20.7 21.225 23.1 24.225 23.1C27.225 23.1 29.625 20.7 29.625 17.7C29.625 14.7 27.225 12.3 24.225 12.3C21.3 12.225 18.825 14.7 18.825 17.7ZM26.7 17.7C26.7 19.05 25.575 20.1 24.3 20.1C23.025 20.1 21.9 18.975 21.9 17.7C21.9 16.425 23.025 15.3 24.3 15.3C25.575 15.3 26.7 16.35 26.7 17.7Z"
            fill="#003366"
          />
          <path
            d="M6.075 23.775C6.45 23.775 6.75 23.625 6.975 23.475L12.3 19.275C12.975 18.75 13.05 17.85 12.525 17.175C12 16.5 11.1 16.425 10.425 16.95L7.725 19.125C9.675 11.475 16.425 6.15001 24.3 6.15001C32.175 6.15001 39 11.475 40.95 19.125C41.175 19.95 42 20.4 42.75 20.175C43.575 19.95 44.025 19.125 43.8 18.375C41.55 9.37501 33.45 3.07501 24.225 3.07501C15.075 3.07501 7.125 9.22501 4.8 18.075L3.075 15.75C2.55 15.075 1.65 14.925 0.974998 15.45C0.299998 15.975 0.149998 16.875 0.674998 17.55L4.875 23.175C5.1 23.475 5.475 23.7 5.85 23.775H6.075Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 19,
      name: "Media",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48 15.7031V36.75C48 37.5469 47.8281 38.2656 47.4844 38.9062C47.1406 39.5469 46.6797 40.0938 46.1016 40.5469C45.5234 41 44.8828 41.3594 44.1797 41.625C43.4766 41.8906 42.75 42.0156 42 42C41.2656 42 40.5391 41.875 39.8203 41.625C39.1016 41.375 38.4609 41.0234 37.8984 40.5703C37.3359 40.1172 36.8828 39.5625 36.5391 38.9062C36.1953 38.25 36.0156 37.5312 36 36.75C36 35.9531 36.1719 35.2344 36.5156 34.5938C36.8594 33.9531 37.3203 33.3984 37.8984 32.9297C38.4766 32.4609 39.1172 32.1094 39.8203 31.875C40.5234 31.6406 41.25 31.5156 42 31.5C43.0312 31.5 44.0312 31.7422 45 32.2266V19.5469L30 23.2969V39.75C30 40.5469 29.8281 41.2656 29.4844 41.9062C29.1406 42.5469 28.6797 43.0938 28.1016 43.5469C27.5234 44 26.8828 44.3594 26.1797 44.625C25.4766 44.8906 24.75 45.0156 24 45C23.2656 45 22.5391 44.875 21.8203 44.625C21.1016 44.375 20.4609 44.0234 19.8984 43.5703C19.3359 43.1172 18.8828 42.5625 18.5391 41.9062C18.1953 41.25 18.0156 40.5312 18 39.75C18 38.9531 18.1719 38.2344 18.5156 37.5938C18.8594 36.9531 19.3203 36.3984 19.8984 35.9297C20.4766 35.4609 21.1172 35.1094 21.8203 34.875C22.5234 34.6406 23.25 34.5156 24 34.5C25.0312 34.5 26.0312 34.7422 27 35.2266V20.9531L48 15.7031Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 20,
      name: "Construction",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.3333 19.875C35.3333 31.6454 17.6667 31.6454 17.6667 19.875H22.0833C22.0833 25.7713 30.9167 25.7713 30.9167 19.875M44.1667 39.75V46.375H8.83333V39.75C8.83333 33.8538 20.6037 30.9167 26.5 30.9167C32.3962 30.9167 44.1667 33.8538 44.1667 39.75ZM39.9708 39.75C39.9708 38.3367 33.0587 35.1125 26.5 35.1125C19.9412 35.1125 13.0292 38.3367 13.0292 39.75V42.1792H39.9708M27.6042 4.41667C28.2225 4.41667 28.7083 4.90251 28.7083 5.52084V12.1458H30.9167V6.62501C32.4795 7.34829 33.7889 8.5246 34.6749 10.0013C35.561 11.478 35.9827 13.1869 35.8854 14.9063C35.8854 14.9063 37.4312 15.2154 37.5417 17.6667H15.4583C15.4583 15.2154 17.1146 14.9063 17.1146 14.9063C17.0173 13.1869 17.439 11.478 18.3251 10.0013C19.2111 8.5246 20.5205 7.34829 22.0833 6.62501V12.1458H24.2917V5.52084C24.2917 4.90251 24.7775 4.41667 25.3958 4.41667"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 21,
      name: "Hospitality",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.5 15L47.9531 42H0L18 6L28.4766 27.0234L34.5 15ZM34.5 21.7266L30.1641 30.375L31.2656 32.6016L33.8672 30H38.625L34.5 21.7266ZM21.0469 18.8203L18 12.7266L14.9531 18.8203L18 21.8672L21.0469 18.8203ZM4.85156 39H31.125L22.4531 21.6562L18 26.1328L13.5234 21.6562L4.85156 39ZM34.4531 39H43.1016L40.125 33H35.1328L32.6953 35.4375L34.4531 39Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 22,
      name: "Transportation",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.232 41.232V29.3L23.15 21H38.866L41.77 29.3V41.232H39.77V37.846H22.23V41.232H20.232ZM22.692 27.692H39.308L37.6 22.77H24.4L22.692 27.692ZM25.154 34.384C25.6553 34.384 26.0753 34.2147 26.414 33.876C26.7527 33.5373 26.9227 33.1174 26.924 32.616C26.9253 32.1147 26.7553 31.6947 26.414 31.356C26.0727 31.0174 25.6527 30.8474 25.154 30.846C24.6553 30.8447 24.2353 31.0147 23.894 31.356C23.5527 31.6974 23.3827 32.1174 23.384 32.616C23.3853 33.1147 23.5553 33.5347 23.894 33.876C24.2327 34.2174 24.6527 34.3867 25.154 34.384ZM36.846 34.384C37.3473 34.384 37.7673 34.2147 38.106 33.876C38.446 33.5373 38.616 33.1174 38.616 32.616C38.616 32.1147 38.446 31.6947 38.106 31.356C37.766 31.0174 37.346 30.8474 36.846 30.846C36.346 30.8447 35.926 31.0147 35.586 31.356C35.246 31.6974 35.0767 32.1174 35.078 32.616C35.0793 33.1147 35.2487 33.5347 35.586 33.876C35.9233 34.2174 36.3433 34.3867 36.846 34.384ZM12.692 25.232V22.154H15.77V25.232H12.692ZM20.692 15.232V12.154H23.77V15.232H20.692ZM12.692 33.232V30.154H15.77V33.232H12.692ZM12.692 41.232V38.154H15.77V41.232H12.692ZM6.23199 41.232V15.692H14.232V5.69202H30.232V16.54H28.232V7.69202H16.232V17.692H8.232V41.232H6.23199Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 23,
      name: "Retail",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M40.8 14.196C41.602 13.9139 42.2783 13.357 42.709 12.6241C43.1398 11.8911 43.2973 11.0293 43.1535 10.1914C43.0098 9.35347 42.5742 8.59344 41.9238 8.04592C41.2733 7.49841 40.4502 7.19875 39.6 7.20002H8.39999C7.54981 7.19875 6.72663 7.49841 6.07622 8.04592C5.42582 8.59344 4.99017 9.35347 4.84644 10.1914C4.70271 11.0293 4.86018 11.8911 5.29095 12.6241C5.72172 13.357 6.39799 13.9139 7.19999 14.196V39.6C7.19999 39.9183 7.32642 40.2235 7.55146 40.4485C7.7765 40.6736 8.08173 40.8 8.39999 40.8H12V30C12 29.6818 12.1264 29.3765 12.3515 29.1515C12.5765 28.9264 12.8817 28.8 13.2 28.8H22.8C23.7019 27.597 25.0227 26.7764 26.5008 26.5008L26.52 26.4H13.2C12.8817 26.4 12.5765 26.2736 12.3515 26.0485C12.1264 25.8235 12 25.5183 12 25.2V18C12 17.6818 12.1264 17.3765 12.3515 17.1515C12.5765 16.9264 12.8817 16.8 13.2 16.8H34.8C35.1182 16.8 35.4235 16.9264 35.6485 17.1515C35.8736 17.3765 36 17.6818 36 18V21.6H37.2C38.5512 21.6 39.7968 22.0464 40.8 22.8V14.196ZM8.39999 9.60002H39.6C39.9183 9.60002 40.2235 9.72644 40.4485 9.95149C40.6736 10.1765 40.8 10.4818 40.8 10.8C40.8 11.1183 40.6736 11.4235 40.4485 11.6485C40.2235 11.8736 39.9183 12 39.6 12H8.39999C8.08173 12 7.7765 11.8736 7.55146 11.6485C7.32642 11.4235 7.19999 11.1183 7.19999 10.8C7.19999 10.4818 7.32642 10.1765 7.55146 9.95149C7.7765 9.72644 8.08173 9.60002 8.39999 9.60002ZM21.6 31.2V40.8H14.4V31.2H21.6ZM32.4 21.6H33.6V19.2H14.4V24H27.6C28.6944 22.5432 30.4368 21.6 32.4 21.6ZM28.8 28.8V27.6C28.8 26.6452 29.1793 25.7296 29.8544 25.0544C30.5295 24.3793 31.4452 24 32.4 24H37.2C38.1548 24 39.0704 24.3793 39.7456 25.0544C40.4207 25.7296 40.8 26.6452 40.8 27.6V28.8H42C42.9548 28.8 43.8704 29.1793 44.5456 29.8544C45.2207 30.5296 45.6 31.4452 45.6 32.4V36H40.8V34.8C40.8 34.4818 40.6736 34.1765 40.4485 33.9515C40.2235 33.7264 39.9183 33.6 39.6 33.6C39.2817 33.6 38.9765 33.7264 38.7515 33.9515C38.5264 34.1765 38.4 34.4818 38.4 34.8V36H31.2V34.8C31.2 34.4818 31.0736 34.1765 30.8485 33.9515C30.6235 33.7264 30.3182 33.6 30 33.6C29.6817 33.6 29.3765 33.7264 29.1515 33.9515C28.9264 34.1765 28.8 34.4818 28.8 34.8V36H24V32.4C24 31.4452 24.3793 30.5296 25.0544 29.8544C25.7295 29.1793 26.6452 28.8 27.6 28.8H28.8ZM31.2 27.6V28.8H38.4V27.6C38.4 27.2818 38.2736 26.9765 38.0485 26.7515C37.8235 26.5264 37.5182 26.4 37.2 26.4H32.4C32.0817 26.4 31.7765 26.5264 31.5515 26.7515C31.3264 26.9765 31.2 27.2818 31.2 27.6ZM40.8 39.6V38.4H45.6V42C45.6 42.9548 45.2207 43.8705 44.5456 44.5456C43.8704 45.2207 42.9548 45.6 42 45.6H27.6C26.6452 45.6 25.7295 45.2207 25.0544 44.5456C24.3793 43.8705 24 42.9548 24 42V38.4H28.8V39.6C28.8 39.9183 28.9264 40.2235 29.1515 40.4485C29.3765 40.6736 29.6817 40.8 30 40.8C30.3182 40.8 30.6235 40.6736 30.8485 40.4485C31.0736 40.2235 31.2 39.9183 31.2 39.6V38.4H38.4V39.6C38.4 39.9183 38.5264 40.2235 38.7515 40.4485C38.9765 40.6736 39.2817 40.8 39.6 40.8C39.9183 40.8 40.2235 40.6736 40.4485 40.4485C40.6736 40.2235 40.8 39.9183 40.8 39.6Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 24,
      name: "Real Estate",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.2927 38.1407C25.41 38.1872 25.5157 38.2104 25.6098 38.2104C25.704 38.2104 25.8097 38.1872 25.927 38.1407L36.5897 34.8554C36.553 34.2981 36.3868 33.8966 36.091 33.6509C35.7928 33.4052 35.4561 33.2824 35.0808 33.2824H26.3817C25.6068 33.2824 24.904 33.2518 24.2733 33.1907C23.6427 33.1296 22.998 32.9842 22.3392 32.7544L19.1968 31.7424C18.9463 31.6593 18.766 31.4943 18.656 31.2474C18.546 31.0005 18.5326 30.7561 18.6157 30.5141C18.6988 30.2721 18.8552 30.0948 19.085 29.9824C19.3148 29.8699 19.558 29.8559 19.8147 29.9402L22.6563 30.9687C23.2455 31.1692 23.8981 31.2975 24.6143 31.3537C25.3293 31.4099 26.2148 31.4417 27.2708 31.4491H27.7475C27.7475 30.8771 27.6418 30.4151 27.4303 30.0631C27.2189 29.7111 26.9176 29.4654 26.5265 29.3261L15.9775 25.4541C15.9078 25.4308 15.8431 25.4137 15.7832 25.4027C15.7233 25.3917 15.6591 25.3856 15.5907 25.3844H11.7407V34.1991L25.2927 38.1407ZM24.8252 39.9521L11.7407 36.1241C11.5659 36.8476 11.1962 37.4245 10.6315 37.8547C10.0668 38.285 9.44963 38.5001 8.77985 38.5001H7.36818C6.55418 38.5001 5.85752 38.2098 5.27818 37.6292C4.69763 37.0499 4.40735 36.3532 4.40735 35.5392V26.5101C4.40735 25.6961 4.69702 24.9994 5.27635 24.4201C5.8569 23.8395 6.55418 23.5492 7.36818 23.5492H15.5503C15.7215 23.5492 15.8968 23.5688 16.0765 23.6079C16.2574 23.6458 16.4255 23.691 16.5807 23.7436L27.1755 27.6247C27.8318 27.8741 28.3965 28.322 28.8695 28.9686C29.3437 29.6151 29.5808 30.4413 29.5808 31.4472H35.0808C36.1845 31.4472 37.0303 31.7925 37.6182 32.4831C38.2061 33.1748 38.5 34.0518 38.5 35.1139C38.5 35.4806 38.401 35.7898 38.203 36.0416C38.005 36.2933 37.7147 36.4834 37.3322 36.6117L26.5448 39.9392C26.2784 40.015 25.9973 40.059 25.7015 40.0712C25.4057 40.0835 25.113 40.0431 24.8233 39.9502M6.24068 35.5374C6.24068 35.8674 6.3464 36.1381 6.55785 36.3496C6.76929 36.561 7.0394 36.6667 7.36818 36.6667H8.77985C9.10863 36.6667 9.37874 36.5787 9.59018 36.4027C9.80163 36.2267 9.90735 35.9383 9.90735 35.5374V25.3844H7.36818C7.0394 25.3844 6.76929 25.4901 6.55785 25.7016C6.3464 25.913 6.24068 26.1837 6.24068 26.5137V35.5374ZM24.7427 5.54956C25.0433 5.54956 25.3403 5.59723 25.6337 5.69256C25.927 5.78789 26.2057 5.92234 26.4697 6.09589L35.4255 12.4741C35.8203 12.7393 36.1258 13.0907 36.3422 13.5282C36.5585 13.9646 36.6667 14.418 36.6667 14.8886V26.1599C36.6667 26.4202 36.5787 26.6378 36.4027 26.8126C36.2267 26.9873 36.0085 27.0753 35.7482 27.0766C35.4879 27.0778 35.2703 26.9898 35.0955 26.8126C34.9207 26.6353 34.8333 26.4184 34.8333 26.1617V14.8427C34.8333 14.6545 34.7924 14.4785 34.7105 14.3147C34.6274 14.1497 34.504 14.0086 34.3402 13.8912L25.3843 7.65056C25.1961 7.51 24.9847 7.43973 24.75 7.43973C24.5153 7.43973 24.3039 7.51 24.1157 7.65056L15.1598 13.8912C14.9948 14.0086 14.8714 14.1491 14.7895 14.3129C14.7076 14.4791 14.6667 14.6569 14.6667 14.8464V18.2656C14.6667 18.5247 14.5787 18.7422 14.4027 18.9182C14.2267 19.0942 14.0085 19.1822 13.7482 19.1822C13.4878 19.1822 13.2703 19.0942 13.0955 18.9182C12.9207 18.7422 12.8333 18.5241 12.8333 18.2637V14.8904C12.8333 14.4186 12.9415 13.9646 13.1578 13.5282C13.3742 13.0907 13.6797 12.7393 14.0745 12.4741L23.0303 6.09589C23.2956 5.92234 23.5724 5.78789 23.8608 5.69256C24.1481 5.59723 24.442 5.54956 24.7427 5.54956ZM22.9167 15.4771C23.1147 15.4771 23.2876 15.4037 23.4355 15.2571C23.5822 15.1079 23.6555 14.9344 23.6555 14.7364C23.6555 14.5384 23.5822 14.3661 23.4355 14.2194C23.2876 14.0703 23.1147 13.9957 22.9167 13.9957C22.7187 13.9957 22.5457 14.0703 22.3978 14.2194C22.2512 14.3673 22.1778 14.5396 22.1778 14.7364C22.1778 14.9332 22.2512 15.1061 22.3978 15.2552C22.5457 15.4031 22.7187 15.4771 22.9167 15.4771ZM26.5833 15.4771C26.7813 15.4771 26.9543 15.4037 27.1022 15.2571C27.2488 15.1079 27.3222 14.9344 27.3222 14.7364C27.3222 14.5384 27.2488 14.3661 27.1022 14.2194C26.9543 14.0703 26.7813 13.9957 26.5833 13.9957C26.3853 13.9957 26.2124 14.0703 26.0645 14.2194C25.9178 14.3673 25.8445 14.5396 25.8445 14.7364C25.8445 14.9332 25.9178 15.1061 26.0645 15.2552C26.2124 15.4031 26.3853 15.4771 26.5833 15.4771ZM22.9167 19.1437C23.1147 19.1437 23.2876 19.0704 23.4355 18.9237C23.5822 18.7746 23.6555 18.6011 23.6555 18.4031C23.6555 18.2051 23.5822 18.0327 23.4355 17.8861C23.2876 17.7369 23.1147 17.6624 22.9167 17.6624C22.7187 17.6624 22.5457 17.7369 22.3978 17.8861C22.2512 18.0339 22.1778 18.2063 22.1778 18.4031C22.1778 18.5998 22.2512 18.7728 22.3978 18.9219C22.5457 19.0698 22.7187 19.1437 22.9167 19.1437ZM26.5833 19.1437C26.7813 19.1437 26.9543 19.0704 27.1022 18.9237C27.2488 18.7746 27.3222 18.6011 27.3222 18.4031C27.3222 18.2051 27.2488 18.0327 27.1022 17.8861C26.9543 17.7369 26.7813 17.6624 26.5833 17.6624C26.3853 17.6624 26.2124 17.7369 26.0645 17.8861C25.9178 18.0339 25.8445 18.2063 25.8445 18.4031C25.8445 18.5998 25.9178 18.7728 26.0645 18.9219C26.2124 19.0698 26.3853 19.1437 26.5833 19.1437Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 25,
      name: "Law Enforcement",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.3333 21.3161L9.30417 31.9403C9.01805 32.2774 8.66507 32.5515 8.26757 32.7452C7.87008 32.9389 7.43671 33.0479 6.99488 33.0655C6.55306 33.0831 6.11239 33.0088 5.70076 32.8473C5.28914 32.6858 4.9155 32.4406 4.60351 32.1273C4.29026 31.8141 4.04528 31.4394 3.88398 31.0268C3.72269 30.6142 3.64858 30.1727 3.66632 29.7301C3.68406 29.2875 3.79326 28.8533 3.98706 28.455C4.18085 28.0567 4.45504 27.7028 4.79234 27.4156L15.3908 18.3681M33 18.4561L23.9213 27.555M18.2453 3.66846L9.16667 12.7691M36.6667 21.3748L40.3333 18.3681M36.6667 27.3881L40.3333 29.392M20.1703 40.3315H38.5M22.4162 40.3315C23.4263 38.5201 24.1817 35.0551 27.7603 34.8626C28.8237 34.804 29.9053 34.804 30.9687 34.8626C34.5455 35.0551 35.3045 38.5201 36.3165 40.3315M17.1105 4.80696L10.3033 11.6306C10.3033 11.6306 13.7078 16.181 17.1123 19.5928C20.5187 23.0046 25.058 26.4183 25.058 26.4183L31.867 19.5928C31.867 19.5928 28.4625 15.0443 25.058 11.6306C21.6535 8.22062 17.1105 4.80696 17.1105 4.80696Z"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 26,
      name: "Facilities Management",
      svg: (
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.8125 23.75H10.6875C9.74267 23.75 8.83653 24.1253 8.16843 24.7934C7.50033 25.4615 7.125 26.3677 7.125 27.3125V29.6875H9.5V27.3125C9.5 26.9976 9.62511 26.6955 9.84781 26.4728C10.0705 26.2501 10.3726 26.125 10.6875 26.125H17.8125C18.1274 26.125 18.4295 26.2501 18.6522 26.4728C18.8749 26.6955 19 26.9976 19 27.3125V29.6875H21.375V27.3125C21.375 26.3677 20.9997 25.4615 20.3316 24.7934C19.6635 24.1253 18.7573 23.75 17.8125 23.75ZM14.25 22.5625C15.1895 22.5625 16.1078 22.2839 16.889 21.762C17.6701 21.24 18.2789 20.4982 18.6384 19.6302C18.9979 18.7623 19.092 17.8072 18.9087 16.8858C18.7255 15.9644 18.2731 15.118 17.6088 14.4537C16.9445 13.7894 16.0981 13.3371 15.1767 13.1538C14.2553 12.9705 13.3002 13.0646 12.4323 13.4241C11.5643 13.7836 10.8225 14.3924 10.3005 15.1735C9.77858 15.9547 9.5 16.873 9.5 17.8125C9.5 19.0723 10.0004 20.2805 10.8912 21.1713C11.782 22.0621 12.9902 22.5625 14.25 22.5625ZM14.25 15.4375C14.7197 15.4375 15.1789 15.5768 15.5695 15.8378C15.96 16.0987 16.2645 16.4697 16.4442 16.9036C16.624 17.3376 16.671 17.8151 16.5794 18.2758C16.4877 18.7365 16.2615 19.1597 15.9294 19.4919C15.5972 19.824 15.174 20.0502 14.7133 20.1419C14.2526 20.2335 13.7751 20.1865 13.3411 20.0067C12.9072 19.827 12.5362 19.5226 12.2753 19.132C12.0143 18.7414 11.875 18.2822 11.875 17.8125C11.875 17.1826 12.1252 16.5785 12.5706 16.1331C13.016 15.6877 13.6201 15.4375 14.25 15.4375Z"
            fill="#003366"
          />
          <path
            d="M33.25 22.5625V33.25H4.75V9.5H19V7.125H4.75C4.12011 7.125 3.51602 7.37522 3.07062 7.82062C2.62522 8.26602 2.375 8.87011 2.375 9.5V33.25C2.375 33.8799 2.62522 34.484 3.07062 34.9294C3.51602 35.3748 4.12011 35.625 4.75 35.625H33.25C33.8799 35.625 34.484 35.3748 34.9294 34.9294C35.3748 34.484 35.625 33.8799 35.625 33.25V22.5625H33.25Z"
            fill="#003366"
          />
          <path
            d="M23.75 22.5625H30.875V24.9375H23.75V22.5625ZM26.125 27.3125H30.875V29.6875H26.125V27.3125ZM38 11.875V9.5H35.5051C35.351 8.75693 35.0559 8.05028 34.6358 7.41831L36.4052 5.64894L34.7261 3.96981L32.9567 5.73919C32.3247 5.31907 31.6181 5.02399 30.875 4.86994V2.375H28.5V4.86994C27.7569 5.02399 27.0503 5.31907 26.4183 5.73919L24.6489 3.96981L22.9698 5.64894L24.7392 7.41831C24.3191 8.05028 24.024 8.75693 23.8699 9.5H21.375V11.875H23.8699C24.024 12.6181 24.3191 13.3247 24.7392 13.9567L22.9698 15.7261L24.6489 17.4052L26.4183 15.6358C27.0503 16.0559 27.7569 16.351 28.5 16.5051V19H30.875V16.5051C31.6181 16.351 32.3247 16.0559 32.9567 15.6358L34.7261 17.4052L36.4052 15.7261L34.6358 13.9567C35.0559 13.3247 35.351 12.6181 35.5051 11.875H38ZM29.6875 14.25C28.9829 14.25 28.2941 14.0411 27.7083 13.6496C27.1224 13.2582 26.6658 12.7018 26.3962 12.0508C26.1265 11.3998 26.056 10.6835 26.1935 9.99249C26.3309 9.30143 26.6702 8.66666 27.1684 8.16843C27.6667 7.67021 28.3014 7.33091 28.9925 7.19345C29.6835 7.05599 30.3998 7.12654 31.0508 7.39618C31.7018 7.66582 32.2582 8.12243 32.6496 8.70828C33.0411 9.29413 33.25 9.9829 33.25 10.6875C33.2491 11.632 32.8734 12.5376 32.2055 13.2055C31.5376 13.8734 30.632 14.2491 29.6875 14.25Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 27,
      name: "Creative Design & Production",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.845 3.09376C10.0737 3.29307 10.2301 3.56242 10.2898 3.85987C10.3495 4.15731 10.3091 4.46614 10.175 4.73826C10.1506 4.81847 10.1385 4.90192 10.1393 4.98576C10.1393 5.15901 10.1833 5.48901 10.5985 5.90151C10.7993 6.10226 10.9533 6.24526 11.121 6.40201C11.2585 6.52851 11.4043 6.66051 11.5885 6.84201C11.946 7.18301 12.3228 7.58451 12.661 8.08776C13.3623 9.14101 13.75 10.4583 13.75 12.375C13.75 13.4255 13.5768 14.41 13.2605 15.2818C12.364 17.7568 10.3483 19.25 8.25001 19.25C6.15176 19.25 4.13601 17.754 3.23951 15.2818C2.9088 14.3486 2.74315 13.365 2.75001 12.375C2.75001 11.4785 2.98926 10.4088 3.31926 9.42151C3.64926 8.43426 4.11126 7.40851 4.64476 6.58351C5.28001 5.51101 6.17376 4.61176 6.86676 4.00676C7.24809 3.6743 7.6445 3.35955 8.05476 3.06351L8.13726 3.00851L8.16201 2.98926L8.17026 2.98376L8.17576 2.98101C8.42792 2.81292 8.72855 2.73285 9.03092 2.75324C9.33328 2.77363 9.62044 2.89334 9.84775 3.09376M8.25001 22C9.99671 22.0044 11.6891 21.3929 13.0295 20.273C13.0845 20.4453 13.1368 20.6195 13.1863 20.7955C13.75 22.8635 13.75 25.421 13.75 27.3983V27.5C13.75 33.1595 12.6913 36.52 11.4923 38.5193C11.038 39.3055 10.4433 40.0018 9.73775 40.5735C9.45711 40.7907 9.15265 40.9752 8.83026 41.1235C8.83026 41.1235 8.48101 41.25 8.25001 41.25C8.05176 41.2343 7.85657 41.1917 7.66976 41.1235C7.34736 40.9752 7.0429 40.7907 6.76226 40.5735C6.05673 40.0018 5.46205 39.3055 5.00776 38.5193C3.80876 36.5228 2.75001 33.1595 2.75001 27.5V27.401C2.75001 25.421 2.75001 22.8663 3.31376 20.7928C3.36142 20.6204 3.41367 20.4463 3.47051 20.2703C4.80979 21.3932 6.50226 22.0076 8.25001 22.0055M19.2445 30.1813C18.2913 30.0749 17.3536 29.858 16.4505 29.535C16.4835 28.842 16.5 28.127 16.5 27.39V26.576C17.3525 26.9803 18.2765 27.2635 19.2445 27.401V22C19.2445 20.5413 19.824 19.1424 20.8554 18.1109C21.8869 17.0795 23.2858 16.5 24.7445 16.5H30.1483C29.9295 14.9795 29.35 13.5335 28.4582 12.2827C27.5664 11.0319 26.3882 10.0128 25.022 9.31045C23.6558 8.60811 22.1413 8.24297 20.6052 8.24555C19.069 8.24813 17.5558 8.61834 16.192 9.32526C15.976 8.42622 15.6196 7.56685 15.136 6.77876C16.9184 5.89789 18.8867 5.45943 20.8744 5.50048C22.8621 5.54153 24.8107 6.06089 26.5552 7.0146C28.2996 7.96831 29.7886 9.32828 30.8961 10.9794C32.0036 12.6305 32.6969 14.5241 32.9175 16.5H35.7418C37.2004 16.5 38.5994 17.0795 39.6308 18.1109C40.6623 19.1424 41.2418 20.5413 41.2418 22V33C41.2418 34.4587 40.6623 35.8576 39.6308 36.8891C38.5994 37.9205 37.2004 38.5 35.7418 38.5H24.7418C23.2831 38.5 21.8841 37.9205 20.8527 36.8891C19.8212 35.8576 19.2418 34.4587 19.2418 33L19.2445 30.1813ZM32.9203 19.25C32.6088 22.0405 31.3575 24.6421 29.3721 26.6276C27.3866 28.613 24.785 29.8643 21.9945 30.1758V33C21.9945 33.7294 22.2842 34.4288 22.8 34.9446C23.3157 35.4603 24.0152 35.75 24.7445 35.75H35.7445C36.4739 35.75 37.1733 35.4603 37.689 34.9446C38.2048 34.4288 38.4945 33.7294 38.4945 33V22C38.4945 21.2707 38.2048 20.5712 37.689 20.0555C37.1733 19.5397 36.4739 19.25 35.7445 19.25H32.9203ZM30.1483 19.25H24.7445C24.0152 19.25 23.3157 19.5397 22.8 20.0555C22.2842 20.5712 21.9945 21.2707 21.9945 22V27.4038C24.0518 27.1073 25.9578 26.1528 27.4276 24.6831C28.8973 23.2133 29.8518 21.3073 30.1483 19.25Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 28,
      name: "Maintenance Services",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.8333 18.3333V3.66663H12.8333V25.6666H25.6667V12.8333H3.66667V34.8333H18.3333M25.6667 42.1666L36.6667 31.1666M38.5 25.6666C37.7748 25.6666 37.0659 25.8817 36.4629 26.2846C35.8599 26.6875 35.39 27.2601 35.1124 27.9301C34.8349 28.6001 34.7623 29.3374 34.9038 30.0486C35.0453 30.7599 35.3945 31.4132 35.9073 31.926C36.4201 32.4388 37.0734 32.788 37.7847 32.9295C38.4959 33.071 39.2332 32.9984 39.9032 32.7209C40.5732 32.4433 41.1458 31.9734 41.5487 31.3704C41.9516 30.7674 42.1667 30.0585 42.1667 29.3333"
            stroke="#003366"
            strokeWidth="3"
          />
        </svg>
      ),
    },
    {
      id: 29,
      name: "Leisure",
      svg: (
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 20.5833V30.0833M19 20.5833V4.74996M19 20.5833C19 18.6215 17.4048 16.625 15.4375 16.625C13.4702 16.625 11.875 18.6215 11.875 20.5833C11.875 18.6215 10.2798 16.625 8.3125 16.625C6.34521 16.625 4.75 18.6215 4.75 20.5833V18.9556C4.75 11.1102 11.13 4.74996 19 4.74996M19 20.5833C19 18.6215 20.5952 16.625 22.5625 16.625C24.5298 16.625 26.125 18.6215 26.125 20.5833C26.125 18.6215 27.7202 16.625 29.6875 16.625C31.6548 16.625 33.25 18.6215 33.25 20.5833V18.9556C33.25 11.1102 26.87 4.74996 19 4.74996M19 4.74996V3.16663M6.33333 31.6666H26.9167L31.6667 26.9166M11.875 31.6666V34.8333M25.3333 31.6666V34.8333"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.875 20.5833C11.875 20.5833 10.6875 16.2292 12.6667 11.875C14.6458 7.52083 19 4.75 19 4.75M19 4.75C19 4.75 22.5625 6.72917 24.5417 11.875C26.5208 17.0208 26.125 20.5833 26.125 20.5833M19 4.75V19.7917"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.6875 16.625C27.7202 16.625 26.125 18.6216 26.125 20.5833C26.125 18.6216 24.5298 16.625 22.5625 16.625C20.5952 16.625 19 18.6216 19 20.5833C19 18.6216 17.4048 16.625 15.4375 16.625C13.4702 16.625 11.875 18.6216 11.875 20.5833C11.875 18.6216 10.2798 16.625 8.3125 16.625M12.4553 6.33333C14.4162 5.32158 16.6408 4.75 19 4.75C21.3592 4.75 23.5837 5.32158 25.5439 6.33333"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },

    {
      id: 30,
      name: "Events and Exhibitions",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.8333 18.3333V3.66663H12.8333V25.6666H25.6667V12.8333H3.66667V34.8333H18.3333M25.6667 42.1666L36.6667 31.1666M38.5 25.6666C37.7748 25.6666 37.0659 25.8817 36.4629 26.2846C35.8599 26.6875 35.39 27.2601 35.1124 27.9301C34.8349 28.6001 34.7623 29.3374 34.9038 30.0486C35.0453 30.7599 35.3945 31.4132 35.9073 31.926C36.4201 32.4388 37.0734 32.788 37.7847 32.9295C38.4959 33.071 39.2332 32.9984 39.9032 32.7209C40.5732 32.4433 41.1458 31.9734 41.5487 31.3704C41.9516 30.7674 42.1667 30.0585 42.1667 29.3333"
            stroke="#003366"
            strokeWidth="3"
          />
        </svg>
      ),
    },

    {
      id: 31,
      name: "Government",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M46.375 15.4583C46.9379 15.459 47.4792 15.6745 47.8885 16.0609C48.2978 16.4473 48.5441 16.9754 48.5771 17.5372C48.6101 18.0991 48.4273 18.6524 48.066 19.084C47.7047 19.5157 47.1923 19.7931 46.6334 19.8595L46.375 19.875V41.9583C46.9379 41.959 47.4792 42.1745 47.8885 42.5609C48.2978 42.9473 48.5441 43.4754 48.5771 44.0372C48.6101 44.5991 48.4273 45.1524 48.066 45.584C47.7047 46.0157 47.1923 46.2931 46.6334 46.3595L46.375 46.375H6.625C6.06214 46.3744 5.52076 46.1589 5.11148 45.7725C4.70219 45.3861 4.4559 44.858 4.42291 44.2961C4.38993 43.7342 4.57274 43.1809 4.934 42.7493C5.29526 42.3177 5.8077 42.0403 6.36662 41.9738L6.625 41.9583V19.875C6.06214 19.8744 5.52076 19.6589 5.11148 19.2725C4.70219 18.8861 4.4559 18.358 4.42291 17.7961C4.38993 17.2342 4.57274 16.6809 4.934 16.2493C5.29526 15.8177 5.8077 15.5403 6.36662 15.4738L6.625 15.4583H46.375ZM41.9583 19.875H11.0417V41.9583H15.4583V26.5C15.4583 25.9143 15.691 25.3526 16.1051 24.9385C16.5193 24.5243 17.081 24.2917 17.6667 24.2917C18.2524 24.2917 18.8141 24.5243 19.2282 24.9385C19.6423 25.3526 19.875 25.9143 19.875 26.5V41.9583H24.2917V26.5C24.2917 25.9143 24.5243 25.3526 24.9385 24.9385C25.3526 24.5243 25.9143 24.2917 26.5 24.2917C27.0857 24.2917 27.6474 24.5243 28.0615 24.9385C28.4757 25.3526 28.7083 25.9143 28.7083 26.5V41.9583H33.125V26.5C33.125 25.9143 33.3577 25.3526 33.7718 24.9385C34.186 24.5243 34.7476 24.2917 35.3333 24.2917C35.919 24.2917 36.4807 24.5243 36.8949 24.9385C37.309 25.3526 37.5417 25.9143 37.5417 26.5V41.9583H41.9583V19.875ZM39.75 8.83333C40.3357 8.83333 40.8974 9.066 41.3115 9.48014C41.7257 9.89428 41.9583 10.456 41.9583 11.0417C41.9583 11.6274 41.7257 12.189 41.3115 12.6032C40.8974 13.0173 40.3357 13.25 39.75 13.25H13.25C12.6643 13.25 12.1026 13.0173 11.6885 12.6032C11.2743 12.189 11.0417 11.6274 11.0417 11.0417C11.0417 10.456 11.2743 9.89428 11.6885 9.48014C12.1026 9.066 12.6643 8.83333 13.25 8.83333H39.75Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 32,
      name: "Non Profit",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31.5 4.54651L30.516 5.62501C28.3125 8.05051 26.496 9.13501 24.984 9.84451C23.472 10.5525 22.2015 10.764 20.9535 11.7195C19.623 12.7395 17.6895 14.6955 16.875 18.1875C15.129 18.5685 13.851 19.2375 12.843 20.109C11.847 20.97 11.097 21.9495 10.173 23.016C10.1655 23.028 10.1775 23.0505 10.173 23.0625C8.847 24.5865 7.6875 26.2275 5.4375 27.0945L4.5 27.4695V43.5H33.0945C34.734 43.4115 35.871 42.276 36.5625 41.1555C37.2525 40.0365 37.635 38.8245 37.8285 37.8285C38.3265 35.2905 39.234 27.984 39.234 27.984L39.282 27.8445V27.7035C39.234 26.6895 38.817 25.8285 38.2965 25.0305L39.984 20.016L42.657 15.984L43.407 14.9055L42.4215 14.016L32.5785 5.48401L31.5 4.54651ZM31.5945 8.67151L39.4215 15.4695L37.359 18.5145L37.2195 18.657L37.1715 18.891L35.8125 22.9215C35.103 22.629 34.3725 22.4235 33.5625 22.4535H33.468L24 22.5H22.5V28.3125C22.29 29.9475 21.381 30.5805 20.25 31.032C19.875 31.1835 19.8285 31.101 19.5 31.1715V22.455C19.254 16.8945 21.234 15.294 22.782 14.1105C23.2095 13.782 24.462 13.4025 26.25 12.564C27.744 11.8605 29.601 10.599 31.5945 8.67151ZM16.5945 21.5625C16.5885 21.903 16.482 22.143 16.5 22.5V34.5H18C18 34.5 19.605 34.482 21.3285 33.7965C23.052 33.111 25.131 31.506 25.5 28.6875V25.5L33.5625 25.4535H33.609C34.2677 25.4167 34.914 25.6427 35.4062 26.082C35.8984 26.5213 36.1961 27.1379 36.234 27.7965C36.228 27.8205 36.159 28.377 36.141 28.5H30V31.5H35.766C35.607 32.6595 35.4615 33.387 35.2965 34.5H30V37.5H34.8285C34.6513 38.2257 34.3666 38.9209 33.984 39.5625C33.5745 40.23 33.222 40.482 32.907 40.5H7.5V29.2965C9.9315 28.0065 11.4435 26.151 12.4215 25.032C13.4355 23.871 14.1315 22.992 14.8125 22.407C15.258 22.026 15.9555 21.8085 16.5945 21.5625Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 33,
      name: "Energy",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Energy and Utilities SVG paths */}
        </svg>
      ),
    },
    {
      id: 34,
      name: "Agriculture",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M30 8C30 6.895 27.012 6 24 6C20.988 6 18 6.895 18 8L17.148 10.841C17.501 10.895 17.89 10.952 18.301 11.009C20.097 11.259 22.291 11.5 24 11.5C25.71 11.5 27.903 11.258 29.699 11.01C30.11 10.952 30.499 10.895 30.852 10.841L30 8ZM31.587 12.751C31.119 12.825 30.57 12.908 29.973 12.991C28.16 13.241 25.853 13.5 24 13.5C22.146 13.5 19.84 13.242 18.027 12.99C17.4883 12.9154 16.9502 12.8357 16.413 12.751C13.135 13.478 11 14.662 11 16C11 18.21 16.82 20 24 20C31.18 20 37 18.21 37 16C37 14.662 34.865 13.478 31.587 12.751Z"
            fill="#003366"
          />
          <path
            d="M16.002 19.154C16.0426 21.2485 16.9031 23.2435 18.3987 24.7104C19.8943 26.1773 21.9056 26.9991 24.0005 26.9991C26.0954 26.9991 28.1067 26.1773 29.6023 24.7104C31.0979 23.2435 31.9584 21.2485 31.999 19.154C31.3297 19.3131 30.6545 19.4465 29.975 19.554C29.8385 21.0443 29.15 22.4299 28.0446 23.4387C26.9391 24.4475 25.4966 25.0068 24 25.0068C22.5034 25.0068 21.0609 24.4475 19.9554 23.4387C18.85 22.4299 18.1615 21.0443 18.025 19.554C17.3458 19.4465 16.671 19.313 16.002 19.154Z"
            fill="#003366"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.197 35C16.481 36.2379 15.3477 37.1805 14 37.659V41C14 41.35 13.94 41.687 13.83 42H42V36C42 30.583 30.008 29 24 29C21.9932 29.0098 19.9891 29.148 18 29.414V35H17.197ZM24 36C22.6552 35.9986 21.3144 35.8545 20 35.57V31.2C21.467 31.062 22.848 31 24 31C25.666 31 27.809 31.129 30 31.432V35C29.987 35.005 27.49 36 24 36ZM34.703 32.392C34.1497 32.2347 33.582 32.0917 33 31.963V35H35C35.2652 35 35.5196 35.1054 35.7071 35.2929C35.8946 35.4804 36 35.7348 36 36V40H40V36C40 35.494 39.752 34.908 38.835 34.223C37.895 33.521 36.472 32.898 34.703 32.392Z"
            fill="#003366"
          />
          <path
            d="M8 25C8 24.7348 7.89464 24.4804 7.70711 24.2929C7.51957 24.1054 7.26522 24 7 24C6.73478 24 6.48043 24.1054 6.29289 24.2929C6.10536 24.4804 6 24.7348 6 25V32C6 33.0609 6.42143 34.0783 7.17157 34.8284C7.92172 35.5786 8.93913 36 10 36V41C10 41.2652 10.1054 41.5196 10.2929 41.7071C10.4804 41.8946 10.7348 42 11 42C11.2652 42 11.5196 41.8946 11.7071 41.7071C11.8946 41.5196 12 41.2652 12 41V36C13.0609 36 14.0783 35.5786 14.8284 34.8284C15.5786 34.0783 16 33.0609 16 32V25C16 24.7348 15.8946 24.4804 15.7071 24.2929C15.5196 24.1054 15.2652 24 15 24C14.7348 24 14.4804 24.1054 14.2929 24.2929C14.1054 24.4804 14 24.7348 14 25V32C14 32.5304 13.7893 33.0391 13.4142 33.4142C13.0391 33.7893 12.5304 34 12 34V25C12 24.7348 11.8946 24.4804 11.7071 24.2929C11.5196 24.1054 11.2652 24 11 24C10.7348 24 10.4804 24.1054 10.2929 24.2929C10.1054 24.4804 10 24.7348 10 25V34C9.46957 34 8.96086 33.7893 8.58579 33.4142C8.21071 33.0391 8 32.5304 8 32V25Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 35,
      name: "Environmental",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 44V40C4 40 14 36 24 36C34 36 44 40 44 40V44H4ZM22.6 18.2C20.2 10.4 8 12.2 8 12.2C8 12.2 8.4 27.8 19.8 25.4C19 19.6 16 18 16 18C21.6 18 22 24.8 22 24.8V34H26V25.6C26 25.6 26 17.8 32 15.8C32 15.8 28 21.8 28 25.8C42 27.2 42 8 42 8C42 8 24.2 6 22.6 18.2Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 36,
      name: "Telecommunications",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.525 29.15L20.2063 26.8312C20.5007 26.4264 20.7031 26.0127 20.8135 25.5901C20.924 25.1676 20.9792 24.7348 20.9792 24.2916C20.9792 23.8485 20.924 23.4164 20.8135 22.9954C20.7031 22.5743 20.5007 22.1783 20.2063 21.8073L22.525 19.4333C23.1139 20.1326 23.5556 20.9055 23.85 21.7521C24.1444 22.5986 24.2917 23.4451 24.2917 24.2916C24.2917 25.1382 24.1444 25.9759 23.85 26.8047C23.5556 27.6336 23.1139 28.4153 22.525 29.15ZM27.2177 33.8979L24.8438 31.5239C25.7639 30.4934 26.4544 29.3524 26.9152 28.101C27.376 26.8496 27.6056 25.5798 27.6042 24.2916C27.6027 23.0034 27.373 21.7432 26.9152 20.511C26.4573 19.2787 25.7668 18.1466 24.8438 17.1146L27.2177 14.7406C28.4691 16.1024 29.3988 17.6026 30.0068 19.2412C30.6149 20.8798 30.9181 22.5633 30.9167 24.2916C30.9152 26.02 30.6112 27.7131 30.0046 29.3708C29.3981 31.0285 28.4691 32.5376 27.2177 33.8979ZM11.0417 26.5C9.82709 26.5 8.7877 26.0679 7.9235 25.2037C7.05931 24.3395 6.62647 23.2994 6.625 22.0833C6.62353 20.8673 7.05636 19.8279 7.9235 18.9651C8.79064 18.1024 9.83003 17.6696 11.0417 17.6666C12.2533 17.6637 13.2934 18.0965 14.162 18.9651C15.0307 19.8338 15.4628 20.8731 15.4583 22.0833C15.4539 23.2935 15.0218 24.3336 14.162 25.2037C13.3023 26.0738 12.2621 26.5059 11.0417 26.5ZM2.20834 35.3333V34.0635C2.20834 33.1802 2.44757 32.3705 2.92604 31.6344C3.40452 30.8982 4.06702 30.3462 4.91354 29.9781C5.87049 29.5732 6.85541 29.2604 7.86829 29.0396C8.88118 28.8187 9.93897 28.7083 11.0417 28.7083C12.1444 28.7083 13.2029 28.8187 14.2173 29.0396C15.2316 29.2604 16.2158 29.5732 17.1698 29.9781C18.0163 30.3462 18.6788 30.8982 19.1573 31.6344C19.6358 32.3705 19.875 33.1802 19.875 34.0635V35.3333H2.20834ZM41.9583 26.5C40.7438 26.5 39.7044 26.0679 38.8402 25.2037C37.976 24.3395 37.5431 23.2994 37.5417 22.0833C37.5402 20.8673 37.973 19.8279 38.8402 18.9651C39.7073 18.1024 40.7467 17.6696 41.9583 17.6666C43.17 17.6637 44.2101 18.0965 45.0787 18.9651C45.9473 19.8338 46.3794 20.8731 46.375 22.0833C46.3706 23.2935 45.9385 24.3336 45.0787 25.2037C44.2189 26.0738 43.1788 26.5059 41.9583 26.5ZM33.125 35.3333V34.0635C33.125 33.1802 33.3642 32.3705 33.8427 31.6344C34.3212 30.8982 34.9837 30.3462 35.8302 29.9781C36.7872 29.5732 37.7713 29.2604 38.7828 29.0396C39.7942 28.8187 40.8527 28.7083 41.9583 28.7083C43.064 28.7083 44.1218 28.8187 45.1317 29.0396C46.1417 29.2604 47.1266 29.5732 48.0865 29.9781C48.933 30.3462 49.5955 30.8982 50.074 31.6344C50.5524 32.3705 50.7917 33.1802 50.7917 34.0635V35.3333H33.125Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 37,
      name: "Automotive",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 20V12C7 9.8 8.8 8 11 8H25C26.2 8 27.4 8.6 28.2 9.6L35 18"
            stroke="#003366"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M35 42C37.7614 42 40 39.7614 40 37C40 34.2386 37.7614 32 35 32C32.2386 32 30 34.2386 30 37C30 39.7614 32.2386 42 35 42Z"
            fill="#37474F"
          />
          <path
            d="M13 42C15.7614 42 18 39.7614 18 37C18 34.2386 15.7614 32 13 32C10.2386 32 8 34.2386 8 37C8 39.7614 10.2386 42 13 42Z"
            fill="#37474F"
          />
          <path
            d="M40.2 17L33 14H7C5.8 14 5 14.8 5 16V26C5 27.2 5.8 28 7 28H8C8 25.2 10.2 23 13 23C15.8 23 18 25.2 18 28H30C30 25.2 32.2 23 35 23C37.8 23 40 25.2 40 28H41C42.2 28 43 27.2 43 26V20.8C43 19.2 41.8 17.6 40.2 17Z"
            fill="#003366"
          />
          <path
            d="M24 40C25.6569 40 27 38.6569 27 37C27 35.3431 25.6569 34 24 34C22.3431 34 21 35.3431 21 37C21 38.6569 22.3431 40 24 40Z"
            fill="#CDCDCD"
          />
          <path
            d="M35 39C36.1046 39 37 38.1046 37 37C37 35.8954 36.1046 35 35 35C33.8954 35 33 35.8954 33 37C33 38.1046 33.8954 39 35 39Z"
            fill="#CDCDCD"
          />
          <path
            d="M13 39C14.1046 39 15 38.1046 15 37C15 35.8954 14.1046 35 13 35C11.8954 35 11 35.8954 11 37C11 38.1046 11.8954 39 13 39Z"
            fill="#CDCDCD"
          />
          <path
            d="M30.4 39C30.1 38.4 30 37.7 30 37C30 36.3 30.2 35.6 30.4 35H17.6C17.9 35.6 18 36.3 18 37C18 37.7 17.8 38.4 17.6 39H30.4Z"
            fill="#CDCDCD"
          />
        </svg>
      ),
    },

    {
      id: 38,
      name: "Aerospace",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.116 26.254L8.196 31.458C7.652 31.6633 7.15 31.608 6.69 31.292C6.23 30.976 6 30.534 6 29.966V29.246C6 28.9847 6.058 28.7387 6.174 28.508C6.29 28.2773 6.454 28.0887 6.666 27.942L21.116 17.762V8.884C21.116 8.09067 21.398 7.412 21.962 6.848C22.5273 6.28267 23.2067 6 24 6C24.7933 6 25.472 6.28267 26.036 6.848C26.6 7.41333 26.8827 8.092 26.884 8.884V17.762L41.334 27.942C41.546 28.0887 41.71 28.2773 41.826 28.508C41.942 28.7387 42 28.9853 42 29.248V29.966C42 30.5327 41.77 30.9747 41.31 31.292C40.85 31.6093 40.348 31.6647 39.804 31.458L26.884 26.254V34.914L32.034 38.554C32.2047 38.6793 32.338 38.8307 32.434 39.008C32.53 39.1853 32.578 39.3787 32.578 39.588V40.288C32.578 40.724 32.4113 41.0673 32.078 41.318C31.7447 41.5687 31.374 41.632 30.966 41.508L24 39.384L17.034 41.508C16.6247 41.6307 16.254 41.5673 15.922 41.318C15.59 41.0687 15.4233 40.7253 15.422 40.288V39.578C15.422 39.3793 15.47 39.1907 15.566 39.012C15.662 38.8333 15.7953 38.6807 15.966 38.554L21.116 34.914V26.254Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 39,
      name: "Pharmaceutical",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Pharmaceuticals SVG paths */}
        </svg>
      ),
    },

    {
      id: 40,
      name: "Biotechnology",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 42V38H20V34C17.2333 34 14.8753 33.0247 12.926 31.074C10.9767 29.1233 10.0013 26.7653 10 24C10 22.1 10.4833 20.35 11.45 18.75C12.4167 17.15 13.75 15.9333 15.45 15.1C15.3167 15.8333 15.342 16.55 15.526 17.25C15.71 17.95 16.0013 18.6167 16.4 19.25C15.6333 19.7833 15.0413 20.4667 14.624 21.3C14.2067 22.1333 13.9987 23.0333 14 24C14 25.6667 14.5833 27.0833 15.75 28.25C16.9167 29.4167 18.3333 30 20 30H36V34H26V38H38V42H10ZM28 24.2L27.4 22.3L25.5 23L24.5 20.35C25.1667 19.8167 25.6833 19.1753 26.05 18.426C26.4167 17.6767 26.6 16.868 26.6 16C26.6 14.4333 26.05 13.1087 24.95 12.026C23.85 10.9433 22.5 10.4013 20.9 10.4L20 7.9L21.9 7.2L21.2 5.4L25 4L25.6 5.9L27.5 5.2L33 20.2L31.1 20.9L31.8 22.8L28 24.2ZM21 19.6C20 19.6 19.15 19.25 18.45 18.55C17.75 17.85 17.4 17 17.4 16C17.4 15 17.75 14.15 18.45 13.45C19.15 12.75 20 12.4 21 12.4C22 12.4 22.85 12.75 23.55 13.45C24.25 14.15 24.6 15 24.6 16C24.6 17 24.25 17.85 23.55 18.55C22.85 19.25 22 19.6 21 19.6Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 41,
      name: "Insurance",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.4497 2.54498L1.11584 20.24H6.16V41.36H37.84V20.24H43.3558L22.4497 2.54498ZM27.229 35.2H17.2418L19.3362 25.7743C18.0699 24.8943 17.2418 23.5691 17.2418 21.9463C17.2418 19.2729 19.4779 17.16 22.235 17.16C24.9938 17.16 27.229 19.3539 27.229 22.0273C27.229 23.6509 26.4009 24.8829 25.1354 25.7603L27.229 35.2Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 42,
      name: "Food",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.96875 30.729H48.0312M45.6021 30.729C45.6021 20.1798 37.0503 11.6269 26.5 11.6269C15.9497 11.6269 7.39792 20.1798 7.39792 30.729"
            stroke="#003366"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.5445 16.2666C16.5709 17.5541 14.9397 19.3019 13.7914 21.3596C12.6431 23.4173 12.0121 25.7233 11.9526 28.079M26.5 11.6269V9.13147M27.5379 38.149C33.2774 38.0794 34.0127 37.8398 44.6249 35.1456C45.2929 34.9767 45.7887 35.319 45.9344 35.7077C46.0835 36.1052 46.0228 36.8096 45.1162 37.0448C43.3275 37.5086 32.1754 42.654 29.6358 42.654C27.0962 42.654 19.6983 42.1019 16.9158 42.1019C14.1333 42.1019 10.8871 43.8686 10.8871 43.8686C8.65667 41.7927 7.24333 38.3477 6.86792 34.6156H34.4279C35.5652 34.6156 35.9296 36.2056 34.9579 36.6473C33.517 37.3021 31.0712 38.149 27.5379 38.149Z"
            stroke="#003366"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 43,
      name: "Arts",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 42.2L21 44.8C7.8 33 1 26.8 1 19.2C1 16.8 1.8 14.6 3 12.8V14C3 23.4 10.8 30.4 24 42.2ZM27.2 34C36.6 25.4 43 19.8 43.2 14C43.2 10 40.2 7 36.2 7C33 7 30 9 29 11.8H25.2C24 9 21 7 18 7C14 7 11 10 11 14C11 19.8 17.2 25.4 26.8 34L27 34.2M36 3C42.2 3 47 7.8 47 14C47 21.4 40.2 27.6 27 39.6C13.8 27.8 7 21.6 7 14C7 7.8 11.8 3 18 3C21.4 3 24.8 4.6 27 7.2C29.2 4.6 32.6 3 36 3Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 44,
      name: "Sports",
      svg: (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.75 12.5H22.9167V8.33334H18.75V12.5ZM27.0833 12.5V8.33334H31.25V12.5H27.0833ZM18.75 29.1667V25H22.9167V29.1667H18.75ZM35.4167 20.8333V16.6667H39.5833V20.8333H35.4167ZM35.4167 29.1667V25H39.5833V29.1667H35.4167ZM27.0833 29.1667V25H31.25V29.1667H27.0833ZM35.4167 12.5V8.33334H39.5833V12.5H35.4167ZM22.9167 16.6667V12.5H27.0833V16.6667H22.9167ZM10.4167 41.6667V8.33334H14.5833V12.5H18.75V16.6667H14.5833V20.8333H18.75V25H14.5833V41.6667H10.4167ZM31.25 25V20.8333H35.4167V25H31.25ZM22.9167 25V20.8333H27.0833V25H22.9167ZM18.75 20.8333V16.6667H22.9167V20.8333H18.75ZM27.0833 20.8333V16.6667H31.25V20.8333H27.0833ZM31.25 16.6667V12.5H35.4167V16.6667H31.25Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 45,
      name: "Fashion",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.5243 20.1223L23.4768 26.0285L17.5022 29.0164L5.52084 25.0226L8.48663 16.123L20.5243 20.1223ZM32.4769 20.1764L29.5232 26.0826L35.4979 29.0705L47.4792 25.0756L44.5134 16.176L32.4769 20.1764ZM17.9151 30.4783L24.369 29.0771L25.7856 35.6061L18.9519 46.227L11.0638 41.1512L17.9151 30.4783ZM21.8515 19.4333L26.521 24.1029L31.2446 19.3792V6.74977H21.8647L21.8515 19.4333ZM35.128 30.5015L28.6741 29.1014L27.2575 35.6293L34.0912 46.2513L41.9793 41.1755L35.128 30.5015Z"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },

    {
      id: 46,
      name: "Beauty and Wellness",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.83331 31.0713C11.0748 31.0713 14.2018 30.4043 16.165 31.8442L20.0561 34.6929C21.5025 35.7529 23.0682 35.404 24.6825 35.1523C26.8069 34.8188 28.7083 36.6318 28.7083 38.9903C28.7083 39.6352 24.1304 41.276 23.4701 41.5873C22.8344 41.888 22.1286 42.0094 21.429 41.9386C20.7293 41.8677 20.0622 41.6073 19.4996 41.1854L15.1094 37.9679"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.7083 37.5417L37.7426 33.3679C38.5394 33.0926 39.3987 33.0535 40.2172 33.2553C41.0356 33.4571 41.7783 33.8911 42.3558 34.5052L43.8354 36.0532C44.3654 36.6053 44.2417 37.5372 43.5859 37.9171L26.2416 47.9893C25.7292 48.2896 25.1605 48.4812 24.5709 48.5522C23.9813 48.6233 23.3833 48.5722 22.8143 48.4022L8.83331 44.2263M26.5044 26.5C26.5044 26.5 31.1419 21.5555 31.1419 15.4583C31.1419 9.36112 26.5044 4.41666 26.5044 4.41666C26.5044 4.41666 21.8669 9.36112 21.8669 15.4583C21.8669 21.5555 26.5044 26.5 26.5044 26.5ZM26.5044 26.5C26.5044 26.5 33.2774 26.3498 37.5461 21.995C41.8148 17.638 41.9627 10.7259 41.9627 10.7259C41.9627 10.7259 39.1581 10.7877 36.0223 11.9935M26.5044 26.5C26.5044 26.5 19.7314 26.3498 15.4627 21.995C11.194 17.638 11.0461 10.7259 11.0461 10.7259C11.0461 10.7259 13.8506 10.7877 16.9865 11.9935"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 47,
      name: "TechWave Pvt Ltd.",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 49.6875L12.5279 33.2095C12.3337 32.962 12.1416 32.713 11.9515 32.4625C9.56601 29.3179 8.27681 25.4782 8.28125 21.5312C8.28125 16.6993 10.2007 12.0653 13.6174 8.64865C17.0341 5.23197 21.6681 3.3125 26.5 3.3125C31.3319 3.3125 35.9659 5.23197 39.3826 8.64865C42.7993 12.0653 44.7187 16.6993 44.7187 21.5312C44.7226 25.4764 43.434 29.3141 41.0502 32.4575L41.0485 32.4625C41.0485 32.4625 40.5516 33.1151 40.4771 33.2028L26.5 49.6875ZM14.5965 30.4667C14.5965 30.4667 14.9824 30.9768 15.0702 31.0862L26.5 44.5664L37.9447 31.0679C38.0176 30.9768 38.4051 30.4634 38.4068 30.4618C40.3565 27.8932 41.4102 24.756 41.4062 21.5312C41.4062 17.5779 39.8358 13.7864 37.0403 10.9909C34.2448 8.19548 30.4534 6.625 26.5 6.625C22.5466 6.625 18.7551 8.19548 15.9597 10.9909C13.1642 13.7864 11.5937 17.5779 11.5937 21.5312C11.5897 24.7581 12.6445 27.8972 14.5965 30.4667Z"
            fill="#003366"
          />
          <path
            d="M34.7812 29.8125H31.4688V16.5625H21.5312V29.8125H18.2188V16.5625C18.2188 15.684 18.5677 14.8414 19.189 14.2202C19.8102 13.599 20.6527 13.25 21.5312 13.25H31.4688C32.3473 13.25 33.1898 13.599 33.811 14.2202C34.4323 14.8414 34.7812 15.684 34.7812 16.5625V29.8125Z"
            fill="#003366"
          />
          <path
            d="M24.8438 26.5H28.1562V29.8125H24.8438V26.5ZM24.8438 19.875H28.1562V23.1875H24.8438V19.875Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 48,
      name: "Beauty and Personal Care",
      svg: (
        <svg
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.83331 30.9167H14.1223C14.7715 30.9167 15.4119 31.0624 15.9927 31.3451L20.5021 33.5269C21.0829 33.8074 21.7234 33.9531 22.3748 33.9531H24.6759C26.9019 33.9531 28.7083 35.6999 28.7083 37.8552C28.7083 37.9436 28.6487 38.0187 28.5626 38.043L22.9512 39.5954C21.9443 39.8736 20.8706 39.7763 19.9302 39.3216L15.1094 36.9896M18.5411 5.63567C21.7962 3.61725 24.6406 4.42992 26.3476 5.72621C27.0476 6.25621 27.3988 6.52121 27.6041 6.52121C27.8095 6.52121 28.1606 6.25621 28.8607 5.72621C30.5677 4.42992 33.4099 3.61725 36.6671 5.63567C40.9425 8.28567 41.9097 17.0218 32.0517 24.3932C30.1724 25.7977 29.2339 26.5 27.6041 26.5C25.9744 26.5 25.0359 25.7977 23.1588 24.3932C13.2986 17.0218 14.2658 8.28346 18.5411 5.63567Z"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.7083 36.4375L38.8512 33.3215C39.7342 33.0506 40.6802 33.0655 41.5543 33.3641C42.4283 33.6627 43.1857 34.2298 43.7184 34.9844C44.5332 36.1107 44.202 37.7272 43.0139 38.4117L26.4183 47.9893C25.8993 48.2895 25.3247 48.481 24.7294 48.552C24.1341 48.623 23.5306 48.572 22.9556 48.4022L8.83331 44.2108"
            stroke="#003366"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 49,
      name: "IT and Software Development",
      svg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_5_97)">
            <path
              d="M16 32H32M24 24V32M12 12V10C12 4 15 2 20 2H28C33 2 36 5 36 10V12C42 12 46 16 46 22C46 28 42 32 36 32M12 12H28M12 12C6 12 2 15 2 22C2 29 6 32 12 32M16 46H32V24H16V46Z"
              stroke="#003366"
              strokeWidth="3"
            />
          </g>
          <defs>
            <clipPath id="clip0_5_97">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
    },

    {
      id: 50,
      name: "Dental Services",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.6667 9.16668C24.75 10.0833 22.9112 9.92201 20.1667 7.65601M20.1667 7.65601C20.5724 7.32356 20.9935 6.94101 21.4298 6.50834C25.6575 2.32101 31.4142 3.14051 34.111 6.50834C35.2587 7.94201 37.5082 10.6902 36.3385 17.4167M20.1667 7.65601C19.7609 7.32356 19.3398 6.94101 18.9035 6.50834C14.6758 2.32101 8.91916 3.14051 6.22233 6.50834C4.35966 8.83668 -0.407002 14.63 11.2603 35.2733C11.7443 36.1277 12.7068 36.6667 13.7427 36.6667C15.3963 36.6667 16.6888 35.3467 16.742 33.8067C16.8263 31.4178 17.2883 28.7558 18.5772 27.5M29.3333 31.1667L30.5873 32.4207C30.8568 32.6902 30.9925 32.8258 31.1557 32.8167C31.3207 32.8075 31.4398 32.659 31.6782 32.3602L34.8333 28.4167M23.8333 28.3323V29.04C23.8333 31.2437 23.8333 32.3455 24.1047 33.3538C24.4437 34.6045 25.0817 35.754 25.9637 36.7033C26.6787 37.477 27.6247 38.0783 29.5148 39.2828C30.36 39.8218 30.7835 40.0913 31.2345 40.2178C31.79 40.3718 32.3785 40.3718 32.934 40.2178C33.3832 40.0913 33.8067 39.8218 34.6518 39.2828C36.542 38.0783 37.488 37.477 38.203 36.7033C39.085 35.754 39.723 34.6045 40.062 33.3538C40.3333 32.3455 40.3333 31.2455 40.3333 29.04V28.3323C40.3333 26.961 40.3333 26.2753 40.073 25.696C39.9096 25.3384 39.6801 25.0149 39.3965 24.7427C38.9327 24.3027 38.2745 24.0607 36.9582 23.5785L34.2558 22.5885C33.1815 22.1962 32.6443 22 32.0833 22C31.5223 22 30.9852 22.1962 29.9108 22.5903L27.2085 23.5803C25.8922 24.0607 25.234 24.3008 24.7702 24.7427C24.4859 25.0148 24.2557 25.3383 24.0918 25.696C23.8333 26.2753 23.8333 26.961 23.8333 28.3323Z"
            stroke="#003366"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },

    {
      id: 51,
      name: "Healthcare Providers",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33 36.6667L40.0107 29.656C40.217 29.4499 40.3331 29.1703 40.3333 28.8787V19.25C40.3333 18.5207 40.0436 17.8212 39.5279 17.3055C39.0122 16.7897 38.3127 16.5 37.5833 16.5C36.854 16.5 36.1545 16.7897 35.6388 17.3055C35.1231 17.8212 34.8333 18.5207 34.8333 19.25V27.5"
            stroke="#003366"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33 29.3333L34.573 27.7603C34.656 27.6781 34.7217 27.5801 34.7664 27.4721C34.8111 27.3641 34.8339 27.2484 34.8333 27.1315C34.8321 26.9669 34.7855 26.8057 34.6989 26.6657C34.6122 26.5257 34.4888 26.4123 34.342 26.3377L33.5298 25.9325C32.8418 25.5885 32.0629 25.4696 31.3035 25.5926C30.5442 25.7157 29.8427 26.0744 29.2985 26.6182L27.6577 28.259C26.97 28.9465 26.5835 29.879 26.5833 30.8513V36.6667M11 36.6667L3.98934 29.656C3.78299 29.4499 3.66693 29.1703 3.66667 28.8787V19.25C3.66667 18.5207 3.9564 17.8212 4.47213 17.3055C4.98785 16.7897 5.68733 16.5 6.41667 16.5C7.14602 16.5 7.84549 16.7897 8.36122 17.3055C8.87694 17.8212 9.16667 18.5207 9.16667 19.25V27.5"
            stroke="#003366"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 29.3333L9.42701 27.7603C9.26275 27.5919 9.16954 27.3667 9.16667 27.1315C9.16667 26.796 9.35734 26.4898 9.65801 26.3376L10.4702 25.9325C11.1582 25.5884 11.9371 25.4695 12.6965 25.5926C13.4558 25.7156 14.1573 26.0744 14.7015 26.6181L16.3423 28.259C17.03 28.9465 17.4165 29.8789 17.4167 30.8513V36.6666M25.0562 22H18.9438V17.7228H14.6667V11.6105H18.9438V7.33331H25.0562V11.6105H29.3333V17.7228H25.0562V22Z"
            stroke="#003366"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },

    {
      id: 52,
      name: "Pharmaceuticals and Biotechnology",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7339 5.59535L16.8052 3.66669L15.6108 4.8611L17.402 6.65227L6.65225 17.402L4.86108 15.6109L3.66666 16.8053L5.59533 18.7339C7.16809 20.3066 9.08643 21.4903 11.1975 22.1905C13.3086 22.8908 15.554 23.0883 17.7549 22.7673C17.8924 22.1586 18.0666 21.556 18.2774 20.9596C16.4303 21.3474 14.5374 21.3098 12.7352 20.8753L20.8752 12.7353C21.4886 15.2642 21.3012 17.9212 20.339 20.339L20.3335 20.3528C20.2926 20.453 20.251 20.5529 20.2088 20.6525C19.8541 21.6517 19.9549 21.3886 19.9549 21.3886L19.8871 21.5793L14.6667 26.7988L22.9387 35.0708C24.5476 36.6793 26.7296 37.5829 29.0047 37.5829C31.2798 37.5829 33.4618 36.6793 35.0707 35.0708C36.6792 33.4618 37.5828 31.2798 37.5828 29.0047C37.5828 26.7296 36.6792 24.5477 35.0707 22.9387L26.7987 14.6667L22.5482 18.9173C23.0953 16.5555 23.0323 14.0934 22.365 11.7627C21.6977 9.43206 20.4481 7.30963 18.7339 5.59535ZM10.9294 20.2914L20.2922 10.9294C19.8498 9.84593 19.258 8.82959 18.5341 7.90994L7.90991 18.5341C8.82962 19.2577 9.84596 19.8491 10.9294 20.2914ZM20.8202 25.9408L25.6511 30.8633C26.4871 31.7139 27.4367 32.1209 28.3351 32.1439C29.2261 32.1668 30.1547 31.8148 30.9705 30.9824L32.2795 32.2667C31.1392 33.429 29.7312 34.0139 28.2883 33.9763C26.8501 33.9396 25.465 33.2888 24.3439 32.1475L19.5131 27.225L20.8202 25.9408Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 53,
      name: "Medical Devices and Equipment",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.33332 40.3334C6.32499 40.3334 5.4621 39.9746 4.74466 39.2572C4.02721 38.5397 3.66788 37.6762 3.66666 36.6667V14.6667C3.66666 13.6584 4.02599 12.7955 4.74466 12.078C5.46332 11.3606 6.32621 11.0012 7.33332 11H14.6667V7.33335C14.6667 6.32502 15.026 5.46213 15.7447 4.74469C16.4633 4.02724 17.3262 3.66791 18.3333 3.66669H25.6667C26.675 3.66669 27.5385 4.02602 28.2572 4.74469C28.9758 5.46335 29.3345 6.32624 29.3333 7.33335V11H36.6667C37.675 11 38.5385 11.3594 39.2572 12.078C39.9758 12.7967 40.3345 13.6596 40.3333 14.6667V36.6667C40.3333 37.675 39.9746 38.5385 39.2572 39.2572C38.5397 39.9759 37.6762 40.3346 36.6667 40.3334H7.33332ZM18.3333 11H25.6667V7.33335H18.3333V11ZM20.1667 27.5V31.1667C20.1667 31.6861 20.3427 32.1219 20.6947 32.4739C21.0467 32.8259 21.4818 33.0012 22 33C22.5182 32.9988 22.9539 32.8228 23.3072 32.472C23.6604 32.1212 23.8358 31.6861 23.8333 31.1667V27.5H27.5C28.0194 27.5 28.4552 27.324 28.8072 26.972C29.1592 26.62 29.3345 26.1849 29.3333 25.6667C29.3321 25.1485 29.1561 24.7134 28.8053 24.3614C28.4545 24.0094 28.0194 23.8334 27.5 23.8334H23.8333V20.1667C23.8333 19.6472 23.6573 19.2121 23.3053 18.8614C22.9533 18.5106 22.5182 18.3346 22 18.3334C21.4818 18.3321 21.0467 18.5081 20.6947 18.8614C20.3427 19.2146 20.1667 19.6497 20.1667 20.1667V23.8334H16.5C15.9805 23.8334 15.5454 24.0094 15.1947 24.3614C14.8439 24.7134 14.6679 25.1485 14.6667 25.6667C14.6654 26.1849 14.8414 26.6206 15.1947 26.9739C15.5479 27.3271 15.983 27.5025 16.5 27.5H20.1667Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 53,
      name: "Health Insurance",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5833 6.41669C15.5833 5.68734 15.8731 4.98787 16.3888 4.47214C16.9045 3.95642 17.604 3.66669 18.3333 3.66669H25.6667C26.396 3.66669 27.0955 3.95642 27.6112 4.47214C28.1269 4.98787 28.4167 5.68734 28.4167 6.41669H31.1667C31.896 6.41669 32.5955 6.70642 33.1112 7.22214C33.6269 7.73787 33.9167 8.43734 33.9167 9.16669V22.9167H32.0833V9.16669C32.0833 8.92357 31.9868 8.69041 31.8149 8.51851C31.643 8.3466 31.4098 8.25002 31.1667 8.25002H28.4167C28.4167 8.97937 28.1269 9.67884 27.6112 10.1946C27.0955 10.7103 26.396 11 25.6667 11H18.3333C17.604 11 16.9045 10.7103 16.3888 10.1946C15.8731 9.67884 15.5833 8.97937 15.5833 8.25002H12.8333C12.5902 8.25002 12.3571 8.3466 12.1852 8.51851C12.0133 8.69041 11.9167 8.92357 11.9167 9.16669V34.8334C11.9167 35.0765 12.0133 35.3096 12.1852 35.4815C12.3571 35.6534 12.5902 35.75 12.8333 35.75H23.8333V37.5834H12.8333C12.104 37.5834 11.4045 37.2936 10.8888 36.7779C10.3731 36.2622 10.0833 35.5627 10.0833 34.8334V9.16669C10.0833 8.43734 10.3731 7.73787 10.8888 7.22214C11.4045 6.70642 12.104 6.41669 12.8333 6.41669H15.5833ZM18.3333 5.50002C18.0902 5.50002 17.8571 5.5966 17.6852 5.76851C17.5133 5.94041 17.4167 6.17357 17.4167 6.41669V8.25002C17.4167 8.49314 17.5133 8.72629 17.6852 8.8982C17.8571 9.07011 18.0902 9.16669 18.3333 9.16669H25.6667C25.9098 9.16669 26.143 9.07011 26.3149 8.8982C26.4868 8.72629 26.5833 8.49314 26.5833 8.25002V6.41669C26.5833 6.17357 26.4868 5.94041 26.3149 5.76851C26.143 5.5966 25.9098 5.50002 25.6667 5.50002H18.3333ZM21.0833 14.6667V17.4167H18.3333V19.25H21.0833V22H22.9167V19.25H25.6667V17.4167H22.9167V14.6667H21.0833ZM25.6667 24.75C25.4236 24.75 25.1904 24.8466 25.0185 25.0185C24.8466 25.1904 24.75 25.4236 24.75 25.6667V31.8899C24.7501 32.9462 25.0109 33.9862 25.5093 34.9175C26.0077 35.8488 26.7284 36.6427 27.6073 37.2286L30.6579 39.2636C30.8086 39.3641 30.9856 39.4177 31.1667 39.4177C31.3478 39.4177 31.5248 39.3641 31.6754 39.2636L34.7261 37.2286C35.6048 36.6427 36.3254 35.849 36.8238 34.9179C37.3223 33.9868 37.5832 32.947 37.5833 31.8909V25.6667C37.5833 25.4236 37.4868 25.1904 37.3149 25.0185C37.143 24.8466 36.9098 24.75 36.6667 24.75H25.6667ZM34.5648 29.9814L30.8981 33.6481C30.7262 33.82 30.4931 33.9165 30.25 33.9165C30.0069 33.9165 29.7738 33.82 29.6019 33.6481L27.7686 31.8148L29.0648 30.5186L30.25 31.7039L33.2686 28.6853L34.5648 29.9814Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 54,
      name: "Health IT and Digital Health",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 16.5C20.2278 16.5 18.7153 15.8736 17.4625 14.6209C16.2097 13.3681 15.5834 11.8556 15.5834 10.0834C15.5834 8.31113 16.2097 6.79863 17.4625 5.54585C18.7153 4.29308 20.2278 3.66669 22 3.66669C23.7722 3.66669 25.2847 4.29308 26.5375 5.54585C27.7903 6.79863 28.4167 8.31113 28.4167 10.0834C28.4167 11.8556 27.7903 13.3681 26.5375 14.6209C25.2847 15.8736 23.7722 16.5 22 16.5ZM19.3875 37.7209L11 29.3334C10.3889 28.7222 9.93058 28.0347 9.62502 27.2709C9.31946 26.507 9.16669 25.6667 9.16669 24.75C9.16669 22.9472 9.78574 21.4268 11.0239 20.1887C12.262 18.9506 13.7818 18.3321 15.5834 18.3334C16.4695 18.3334 17.2871 18.5014 18.0364 18.8375C18.7856 19.1736 19.4651 19.6472 20.075 20.2584L22 22.1834L23.925 20.2584C24.5361 19.6472 25.2163 19.1736 25.9655 18.8375C26.7147 18.5014 27.5318 18.3334 28.4167 18.3334C30.2195 18.3334 31.7399 18.9524 32.978 20.1905C34.2161 21.4286 34.8346 22.9485 34.8334 24.75C34.8334 25.6667 34.6806 26.507 34.375 27.2709C34.0695 28.0347 33.6111 28.7222 33 29.3334L24.6125 37.7209C24.2459 38.0875 23.8334 38.3625 23.375 38.5459C22.9167 38.7292 22.4584 38.8209 22 38.8209C21.5417 38.8209 21.0834 38.7292 20.625 38.5459C20.1667 38.3625 19.7542 38.0875 19.3875 37.7209Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 55,
      name: "Public Health",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33 36.6667L40.0107 29.656C40.217 29.4499 40.3331 29.1703 40.3333 28.8787V19.25C40.3333 18.5207 40.0436 17.8212 39.5279 17.3055C39.0122 16.7897 38.3127 16.5 37.5833 16.5C36.854 16.5 36.1545 16.7897 35.6388 17.3055C35.1231 17.8212 34.8333 18.5207 34.8333 19.25V27.5"
            stroke="#003366"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33 29.3333L34.573 27.7603C34.656 27.6781 34.7217 27.5801 34.7664 27.4721C34.8111 27.3641 34.8339 27.2484 34.8333 27.1315C34.832 26.9669 34.7855 26.8057 34.6989 26.6657C34.6122 26.5257 34.4888 26.4123 34.342 26.3377L33.5298 25.9325C32.8418 25.5885 32.0629 25.4696 31.3035 25.5926C30.5442 25.7157 29.8427 26.0744 29.2985 26.6182L27.6577 28.259C26.97 28.9465 26.5835 29.879 26.5833 30.8513V36.6667M11 36.6667L3.98933 29.656C3.78298 29.4499 3.66692 29.1703 3.66666 28.8787V19.25C3.66666 18.5207 3.9564 17.8212 4.47212 17.3055C4.98785 16.7897 5.68732 16.5 6.41666 16.5C7.14601 16.5 7.84548 16.7897 8.36121 17.3055C8.87693 17.8212 9.16666 18.5207 9.16666 19.25V27.5"
            stroke="#003366"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0314 8.15204C18.0314 7.09951 18.4495 6.09009 19.1938 5.34584C19.9381 4.60159 20.9475 4.18347 22 4.18347C23.0525 4.18347 24.062 4.60159 24.8062 5.34584C25.5505 6.09009 25.9686 7.09951 25.9686 8.15204C25.9686 9.20457 25.5505 10.214 24.8062 10.9582C24.062 11.7025 23.0525 12.1206 22 12.1206C20.9475 12.1206 19.9381 11.7025 19.1938 10.9582C18.4495 10.214 18.0314 9.20457 18.0314 8.15204ZM14.1931 14.6526C15.001 13.8857 16.0724 13.4582 17.1863 13.4582C18.3002 13.4582 19.3716 13.8857 20.1794 14.6526L20.1966 14.6698L22 16.4732L23.8051 14.6698L23.8223 14.6526C24.63 13.8867 25.7006 13.4598 26.8137 13.4598C27.9268 13.4598 28.9975 13.8867 29.8051 14.6526C30.2059 15.0334 30.5251 15.4916 30.7434 15.9994C30.9616 16.5073 31.0744 17.0542 31.0749 17.6069C31.0754 18.1597 30.9636 18.7068 30.7462 19.215C30.5288 19.7233 30.2104 20.182 29.8103 20.5635L22.5966 27.5749C22.4366 27.7304 22.2223 27.8174 21.9991 27.8174C21.776 27.8174 21.5617 27.7304 21.4017 27.5749L14.1897 20.5635C13.7898 20.1822 13.4715 19.7236 13.2541 19.2156C13.0367 18.7076 12.9248 18.1607 12.9251 17.6082C12.9255 17.0556 13.038 16.5089 13.256 16.0011C13.4739 15.4934 13.7928 15.0334 14.1931 14.6526Z"
            fill="#003366"
          />
          <path
            d="M11 29.3333L9.427 27.7603C9.26274 27.5919 9.16953 27.3668 9.16666 27.1315C9.16666 26.796 9.35733 26.4898 9.658 26.3377L10.4702 25.9325C11.1582 25.5885 11.9371 25.4696 12.6965 25.5926C13.4558 25.7157 14.1573 26.0745 14.7015 26.6182L16.3423 28.259C17.03 28.9465 17.4165 29.879 17.4167 30.8513V36.6667"
            stroke="#003366"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },

    {
      id: 56,
      name: "Long-term Care and Elderly Services",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 16.5C20.2278 16.5 18.7153 15.8736 17.4625 14.6209C16.2097 13.3681 15.5834 11.8556 15.5834 10.0834C15.5834 8.31113 16.2097 6.79863 17.4625 5.54585C18.7153 4.29308 20.2278 3.66669 22 3.66669C23.7722 3.66669 25.2847 4.29308 26.5375 5.54585C27.7903 6.79863 28.4167 8.31113 28.4167 10.0834C28.4167 11.8556 27.7903 13.3681 26.5375 14.6209C25.2847 15.8736 23.7722 16.5 22 16.5ZM19.3875 37.7209L11 29.3334C10.3889 28.7222 9.93058 28.0347 9.62502 27.2709C9.31946 26.507 9.16669 25.6667 9.16669 24.75C9.16669 22.9472 9.78574 21.4268 11.0239 20.1887C12.262 18.9506 13.7818 18.3321 15.5834 18.3334C16.4695 18.3334 17.2871 18.5014 18.0364 18.8375C18.7856 19.1736 19.4651 19.6472 20.075 20.2584L22 22.1834L23.925 20.2584C24.5361 19.6472 25.2163 19.1736 25.9655 18.8375C26.7147 18.5014 27.5318 18.3334 28.4167 18.3334C30.2195 18.3334 31.7399 18.9524 32.978 20.1905C34.2161 21.4286 34.8346 22.9485 34.8334 24.75C34.8334 25.6667 34.6806 26.507 34.375 27.2709C34.0695 28.0347 33.6111 28.7222 33 29.3334L24.6125 37.7209C24.2459 38.0875 23.8334 38.3625 23.375 38.5459C22.9167 38.7292 22.4584 38.8209 22 38.8209C21.5417 38.8209 21.0834 38.7292 20.625 38.5459C20.1667 38.3625 19.7542 38.0875 19.3875 37.7209Z"
            fill="#003366"
          />
        </svg>
      ),
    },

    {
      id: 57,
      name: "Health Education and Training",
      svg: (
        <svg
          width="45"
          height="44"
          viewBox="0 0 45 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.67116 33.4716C7.29854 33.4774 6.9285 33.4085 6.58258 33.2689C6.23666 33.1293 5.92177 32.9218 5.65625 32.6584C5.39072 32.3951 5.17987 32.0812 5.03596 31.735C4.89205 31.3887 4.81796 31.0172 4.81801 30.6418C4.81805 30.2665 4.89223 29.895 5.03622 29.5488C5.18022 29.2026 5.39115 28.8888 5.65673 28.6255C5.92232 28.3622 6.23726 28.1548 6.58322 28.0152C6.92917 27.8757 7.29923 27.8069 7.67184 27.8128C8.40934 27.8245 9.11272 28.1277 9.63013 28.6572C10.1475 29.1866 10.4375 29.8997 10.4374 30.6425C10.4373 31.3854 10.1472 32.0984 9.62965 32.6277C9.11211 33.157 8.40866 33.4601 7.67116 33.4716ZM2.01353 43.7332V38.1892C2.01353 36.19 3.64433 34.5654 5.63146 34.5654H9.51084C11.498 34.5654 13.2728 36.19 13.2728 38.1892V43.7332H2.01353ZM36.7969 33.2317C37.5419 33.2308 38.256 32.9322 38.7827 32.4016C39.3093 31.8709 39.6054 31.1515 39.6059 30.4012C39.6142 30.0245 39.5476 29.6498 39.4101 29.2993C39.2727 28.9488 39.0671 28.6295 38.8054 28.3601C38.5438 28.0907 38.2313 27.8766 37.8864 27.7305C37.5415 27.5844 37.1711 27.5091 36.7969 27.5091C36.4227 27.5091 36.0523 27.5844 35.7074 27.7305C35.3625 27.8766 35.05 28.0907 34.7884 28.3601C34.5267 28.6295 34.3211 28.9488 34.1837 29.2993C34.0462 29.6498 33.9796 30.0245 33.9879 30.4012C33.9884 31.1515 34.2845 31.8709 34.8111 32.4016C35.3378 32.9322 36.0519 33.2308 36.7969 33.2317ZM42.4518 43.7332V38.1892C42.4518 36.19 40.821 34.5654 38.8325 34.5654H34.9572C32.9667 34.5654 31.1946 36.19 31.1946 38.1892V43.7332H42.4518ZM22.2289 33.4565C20.6589 33.4565 19.3871 32.1853 19.3871 30.6185C19.3871 29.0517 20.6589 27.7798 22.2289 27.7798C23.7976 27.7798 25.0693 29.051 25.0693 30.6185C25.0693 32.186 23.7983 33.4565 22.2289 33.4565ZM15.3856 43.7332L17.6218 37.5973C18.5175 34.463 21.1258 34.5599 21.1258 34.5599H23.3395C23.3395 34.5599 25.9465 34.4637 26.8435 37.5973L29.0798 43.7332H15.3856ZM22.2289 24.1972V17.4838L21.1224 16.3694V23.0794H4.38225V1.73385H21.1224V12.6995L22.2289 13.8132V0.618042H3.2798V24.1965L22.2289 24.1972Z"
            fill="#003366"
          />
          <path
            d="M12.5895 6.32161C12.9746 6.30502 13.3384 6.13929 13.6051 5.85901C13.8717 5.57872 14.0206 5.20554 14.0206 4.81736C14.0206 4.42918 13.8717 4.056 13.6051 3.77572C13.3384 3.49543 12.9746 3.3297 12.5895 3.31311C12.1934 3.31311 11.8135 3.47159 11.5334 3.7537C11.2533 4.0358 11.0959 4.41841 11.0959 4.81736C11.0959 5.21631 11.2533 5.59892 11.5334 5.88103C11.8135 6.16313 12.1934 6.32161 12.5895 6.32161ZM17.5215 12.573C17.5215 12.573 16.2962 8.38136 16.2941 8.37792C15.8061 6.74649 14.4394 6.7953 14.4394 6.7953H10.7423C10.7423 6.7953 9.37364 6.74649 8.88624 8.37792L7.66092 12.573C7.63557 12.6544 7.62657 12.74 7.63443 12.8248C7.6423 12.9097 7.66688 12.9921 7.70673 13.0673C7.74659 13.1425 7.80092 13.2089 7.86656 13.2627C7.93219 13.3165 8.00782 13.3566 8.08901 13.3806C8.1702 13.4046 8.25533 13.4121 8.33943 13.4026C8.42353 13.3932 8.50491 13.3669 8.57881 13.3254C8.65272 13.2839 8.71767 13.2279 8.76987 13.1608C8.82207 13.0938 8.86047 13.0169 8.88283 12.9347L10.0529 8.92311L10.0556 8.92449L10.5771 8.92311V13.4881L8.51762 20.6065C8.47945 20.7377 8.47214 20.876 8.49628 21.0105C8.52042 21.145 8.57535 21.272 8.6567 21.3814C8.73805 21.4909 8.84359 21.5797 8.96495 21.6409C9.08631 21.7021 9.22017 21.7339 9.35589 21.734C9.73475 21.734 10.0843 21.4844 10.1962 21.1008L12.2304 14.0718H12.9506L14.9848 21.1008C15.0171 21.2117 15.0707 21.3151 15.1426 21.4052C15.2145 21.4953 15.3033 21.5702 15.404 21.6256C15.5047 21.6811 15.6152 21.7161 15.7293 21.7285C15.8433 21.741 15.9587 21.7307 16.0689 21.6982C16.1791 21.6659 16.2818 21.6119 16.3713 21.5395C16.4608 21.4671 16.5353 21.3777 16.5904 21.2763C16.6456 21.1749 16.6803 21.0636 16.6927 20.9486C16.7052 20.8337 16.695 20.7174 16.6628 20.6065L14.6033 13.4915V8.9238L15.1248 8.92517L15.1275 8.9238L16.2989 12.9354C16.3465 13.0986 16.4566 13.236 16.6048 13.3175C16.6782 13.3578 16.7588 13.3832 16.8419 13.3922C16.9251 13.4012 17.0092 13.3936 17.0894 13.3699C17.1696 13.3461 17.2444 13.3067 17.3095 13.2538C17.3746 13.201 17.4288 13.1357 17.4688 13.0618C17.5089 12.9879 17.5341 12.9067 17.543 12.823C17.5519 12.7392 17.5444 12.6545 17.5208 12.5737L17.5215 12.573ZM36.7839 11.9412C36.0507 11.9249 35.353 11.6202 34.8402 11.0922C34.3274 10.5642 34.0402 9.85491 34.0402 9.1163C34.0402 8.37769 34.3274 7.66844 34.8402 7.14044C35.353 6.61243 36.0507 6.30765 36.7839 6.29136C37.1524 6.29109 37.5173 6.36403 37.8577 6.50601C38.1981 6.648 38.5073 6.85622 38.7677 7.11877C39.028 7.38132 39.2344 7.69302 39.375 8.03603C39.5155 8.37904 39.5875 8.7466 39.5868 9.11767C39.5874 9.48859 39.5154 9.85598 39.3747 10.1988C39.2341 10.5416 39.0277 10.8531 38.7673 11.1154C38.5069 11.3777 38.1977 11.5857 37.8573 11.7274C37.517 11.8691 37.1522 11.9418 36.7839 11.9412ZM36.7839 16.1425C36.7839 16.1425 37.4645 16.2312 37.8809 15.6503C38.2577 15.1195 38.2857 13.3609 38.2884 13.0426H35.2767C35.2664 14.3083 35.4125 15.2309 35.7129 15.6957C36.016 16.17 36.7839 16.1432 36.7839 16.1432V16.1425Z"
            fill="#003366"
          />
          <path
            d="M24.5621 18.6333C24.4591 18.8038 24.2986 19.1503 24.2986 19.3689C24.2986 20.0289 24.8277 20.5589 25.481 20.5589H29.3699C29.8116 20.5589 30.3918 20.3795 30.6396 20.0055C31.4758 18.7549 32.3598 17.437 32.6206 17.0431V24.4488H42.4149V16.854C42.4149 14.8678 40.8742 13.0796 39.0516 13.0796C39.0564 14.0119 38.9322 15.5601 38.3902 16.238C37.8243 16.9303 37.158 16.8698 37.158 16.8698V19.7594C37.3679 19.8457 37.5415 20.0028 37.6489 20.2039C37.7563 20.4051 37.7909 20.6375 37.7466 20.8615C37.7024 21.0855 37.5821 21.2869 37.4064 21.4313C37.2308 21.5757 37.0107 21.654 36.7839 21.6528C36.6555 21.6529 36.5283 21.6274 36.4097 21.5779C36.291 21.5284 36.1833 21.4558 36.0925 21.3643C36.0018 21.2728 35.9298 21.1642 35.8809 21.0446C35.8319 20.925 35.8068 20.7969 35.8071 20.6676C35.8071 20.2585 36.0542 19.9079 36.4078 19.7594V16.8568C36.4078 16.8568 35.8262 16.9049 35.2767 16.3501C34.5429 15.5801 34.5156 13.3979 34.5169 13.0411H34.3388C33.7464 13.0405 33.1631 13.1874 32.6409 13.4688C32.1186 13.7502 31.6736 14.1574 31.3454 14.654L29.017 18.1926L25.4844 18.1912L20.4957 13.1663C20.4513 13.121 20.3984 13.0852 20.3401 13.0607C20.2818 13.0362 20.2193 13.0236 20.1561 13.0236C20.0929 13.0236 20.0304 13.0362 19.9721 13.0607C19.9138 13.0852 19.8609 13.121 19.8165 13.1663C19.7716 13.2111 19.736 13.2645 19.7117 13.3232C19.6873 13.382 19.6747 13.445 19.6746 13.5087C19.6745 13.5724 19.6868 13.6354 19.7109 13.6943C19.735 13.7532 19.7705 13.8066 19.8151 13.8517L24.5628 18.6339L24.5621 18.6333Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 58,
      name: "Alternative and Holistic Medicine",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 39.4167H27.4587C27.5345 36.9075 27.9024 35.5279 28.5624 35.278C35.4466 32.6655 40.3333 26.0645 40.3333 18.3334H3.66666C3.66666 25.8968 8.34441 32.3795 14.9939 35.1029C15.6887 35.3877 16.2079 36.8256 16.5513 39.4167H22Z"
            stroke="#003366"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M13.2394 24.7711C13.5694 25.8589 14.0054 26.7579 14.5475 27.468C15.1127 28.1952 15.7724 28.8438 16.5092 29.3966M23.1128 18.3572C25.1459 14.1733 27.1693 9.98477 29.183 5.79156C30.1455 3.76573 32.098 3.27806 33.8992 4.04806C35.7005 4.81806 36.4292 7.01989 35.673 8.55531C35.2055 9.50375 33.6197 12.7643 30.9155 18.3371"
            stroke="#003366"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ),
    },

    {
      id: 59,
      name: "Veterinary Services",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 39.4167H27.4587C27.5345 36.9075 27.9024 35.5279 28.5624 35.278C35.4466 32.6655 40.3333 26.0645 40.3333 18.3334H3.66666C3.66666 25.8968 8.34441 32.3795 14.9939 35.1029C15.6887 35.3877 16.2079 36.8256 16.5513 39.4167H22Z"
            stroke="#003366"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M13.2394 24.7711C13.5694 25.8589 14.0054 26.7579 14.5475 27.468C15.1127 28.1952 15.7724 28.8438 16.5092 29.3966M23.1128 18.3572C25.1459 14.1733 27.1693 9.98477 29.183 5.79156C30.1455 3.76573 32.098 3.27806 33.8992 4.04806C35.7005 4.81806 36.4292 7.01989 35.673 8.55531C35.2055 9.50375 33.6197 12.7643 30.9155 18.3371"
            stroke="#003366"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ),
    },

    {
      id: 60,
      name: "Medical Research",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.6667 31.1666V27.5H18.6542C18.5014 28.1111 18.4024 28.7222 18.3572 29.3333C18.3119 29.9444 18.3193 30.5555 18.3792 31.1666H14.6667ZM14.6667 40.3333C12.1306 40.3333 9.96906 39.4392 8.18217 37.6511C6.39528 35.863 5.50122 33.7015 5.5 31.1666V14.6666C4.49167 14.6666 3.62878 14.3079 2.91134 13.5905C2.19389 12.873 1.83456 12.0095 1.83334 11V7.33329C1.83334 6.32496 2.19267 5.46207 2.91134 4.74463C3.63 4.02718 4.49289 3.66785 5.5 3.66663H23.8333C24.8417 3.66663 25.7052 4.02596 26.4238 4.74463C27.1425 5.46329 27.5012 6.32618 27.5 7.33329V11C27.5 12.0083 27.1413 12.8718 26.4238 13.5905C25.7064 14.3091 24.8429 14.6678 23.8333 14.6666V20.2125C23.1 20.6708 22.4278 21.2055 21.8167 21.8166C21.2056 22.4277 20.6708 23.1 20.2125 23.8333H14.6667V20.1666H20.1667V14.6666H9.16667V31.1666C9.16667 32.6944 9.70139 33.993 10.7708 35.0625C11.8403 36.1319 13.1389 36.6666 14.6667 36.6666C15.5833 36.6666 16.4163 36.468 17.1655 36.0708C17.9147 35.6736 18.5484 35.1236 19.0667 34.4208C19.3111 35.0319 19.5861 35.6125 19.8917 36.1625C20.1972 36.7125 20.5639 37.2472 20.9917 37.7666C20.1667 38.5611 19.2194 39.1875 18.15 39.6458C17.0806 40.1041 15.9194 40.3333 14.6667 40.3333ZM30.25 34.8333C31.5333 34.8333 32.6181 34.3902 33.5042 33.5041C34.3903 32.618 34.8333 31.5333 34.8333 30.25C34.8333 28.9666 34.3903 27.8819 33.5042 26.9958C32.6181 26.1097 31.5333 25.6666 30.25 25.6666C28.9667 25.6666 27.8819 26.1097 26.9958 26.9958C26.1097 27.8819 25.6667 28.9666 25.6667 30.25C25.6667 31.5333 26.1097 32.618 26.9958 33.5041C27.8819 34.3902 28.9667 34.8333 30.25 34.8333ZM39.6 42.1666L34.65 37.2166C33.9778 37.6444 33.275 37.9652 32.5417 38.1791C31.8083 38.393 31.0444 38.5 30.25 38.5C27.9583 38.5 26.0107 37.6982 24.4072 36.0946C22.8036 34.4911 22.0012 32.5428 22 30.25C21.9988 27.9571 22.8012 26.0095 24.4072 24.4071C26.0132 22.8048 27.9608 22.0024 30.25 22C32.5392 21.9975 34.4874 22.7999 36.0947 24.4071C37.7019 26.0143 38.5037 27.962 38.5 30.25C38.5 31.0444 38.3931 31.8083 38.1792 32.5416C37.9653 33.275 37.6444 33.9777 37.2167 34.65L42.1667 39.6L39.6 42.1666Z"
            fill="#003366"
          />
        </svg>
      ),
    },
    {
      id: 61,
      name: "Nutritional and Wellness Services",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.33334 25.7949C9.19418 25.7949 11.7902 25.2412 13.42 26.4366L16.6503 28.8016C17.8512 29.6816 19.151 29.3919 20.4912 29.1829C22.2548 28.9061 23.8333 30.4112 23.8333 32.3692C23.8333 32.9046 20.0328 34.2667 19.4847 34.5252C18.9569 34.7748 18.371 34.8756 17.7901 34.8168C17.2092 34.758 16.6554 34.5419 16.1883 34.1916L12.5437 31.5204"
            stroke="#003366"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.8333 31.1666L31.3335 27.7016C31.995 27.4731 32.7084 27.4406 33.3879 27.6081C34.0673 27.7756 34.6839 28.136 35.1633 28.6458L36.3917 29.931C36.8317 30.3893 36.729 31.163 36.1845 31.4783L21.7855 39.8401C21.3601 40.0894 20.888 40.2485 20.3985 40.3075C19.909 40.3665 19.4126 40.3241 18.9402 40.183L7.33334 36.7161M22.0037 22C22.0037 22 25.8537 17.8951 25.8537 12.8333C25.8537 7.77146 22.0037 3.66663 22.0037 3.66663C22.0037 3.66663 18.1537 7.77146 18.1537 12.8333C18.1537 17.8951 22.0037 22 22.0037 22ZM22.0037 22C22.0037 22 27.6265 21.8753 31.1703 18.26C34.7142 14.6428 34.837 8.90446 34.837 8.90446C34.837 8.90446 32.5087 8.95579 29.9053 9.95679M22.0037 22C22.0037 22 16.3808 21.8753 12.837 18.26C9.29318 14.6428 9.17034 8.90446 9.17034 8.90446C9.17034 8.90446 11.4987 8.95579 14.102 9.95679"
            stroke="#003366"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },

    {
      id: 62,
      name: "Medical Tourism",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.3333 11C29.3333 7.54229 29.3333 5.81529 28.259 4.74096C27.1847 3.66663 25.4577 3.66663 22 3.66663C18.5423 3.66663 16.8153 3.66663 15.741 4.74096C14.6667 5.81529 14.6667 7.54229 14.6667 11M3.66666 25.6666C3.66666 18.7531 3.66666 15.2955 5.81532 13.1486C7.96399 11.0018 11.4198 11 18.3333 11H25.6667C32.5802 11 36.0378 11 38.1847 13.1486C40.3315 15.2973 40.3333 18.7531 40.3333 25.6666C40.3333 32.5801 40.3333 36.0378 38.1847 38.1846C36.036 40.3315 32.5802 40.3333 25.6667 40.3333H18.3333C11.4198 40.3333 7.96216 40.3333 5.81532 38.1846C3.66849 36.036 3.66666 32.5801 3.66666 25.6666Z"
            stroke="#003366"
            strokeWidth="2"
          />
          <path
            d="M24.75 25.6666H19.25M22 22.9166V28.4166"
            stroke="#003366"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M22 32.9999C26.0501 32.9999 29.3333 29.7167 29.3333 25.6666C29.3333 21.6165 26.0501 18.3333 22 18.3333C17.9499 18.3333 14.6667 21.6165 14.6667 25.6666C14.6667 29.7167 17.9499 32.9999 22 32.9999Z"
            stroke="#003366"
            strokeWidth="2"
          />
        </svg>
      ),
    },

    {
      id: 63,
      name: "Medical Tourism",
      svg: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.3333 11C29.3333 7.54229 29.3333 5.81529 28.259 4.74096C27.1847 3.66663 25.4577 3.66663 22 3.66663C18.5423 3.66663 16.8153 3.66663 15.741 4.74096C14.6667 5.81529 14.6667 7.54229 14.6667 11M3.66666 25.6666C3.66666 18.7531 3.66666 15.2955 5.81532 13.1486C7.96399 11.0018 11.4198 11 18.3333 11H25.6667C32.5802 11 36.0378 11 38.1847 13.1486C40.3315 15.2973 40.3333 18.7531 40.3333 25.6666C40.3333 32.5801 40.3333 36.0378 38.1847 38.1846C36.036 40.3315 32.5802 40.3333 25.6667 40.3333H18.3333C11.4198 40.3333 7.96216 40.3333 5.81532 38.1846C3.66849 36.036 3.66666 32.5801 3.66666 25.6666Z"
            stroke="#003366"
            strokeWidth="2"
          />
          <path
            d="M24.75 25.6666H19.25M22 22.9166V28.4166"
            stroke="#003366"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M22 32.9999C26.0501 32.9999 29.3333 29.7167 29.3333 25.6666C29.3333 21.6165 26.0501 18.3333 22 18.3333C17.9499 18.3333 14.6667 21.6165 14.6667 25.6666C14.6667 29.7167 17.9499 32.9999 22 32.9999Z"
            stroke="#003366"
            strokeWidth="2"
          />
        </svg>
      ),
    },
  ];
  return (
    <>
      <div className="hrp-main-section health-recruiter-page ">
        <section className=" hrp-container health-recruiter-hrp-section-1">
          <div className="hrp-sub-section  hrp-border-bottom">
            <div className="container m-auto">
              <div className="flex flex-col md:flex-row items-center mx-14 pb-10 pt-24">
                <div
                  data-aos="fade-left"
                  className={`md:w-1/2 mb-8 md:mb-0 hrp-Employees-outer employer-without-relying ${
                    Animate ? "animate-left" : ""
                  }`}
                >
                  <h1
                    className="hrp-Employees-heading font-semibold mb-4 text-[#343434]"
                    style={{
                      color: "#3E3E3E",
                    }}
                  >
                    Looking for Healthcare Professionals?
                  </h1>
                  <p className="xl:text-2xl text-gray-600 mb-4">
                    We specialise in healthcare recruitment to connect you with
                    highly skilled professionals.
                  </p>
                  <button
                    className="py-3 px-12 btnpostjob text-xl"
                    onClick={() => history.push("/post-job")}
                  >
                    Post a Job
                  </button>
                </div>
                <div
                  data-aos="fade-right"
                  className={`flex md:w-1/2 justify-center ${
                    Animate ? "animate-right" : ""
                  }`}
                >
                  <img
                    src={image1}
                    alt="Employees illustration"
                    className="w-full lg:w-full lg:w-1/4 mb-8 md:mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="animate-on-scroll hrp-container  hrp-section-2">
          <div className=" hrp-sub-section ">
            <div className="container m-auto my-20 health-recruiter-processe">
              <div class="max-w-7xl m-auto">
                <h1 class="md:text-3xl text-2xl font-bold text-center mb-4 hrp-hiring-journey">
                  Effortless Hiring Journey: From Posting to Onboarding
                </h1>
                <p class="text-gray-600 mb-12 text-center hrp-testimonials  ">
                  Experience a seamless recruitment process with our intuitive
                  platform. From creating job listings to screening candidates,
                  communicating, and finalising offers, our step-by-step
                  approach ensures you attract the best talent, streamline
                  hiring, and effortlessly onboard new team members to
                  accelerate your growth.
                </p>
              </div>
              <div className="relative vectorcandidate-main ">
                <div className="Vectorcandidate-image">
                  <img
                    className="m-auto"
                    src={Vectorcandidate}
                    alt="Vectorcandidate"
                  ></img>
                </div>
                <div className="lg:flex">
                  <div className="ApplyforJobs-outer firststep">
                    <div>
                      <div className="ApplyforJobs-section">
                        <div>
                          <div className="ApplyforJobs">
                            <div>
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_1314_438)">
                                  <path
                                    d="M40 24.9996V39.9996H20V24.9996H25V19.9996H35V24.9996H40ZM27.5 24.9996H32.5V22.4996H27.5V24.9996ZM37.5 32.4996H35V34.9996H32.5V32.4996H27.5V34.9996H25V32.4996H22.5V37.4996H37.5V32.4996ZM37.5 27.4996H22.5V29.9996H37.5V27.4996ZM30.5664 17.4996C29.8633 16.7054 29.0299 16.0934 28.0664 15.6637C27.1029 15.234 26.0807 15.0127 25 14.9996C23.9583 14.9996 22.9883 15.1949 22.0898 15.5856C21.1914 15.9762 20.3971 16.51 19.707 17.1871C19.0169 17.8642 18.4766 18.665 18.0859 19.5895C17.6953 20.514 17.5 21.484 17.5 22.4996C17.5 23.6975 17.2331 24.8239 16.6992 25.8785C16.1654 26.9332 15.4102 27.8186 14.4336 28.5348C15.0195 28.8343 15.5664 29.1793 16.0742 29.5699C16.582 29.9606 17.0573 30.4033 17.5 30.8981V37.4996C17.5 36.471 17.3047 35.5009 16.9141 34.5895C16.5234 33.678 15.9896 32.8837 15.3125 32.2067C14.6354 31.5296 13.8346 30.9892 12.9102 30.5856C11.9857 30.1819 11.0156 29.9866 10 29.9996C8.95833 29.9996 7.98828 30.1949 7.08984 30.5856C6.19141 30.9762 5.39714 31.51 4.70703 32.1871C4.01693 32.8642 3.47656 33.665 3.08594 34.5895C2.69531 35.514 2.5 36.484 2.5 37.4996H0C0 36.5491 0.130208 35.6311 0.390625 34.7457C0.651042 33.8603 1.02214 33.0205 1.50391 32.2262C1.98568 31.4319 2.57161 30.7288 3.26172 30.1168C3.95182 29.5048 4.72005 28.9775 5.56641 28.5348C4.60286 27.8317 3.85417 26.9528 3.32031 25.8981C2.78646 24.8434 2.51302 23.7106 2.5 22.4996C2.5 21.471 2.69531 20.5009 3.08594 19.5895C3.47656 18.678 4.01042 17.8837 4.6875 17.2067C5.36458 16.5296 6.15885 15.9892 7.07031 15.5856C7.98177 15.1819 8.95833 14.9866 10 14.9996C11.1979 14.9996 12.3242 15.2666 13.3789 15.8004C14.4336 16.3343 15.319 17.0895 16.0352 18.066C16.5299 17.0895 17.1615 16.2171 17.9297 15.4489C18.6979 14.6806 19.5768 14.0426 20.5664 13.5348C19.6029 12.8317 18.8542 11.9528 18.3203 10.8981C17.7865 9.84338 17.513 8.71057 17.5 7.49963C17.5 6.47099 17.6953 5.50094 18.0859 4.58948C18.4766 3.67802 19.0104 2.88375 19.6875 2.20667C20.3646 1.52958 21.1589 0.989217 22.0703 0.585571C22.9818 0.181925 23.9583 -0.013387 25 -0.000366211C26.0286 -0.000366211 26.9987 0.194946 27.9102 0.585571C28.8216 0.976196 29.6159 1.51005 30.293 2.18713C30.9701 2.86422 31.5104 3.665 31.9141 4.58948C32.3177 5.51396 32.513 6.48401 32.5 7.49963C32.5 8.69755 32.2331 9.82385 31.6992 10.8785C31.1654 11.9332 30.4102 12.8186 29.4336 13.5348C30.319 13.9775 31.1198 14.5309 31.8359 15.1949C32.5521 15.859 33.1576 16.6272 33.6523 17.4996H30.5664ZM10 27.4996C10.6901 27.4996 11.3346 27.3694 11.9336 27.109C12.5326 26.8486 13.0664 26.4905 13.5352 26.0348C14.0039 25.5791 14.362 25.0517 14.6094 24.4528C14.8568 23.8538 14.987 23.2028 15 22.4996C15 21.8095 14.8698 21.165 14.6094 20.566C14.349 19.9671 13.9909 19.4332 13.5352 18.9645C13.0794 18.4957 12.5521 18.1377 11.9531 17.8903C11.3542 17.6429 10.7031 17.5127 10 17.4996C9.3099 17.4996 8.66536 17.6298 8.06641 17.8903C7.46745 18.1507 6.93359 18.5087 6.46484 18.9645C5.99609 19.4202 5.63802 19.9475 5.39062 20.5465C5.14323 21.1455 5.01302 21.7965 5 22.4996C5 23.1897 5.13021 23.8343 5.39062 24.4332C5.65104 25.0322 6.00911 25.566 6.46484 26.0348C6.92057 26.5035 7.44792 26.8616 8.04688 27.109C8.64583 27.3564 9.29688 27.4866 10 27.4996ZM20 7.49963C20 8.18974 20.1302 8.83427 20.3906 9.43323C20.651 10.0322 21.0091 10.566 21.4648 11.0348C21.9206 11.5035 22.4479 11.8616 23.0469 12.109C23.6458 12.3564 24.2969 12.4866 25 12.4996C25.6901 12.4996 26.3346 12.3694 26.9336 12.109C27.5326 11.8486 28.0664 11.4905 28.5352 11.0348C29.0039 10.5791 29.362 10.0517 29.6094 9.45276C29.8568 8.8538 29.987 8.20276 30 7.49963C30 6.80953 29.8698 6.165 29.6094 5.56604C29.349 4.96708 28.9909 4.43323 28.5352 3.96448C28.0794 3.49573 27.5521 3.13765 26.9531 2.89026C26.3542 2.64286 25.7031 2.51265 25 2.49963C24.3099 2.49963 23.6654 2.62984 23.0664 2.89026C22.4674 3.15068 21.9336 3.50875 21.4648 3.96448C20.9961 4.42021 20.638 4.94755 20.3906 5.54651C20.1432 6.14547 20.013 6.79651 20 7.49963Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1314_438">
                                    <rect width="40" height="40" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <div className="JobDiscussions">
                              <div className="JobDiscussions-inner"></div>
                            </div>
                          </div>
                          {/* <div className="ApplyforJobs-text">Post Job</div> */}
                        </div>
                      </div>
                      <div className="ApplyforJobs-contents">
                        <p className="text-center">
                          Healthcare Recruitment Experts - Connecting You with
                          Top Talent
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="ApplyforJobs-outer secondstep">
                    <div>
                      <div className="ApplyforJobs-section">
                        <div>
                          <div className="ApplyforJobs">
                            <div>
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M25 9C25 10.3261 24.4732 11.5979 23.5355 12.5355C22.5979 13.4732 21.3261 14 20 14C18.6739 14 17.4021 13.4732 16.4645 12.5355C15.5268 11.5979 15 10.3261 15 9C15 7.67392 15.5268 6.40215 16.4645 5.46447C17.4021 4.52678 18.6739 4 20 4C21.3261 4 22.5979 4.52678 23.5355 5.46447C24.4732 6.40215 25 7.67392 25 9ZM35 10C35 11.0609 34.5786 12.0783 33.8284 12.8284C33.0783 13.5786 32.0609 14 31 14C29.9391 14 28.9217 13.5786 28.1716 12.8284C27.4214 12.0783 27 11.0609 27 10C27 8.93913 27.4214 7.92172 28.1716 7.17157C28.9217 6.42143 29.9391 6 31 6C32.0609 6 33.0783 6.42143 33.8284 7.17157C34.5786 7.92172 35 8.93913 35 10ZM9 14C10.0609 14 11.0783 13.5786 11.8284 12.8284C12.5786 12.0783 13 11.0609 13 10C13 8.93913 12.5786 7.92172 11.8284 7.17157C11.0783 6.42143 10.0609 6 9 6C7.93913 6 6.92172 6.42143 6.17157 7.17157C5.42143 7.92172 5 8.93913 5 10C5 11.0609 5.42143 12.0783 6.17157 12.8284C6.92172 13.5786 7.93913 14 9 14ZM12 18.5C12 17.12 13.12 16 14.5 16H25.5C26.0848 15.9997 26.6513 16.2045 27.1007 16.5787C27.5502 16.9529 27.8543 17.4728 27.96 18.048C25.9727 18.2363 24.0742 18.9618 22.4677 20.1468C20.8613 21.3318 19.6077 22.9315 18.8411 24.7746C18.0745 26.6177 17.8239 28.6347 18.1161 30.6094C18.4084 32.584 19.2324 34.4419 20.5 35.984C19.4095 36.0523 18.3165 35.8965 17.2885 35.5261C16.2606 35.1558 15.3193 34.5788 14.5229 33.8307C13.7265 33.0826 13.0917 32.1793 12.6578 31.1765C12.2239 30.1737 12.0001 29.0927 12 28V18.5ZM29.978 18.042C32.256 18.242 34.334 19.138 36 20.514V18.5C36 17.12 34.88 16 33.5 16H29.242C29.642 16.596 29.902 17.292 29.976 18.042M10 18.5C10 17.574 10.28 16.716 10.758 16H6.5C5.12 16 4 17.12 4 18.5V26C3.99991 26.8562 4.18308 27.7026 4.5372 28.4822C4.89133 29.2617 5.40821 29.9565 6.05311 30.5197C6.69801 31.083 7.456 31.5017 8.27613 31.7477C9.09627 31.9937 9.95956 32.0613 10.808 31.946C10.2738 30.6991 9.9989 29.3565 10 28V18.5ZM38 29C38 31.387 37.0518 33.6761 35.364 35.364C33.6761 37.0518 31.387 38 29 38C26.6131 38 24.3239 37.0518 22.636 35.364C20.9482 33.6761 20 31.387 20 29C20 26.6131 20.9482 24.3239 22.636 22.636C24.3239 20.9482 26.6131 20 29 20C31.387 20 33.6761 20.9482 35.364 22.636C37.0518 24.3239 38 26.6131 38 29ZM30 25C30 24.7348 29.8946 24.4804 29.7071 24.2929C29.5196 24.1054 29.2652 24 29 24C28.7348 24 28.4804 24.1054 28.2929 24.2929C28.1054 24.4804 28 24.7348 28 25V28H25C24.7348 28 24.4804 28.1054 24.2929 28.2929C24.1054 28.4804 24 28.7348 24 29C24 29.2652 24.1054 29.5196 24.2929 29.7071C24.4804 29.8946 24.7348 30 25 30H28V33C28 33.2652 28.1054 33.5196 28.2929 33.7071C28.4804 33.8946 28.7348 34 29 34C29.2652 34 29.5196 33.8946 29.7071 33.7071C29.8946 33.5196 30 33.2652 30 33V30H33C33.2652 30 33.5196 29.8946 33.7071 29.7071C33.8946 29.5196 34 29.2652 34 29C34 28.7348 33.8946 28.4804 33.7071 28.2929C33.5196 28.1054 33.2652 28 33 28H30V25Z"
                                  fill="white"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <div className="JobDiscussions">
                              <div className="JobDiscussions-inner"></div>
                            </div>
                          </div>
                          {/* <div className="ApplyforJobs-text">
                            Invite Candidates
                          </div> */}
                        </div>
                      </div>
                      <div className="ApplyforJobs-contents">
                        <p className="text-center">
                          specialised Healthcare Hiring Solutions for Your
                          Medical Team
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* -------------------------------new section Show Jobs on Your Website end------------------------------------------------ */}
                  <div className="ApplyforJobs-outer thirdstep">
                    <div>
                      <div className="ApplyforJobs-section">
                        <div>
                          <div className="ApplyforJobs">
                            <div>
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_1314_442)">
                                  <path
                                    d="M34.1594 18.404C37.4462 18.404 39.4031 20.3621 39.4031 23.3608V37.3983C39.4031 38.4858 39.3056 39.3665 39.3056 39.3665H24.2956V25.7233H23.6837L20.8975 29.8802C20.4437 30.499 19.5225 30.799 18.7887 30.799H12.2481C11.9898 30.7992 11.734 30.7486 11.4952 30.6499C11.2565 30.5512 11.0395 30.4065 10.8568 30.2239C10.674 30.0414 10.529 29.8246 10.43 29.586C10.331 29.3474 10.2801 29.0917 10.28 28.8333C10.28 27.7496 11.1606 26.894 12.2481 26.894H18.1969L22.3231 20.6527C23.3137 19.1433 25.1469 18.4233 26.8031 18.4233C26.8031 22.8127 27.8969 24.6702 29.8744 24.6702V31.9677C29.5933 32.0882 29.3538 32.2885 29.1855 32.5438C29.0172 32.7991 28.9275 33.0982 28.9275 33.404C28.9266 33.6081 28.9661 33.8103 29.0437 33.9991C29.1214 34.1879 29.2356 34.3594 29.3799 34.5038C29.5242 34.6482 29.6956 34.7626 29.8843 34.8404C30.073 34.9182 30.2752 34.9578 30.4794 34.9571C31.3425 34.9571 32.0337 34.2477 32.0337 33.3827C32.0337 32.739 31.6431 32.1865 31.0869 31.9483V24.6483C33.0631 24.6477 34.1581 22.7927 34.1581 18.404H34.1594ZM32.9262 18.404C32.8912 22.9033 32.1131 23.4952 30.48 23.4952C28.8487 23.4952 28.07 22.9027 28.0356 18.404H32.9262ZM30.4531 8.27083C31.0428 8.27067 31.6267 8.38672 32.1715 8.61236C32.7163 8.838 33.2113 9.1688 33.6282 9.58585C34.045 10.0029 34.3756 10.498 34.601 11.0429C34.8265 11.5878 34.9423 12.1718 34.9419 12.7615C34.9419 13.952 34.469 15.0938 33.6272 15.9357C32.7854 16.7776 31.6437 17.2507 30.4531 17.2508C29.2623 17.2508 28.1202 16.7779 27.278 15.936C26.4358 15.0942 25.9624 13.9523 25.9619 12.7615C25.9619 12.1717 26.078 11.5877 26.3037 11.0428C26.5295 10.498 26.8603 10.0029 27.2774 9.58589C27.6944 9.16889 28.1895 8.83812 28.7344 8.61248C29.2793 8.38684 29.8633 8.27075 30.4531 8.27083ZM19.4194 8.88458C19.5521 8.8877 19.6841 8.86422 19.8076 8.81553C19.9311 8.76684 20.0436 8.69392 20.1385 8.60108C20.2334 8.50824 20.3088 8.39734 20.3601 8.27493C20.4115 8.15251 20.4379 8.02105 20.4377 7.88829C20.4375 7.75553 20.4107 7.62416 20.3589 7.50191C20.3072 7.37965 20.2315 7.269 20.1363 7.17645C20.0411 7.08391 19.9283 7.01135 19.8047 6.96305C19.681 6.91474 19.5489 6.89168 19.4162 6.89521C19.1567 6.90211 18.9102 7.01014 18.7293 7.19626C18.5483 7.38238 18.4473 7.63184 18.4477 7.89142C18.4481 8.151 18.5499 8.40014 18.7315 8.58569C18.913 8.77124 19.1598 8.8785 19.4194 8.88458ZM12.3125 3.40396C12.4985 3.40388 12.6828 3.36715 12.8546 3.29587C13.0265 3.22459 13.1827 3.12015 13.3142 2.98852C13.4457 2.8569 13.55 2.70066 13.6211 2.52872C13.6922 2.35679 13.7288 2.17253 13.7287 1.98646C13.7286 1.80039 13.6919 1.61616 13.6206 1.44429C13.5494 1.27242 13.4449 1.11627 13.3133 0.98476C13.1817 0.853249 13.0254 0.748952 12.8535 0.677823C12.6816 0.606694 12.4973 0.570127 12.3112 0.570209C11.9355 0.570375 11.5751 0.719811 11.3095 0.985644C11.0439 1.25148 10.8948 1.61193 10.895 1.98771C10.8951 2.36349 11.0446 2.72381 11.3104 2.98941C11.5762 3.25501 11.9367 3.40412 12.3125 3.40396ZM4.62061 3.41333C5.00065 3.41483 5.36573 3.26538 5.63563 2.99782C5.90553 2.73027 6.05816 2.3665 6.05998 1.98646C6.05816 1.60642 5.90553 1.24265 5.63563 0.975097C5.36573 0.707541 5.00065 0.558089 4.62061 0.559584C4.43249 0.558762 4.24606 0.59503 4.07198 0.666316C3.8979 0.737601 3.73957 0.842504 3.60606 0.975027C3.47255 1.10755 3.36648 1.26509 3.2939 1.43864C3.22133 1.61219 3.18368 1.79835 3.18311 1.98646C3.18368 2.17457 3.22133 2.36073 3.2939 2.53428C3.36648 2.70783 3.47255 2.86537 3.60606 2.99789C3.73957 3.13041 3.8979 3.23532 4.07198 3.3066C4.24606 3.37789 4.43249 3.41416 4.62061 3.41333Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M18.07 17.4661C18.0712 17.6212 18.1336 17.7695 18.2436 17.8787C18.3537 17.9879 18.5024 18.0492 18.6575 18.0492C18.812 18.0489 18.9601 17.9873 19.0693 17.878C19.1784 17.7687 19.2398 17.6206 19.24 17.4661V13.9786H19.6963V17.4661C19.6963 17.7874 19.9575 18.0492 20.28 18.0492C20.4349 18.0489 20.5833 17.9875 20.6931 17.8783C20.8029 17.7691 20.8651 17.621 20.8663 17.4661V10.9467H21.3175V13.1574C21.3175 13.398 21.5119 13.593 21.7513 13.593C21.8082 13.5928 21.8645 13.5814 21.9169 13.5594C21.9694 13.5374 22.017 13.5052 22.0569 13.4647C22.0969 13.4242 22.1285 13.3762 22.1498 13.3235C22.1712 13.2707 22.1818 13.2143 22.1813 13.1574V10.6442C22.1813 9.94049 21.5613 9.36986 20.86 9.36986C20.86 9.36986 18.1625 9.37174 18.1513 9.37299L17.2781 9.28861L16.1563 5.37862C15.7038 3.80174 14.3838 3.85174 14.3838 3.85174H10.7469C10.7469 3.85174 9.42688 3.80174 8.97439 5.37862L8.38688 7.42612L7.79939 5.37862C7.34688 3.80174 6.02688 3.85174 6.02688 3.85174H3.21313C3.21313 3.85174 1.89376 3.80174 1.44126 5.37862L0.30876 9.32424C0.200635 9.69236 0.38126 10.0361 0.70251 10.1292C1.02501 10.2205 1.37688 9.99674 1.46313 9.70236L2.56251 5.85549H3.10063L1.49063 12.5142H2.91313V17.2442C2.91313 17.6342 3.22751 17.9505 3.61751 17.9505C4.00813 17.9505 4.32688 17.6342 4.32688 17.2442V12.5142H4.92251V17.2442C4.92251 17.4315 4.99692 17.6112 5.12937 17.7436C5.26181 17.8761 5.44145 17.9505 5.62876 17.9505C5.81607 17.9505 5.99571 17.8761 6.12815 17.7436C6.2606 17.6112 6.33501 17.4315 6.33501 17.2442V12.5142H7.73439L6.13876 5.85549H6.67688L7.77751 9.70236C7.85251 9.95799 8.08688 10.1642 8.36376 10.1411C8.64063 10.1649 8.92313 9.95736 8.99564 9.70236L10.0975 5.85549H10.5931V17.108C10.5991 17.3251 10.6895 17.5313 10.8451 17.6827C11.0008 17.8342 11.2094 17.9189 11.4266 17.9189C11.6437 17.9189 11.8523 17.8342 12.008 17.6827C12.1636 17.5313 12.2541 17.3251 12.26 17.108V10.7061H12.8744V17.108C12.8827 17.3232 12.9741 17.5268 13.1293 17.6761C13.2845 17.8254 13.4915 17.9088 13.7069 17.9088C13.9223 17.9088 14.1293 17.8254 14.2845 17.6761C14.4397 17.5268 14.531 17.3232 14.5394 17.108V5.85549H15.0775L16.1006 9.57424C16.165 9.79736 16.3963 10.0149 16.6444 10.0899L18.0713 10.4892V17.4667L18.07 17.4661Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1314_442">
                                    <rect width="40" height="40" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <div className="JobDiscussions">
                              <div className="JobDiscussions-inner"></div>
                            </div>
                          </div>
                          {/* <div className="ApplyforJobs-text">
                            Screening Tools
                          </div> */}
                        </div>
                      </div>
                      <div className="ApplyforJobs-contents">
                        <p className="text-center">
                          Health Care Recruiters - Finding the Best for Your
                          Practise
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="ApplyforJobs-outer fourthstep">
                    <div>
                      <div className="ApplyforJobs-section">
                        <div>
                          <div className="ApplyforJobs">
                            <div>
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_1314_445)">
                                  <path
                                    d="M16.9531 28.5348C17.7995 28.9645 18.5612 29.4918 19.2383 30.1168C19.9154 30.7418 20.5013 31.4449 20.9961 32.2262C21.4909 33.0074 21.862 33.8408 22.1094 34.7262C22.3568 35.6116 22.487 36.5361 22.5 37.4996H20C20 36.471 19.8047 35.5009 19.4141 34.5895C19.0234 33.678 18.4896 32.8837 17.8125 32.2067C17.1354 31.5296 16.3346 30.9892 15.4102 30.5856C14.4857 30.1819 13.5156 29.9866 12.5 29.9996C11.4583 29.9996 10.4883 30.1949 9.58984 30.5856C8.69141 30.9762 7.89714 31.51 7.20703 32.1871C6.51693 32.8642 5.97656 33.665 5.58594 34.5895C5.19531 35.514 5 36.484 5 37.4996H2.5C2.5 36.5491 2.63021 35.6311 2.89062 34.7457C3.15104 33.8603 3.52214 33.027 4.00391 32.2457C4.48568 31.4645 5.0651 30.7614 5.74219 30.1364C6.41927 29.5114 7.1875 28.9775 8.04688 28.5348C7.08333 27.8186 6.33464 26.9332 5.80078 25.8785C5.26693 24.8239 5 23.6975 5 22.4996C5 21.471 5.19531 20.5009 5.58594 19.5895C5.97656 18.678 6.51042 17.8837 7.1875 17.2067C7.86458 16.5296 8.65885 15.9892 9.57031 15.5856C10.4818 15.1819 11.4583 14.9866 12.5 14.9996C13.6979 14.9996 14.8242 15.2666 15.8789 15.8004C16.9336 16.3343 17.819 17.083 18.5352 18.0465C19.0299 17.0699 19.6615 16.1975 20.4297 15.4293C21.1979 14.6611 22.0703 14.0296 23.0469 13.5348C22.0833 12.8186 21.3346 11.9332 20.8008 10.8785C20.2669 9.82385 20 8.69755 20 7.49963C20 6.47099 20.1953 5.50094 20.5859 4.58948C20.9766 3.67802 21.5104 2.88375 22.1875 2.20667C22.8646 1.52958 23.6589 0.989217 24.5703 0.585571C25.4818 0.181925 26.4583 -0.013387 27.5 -0.000366211C28.5286 -0.000366211 29.4987 0.194946 30.4102 0.585571C31.3216 0.976196 32.1159 1.51005 32.793 2.18713C33.4701 2.86422 34.0104 3.665 34.4141 4.58948C34.8177 5.51396 35.013 6.48401 35 7.49963C35 8.69755 34.7331 9.82385 34.1992 10.8785C33.6654 11.9332 32.9167 12.8186 31.9531 13.5348C32.7995 13.9645 33.5612 14.4918 34.2383 15.1168C34.9154 15.7418 35.5013 16.4449 35.9961 17.2262C36.4909 18.0074 36.862 18.8408 37.1094 19.7262C37.3568 20.6116 37.487 21.5361 37.5 22.4996H35C35 21.471 34.8047 20.5009 34.4141 19.5895C34.0234 18.678 33.4896 17.8837 32.8125 17.2067C32.1354 16.5296 31.3346 15.9892 30.4102 15.5856C29.4857 15.1819 28.5156 14.9866 27.5 14.9996C26.4583 14.9996 25.4883 15.1949 24.5898 15.5856C23.6914 15.9762 22.8971 16.51 22.207 17.1871C21.5169 17.8642 20.9766 18.665 20.5859 19.5895C20.1953 20.514 20 21.484 20 22.4996C20 23.6975 19.7331 24.8239 19.1992 25.8785C18.6654 26.9332 17.9167 27.8186 16.9531 28.5348ZM22.5 7.49963C22.5 8.18974 22.6302 8.83427 22.8906 9.43323C23.151 10.0322 23.5091 10.566 23.9648 11.0348C24.4206 11.5035 24.9479 11.8616 25.5469 12.109C26.1458 12.3564 26.7969 12.4866 27.5 12.4996C28.1901 12.4996 28.8346 12.3694 29.4336 12.109C30.0326 11.8486 30.5664 11.4905 31.0352 11.0348C31.5039 10.5791 31.862 10.0517 32.1094 9.45276C32.3568 8.8538 32.487 8.20276 32.5 7.49963C32.5 6.80953 32.3698 6.165 32.1094 5.56604C31.849 4.96708 31.4909 4.43323 31.0352 3.96448C30.5794 3.49573 30.0521 3.13765 29.4531 2.89026C28.8542 2.64286 28.2031 2.51265 27.5 2.49963C26.8099 2.49963 26.1654 2.62984 25.5664 2.89026C24.9674 3.15068 24.4336 3.50875 23.9648 3.96448C23.4961 4.42021 23.138 4.94755 22.8906 5.54651C22.6432 6.14547 22.513 6.79651 22.5 7.49963ZM7.5 22.4996C7.5 23.1897 7.63021 23.8343 7.89062 24.4332C8.15104 25.0322 8.50911 25.566 8.96484 26.0348C9.42057 26.5035 9.94792 26.8616 10.5469 27.109C11.1458 27.3564 11.7969 27.4866 12.5 27.4996C13.1901 27.4996 13.8346 27.3694 14.4336 27.109C15.0326 26.8486 15.5664 26.4905 16.0352 26.0348C16.5039 25.5791 16.862 25.0517 17.1094 24.4528C17.3568 23.8538 17.487 23.2028 17.5 22.4996C17.5 21.8095 17.3698 21.165 17.1094 20.566C16.849 19.9671 16.4909 19.4332 16.0352 18.9645C15.5794 18.4957 15.0521 18.1377 14.4531 17.8903C13.8542 17.6429 13.2031 17.5127 12.5 17.4996C11.8099 17.4996 11.1654 17.6298 10.5664 17.8903C9.96745 18.1507 9.43359 18.5087 8.96484 18.9645C8.49609 19.4202 8.13802 19.9475 7.89062 20.5465C7.64323 21.1455 7.51302 21.7965 7.5 22.4996ZM36.875 39.9996L31.25 35.6051L25.625 39.9996L27.8906 32.9684L22.5 28.7496H29.2383L31.25 22.4996L33.2617 28.7496H40L34.6094 32.9684L36.875 39.9996Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1314_445">
                                    <rect width="40" height="40" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <div className="JobDiscussions">
                              <div className="JobDiscussions-inner"></div>
                            </div>
                          </div>
                          {/* <div className="ApplyforJobs-text">
                            Easy Communication
                          </div> */}
                        </div>
                      </div>
                      <div className="ApplyforJobs-contents">
                        <p className="text-center">
                          Healthcare Talent Acquisition - The Key to Building
                          Strong Teams
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="ApplyforJobs-outer fifthstep">
                    <div>
                      <div className="ApplyforJobs-section">
                        <div>
                          <div className="ApplyforJobs">
                            <div>
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_1314_447)">
                                  <path
                                    d="M25.0418 12.8584C25.0418 15.7065 22.7299 18.0146 19.8793 18.0146C17.0318 18.0146 14.7236 15.7059 14.7236 12.8584C14.7236 10.0109 17.0318 7.70215 19.8793 7.70215C22.7299 7.70215 25.0418 10.0109 25.0418 12.8584Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M19.8874 0.327148C17.5012 0.327148 14.168 1.2784 11.7537 3.69277L14.6212 8.91715C15.2477 8.11963 16.0474 7.47506 16.9597 7.0322C17.8721 6.58933 18.8733 6.35978 19.8874 6.3609C22.0493 6.3609 23.973 7.38215 25.1987 8.97027L28.0112 3.57277C25.9218 1.28965 22.1749 0.327148 19.8874 0.327148ZM22.0124 4.1634H20.6774V5.49715H19.0737V4.1634H17.7387V2.56027H19.0737V1.2209H20.6774V2.56027H22.0124V4.1634ZM13.1037 27.2815H14.4243L12.538 33.7465H27.2762L25.3987 27.2815H26.7205L28.6099 33.7465H32.9468L29.9868 23.9515C29.5243 22.3347 27.4968 19.4878 23.998 19.4015L15.9543 19.3946C12.3762 19.4121 10.3062 22.3146 9.83805 23.9509L6.82055 33.7459H11.2187L13.1037 27.2815ZM0.591797 35.8078H39.173V39.4784H0.591797V35.8078Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1314_447">
                                    <rect width="40" height="40" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <div className="JobDiscussions">
                              <div className="JobDiscussions-inner"></div>
                            </div>
                          </div>
                          {/* <div className="ApplyforJobs-text">Hire</div> */}
                        </div>
                      </div>
                      <div className="ApplyforJobs-contents">
                        <p className="text-center">
                          Your Partner in Healthcare Staffing Excellence
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="animate-on-scroll hrp-container  hrp-section-3 ">
          <div className="hrp-sub-section hrp-Employees-outer md:px-10">
            <div className="lg:flex flex-row-reverse md:flex-row items-center lg:py-10 container m-auto">
              <div className="md:flex lg:justify-start md:justify-center lg:w-1/2 md:w-full mb-8 md:mb-0 animate  animate-left">
                <img
                  src={nextSectionImage}
                  alt="Creative Agency"
                  className="rounded-lg "
                />
              </div>
              <div className="lg:w-1/2 md:w-full px-2 lg:px-10 md:px-3 animate  animate-right">
                <h1
                  className="lg:text-2xl font-bold mb-4 employer-Connecting-without-relying"
                  style={{ color: "#3E3E3E" }}
                >
                  Connecting You with Top Healthcare Talent
                </h1>
                <p
                  className="text-[#797979]-700 mb-4"
                  style={{ fontSize: "14px", color: "#797979" }}
                >
                  Whether you’re hiring for hospitals, clinics, or specialise d
                  healthcare Practises, we provide a tailored solution to find
                  the best talent for your needs. Our industry expertise ensures
                  that your job listings reach the right audience, helping you
                  fill critical roles in your organisation efficiently.
                </p>
                <ul className="list-disc lg:ml-5 list-inside mb-4 text-gray-700 w-full">
                  <li className="mb-2 2xl:flex items-start">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 inline-block"
                      style={{ stroke: "#003366" }}
                    >
                      <path
                        d="M20 6L9 17L4 12"
                        stroke="#003366"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span
                      className="font-semibold"
                      style={{ color: "#003366", fontSize: "13px" }}
                    >
                      Efficient Matching:
                    </span>
                    <p style={{ color: "#797979", fontSize: "12px" }}>
                      Leverage Advanced Algorithms To Find Candidates Who Meet
                      Your Exact Criteria.
                    </p>
                  </li>
                  <li className="mb-2 2xl:flex items-start">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 inline-block"
                      style={{ stroke: "#003366" }}
                    >
                      <path
                        d="M20 6L9 17L4 12"
                        stroke="#003366"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span
                      className="font-semibold"
                      style={{ color: "#003366", fontSize: "13px" }}
                    >
                      Comprehensive Insights:
                    </span>
                    <p style={{ color: "#797979", fontSize: "12px" }}>
                      Access In-Depth Reviews And Salary Estimates To Make
                      Informed Hiring Decisions.
                    </p>
                  </li>
                  <li className="mb-2 2xl:flex items-start">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2 inline-block"
                      style={{ stroke: "#003366" }}
                    >
                      <path
                        d="M20 6L9 17L4 12"
                        stroke="#003366"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span
                      className="font-semibold"
                      style={{ color: "#003366", fontSize: "13px" }}
                    >
                      User-Friendly Interface:
                    </span>
                    <p style={{ color: "#797979", fontSize: "12px" }}>
                      Enjoy A Seamless Experience From Job Posting To Candidate
                      Selection.
                    </p>
                  </li>
                </ul>

                <button
                  className="py-3 px-10 btnpostjob text-xl rounded-lg"
                  onClick={() => handleClickEmployee()}
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* -------------------------------new section Show Jobs on Your Website------------------------------------------------ */}

        <section className="animate-on-scroll hrp-container hrp-section-4">
          <div className=" hrp-sub-section  py-10  ">
            <div className="hrp-healthcare-banner-section">
              <div className="hrp-banner-content container m-auto">
                <div className="hrp-banner-text">
                  <h2>Hiring For Healthcare?</h2>
                  <p>We specialise In Finding The Right Talent</p>
                  <h3 className="mt-5">
                    Your Trusted Partner In Healthcare Recruitment
                  </h3>
                  <div class="hrp-read-now-btn flex mt-10 ">
                    <a
                      href="/register"
                      class="flex text-white m-auto md:px-10 px-8 py-3
                        rounded-full hover:opacity-90 transition-opacity"
                    >
                      <button class="flex text-white m-auto md:px-10 px-8 py-3 rounded-full hover:opacity-90 transition-opacity">
                        Click to Start
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9 6L15 12L9 18"
                            stroke="white"
                            strokeWidth="2"
                          ></path>
                        </svg>
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* -------------------------------new section Show Jobs on Your Website------------------------------------------------ */}
        <section className="animate-on-scroll hrp-container hrp-section-5">
          <div className="hrp-sub-container">
            <div className="hrp-value-delivery-section container m-auto">
              <div className="hrp-value-content-wrapper pt-20  pb-0 px-5">
                <div className="hrp-value-text-container">
                  <h2>We Seek Always To Create & Deliver Value For You.</h2>
                  <div className="hrp-value-info-block">
                    <h3>Our Mission</h3>

                    <p>
                      Our Mission Is To Enhance Health And Well-Being By
                      Providing The Best Total Healthcare.
                    </p>
                  </div>
                  <div className="hrp-value-info-block">
                    <h3>Our Vision</h3>
                    <p>
                      Trusted Partner For Health. A Healthy Community With
                      Quality, Affordable Healthcare For All.
                    </p>
                  </div>
                  <div className="hrp-value-info-block">
                    <h3>Quality Policy</h3>
                    <p>
                      We Practise High Standards Through An Effective Quality
                      Management System To Assure That Our Services Meet.
                    </p>
                  </div>
                </div>
                <div className="hrp-value-image-container flex">
                  <img
                    className="m-auto"
                    src={health_bgimage} // Replace with actual path to your image
                    alt="Healthcare Professionals"
                  />
                </div>
              </div>
            </div>
          </div>
          <section className="animate-on-scroll  container m-auto ">
            <div className="hrp-stats-container hrp-stats-section">
              <div className="hrp-stat-item">
                <div className="flex justify-center">
                  <div className="hrp-icon">
                    <svg
                      width="52"
                      height="54"
                      viewBox="0 0 52 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_1387_323)">
                        <g filter="url(#filter1_d_1387_323)">
                          <path
                            d="M8.66671 45.4997C7.47504 45.4997 6.45526 45.0757 5.60737 44.2278C4.75949 43.38 4.33482 42.3595 4.33337 41.1663V32.4997H19.5V36.833H32.5V32.4997H47.6667V41.1663C47.6667 42.358 47.2428 43.3785 46.3949 44.2278C45.547 45.0772 44.5265 45.5011 43.3334 45.4997H8.66671ZM23.8334 32.4997V28.1663H28.1667V32.4997H23.8334ZM4.33337 28.1663V17.333C4.33337 16.1413 4.75804 15.1216 5.60737 14.2737C6.45671 13.4258 7.47649 13.0011 8.66671 12.9997H17.3334V8.66634C17.3334 7.47467 17.758 6.4549 18.6074 5.60701C19.4567 4.75912 20.4765 4.33445 21.6667 4.33301H30.3334C31.525 4.33301 32.5455 4.75767 33.3949 5.60701C34.2442 6.45634 34.6682 7.47612 34.6667 8.66634V12.9997H43.3334C44.525 12.9997 45.5455 13.4243 46.3949 14.2737C47.2442 15.123 47.6682 16.1428 47.6667 17.333V28.1663H32.5V23.833H19.5V28.1663H4.33337ZM21.6667 12.9997H30.3334V8.66634H21.6667V12.9997Z"
                            fill="#FFA500"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1387_323"
                          x="-4"
                          y="0"
                          width="60"
                          height="60"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1387_323"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1387_323"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter1_d_1387_323"
                          x="3.33337"
                          y="4.33301"
                          width="45.3334"
                          height="43.167"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1" />
                          <feGaussianBlur stdDeviation="0.5" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1387_323"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1387_323"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>

                  {/* Replace with your icon library */}
                </div>
                <div>
                  <h3>12,376</h3>
                  <p>Live Jobs</p>
                </div>
              </div>
              <div className="hrp-stat-item">
                <div className="flex justify-center">
                  <div className="hrp-icon">
                    <svg
                      width="60"
                      height="53"
                      viewBox="0 0 60 53"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        clipPath="url(#clip0_1387_334)"
                        filter="url(#filter0_d_1387_334)"
                      >
                        <g filter="url(#filter1_d_1387_334)">
                          <path
                            d="M49.0103 39.0003C50.6353 39.0003 51.9245 37.9798 53.0836 36.552C55.4583 33.627 51.5605 31.287 50.0741 30.1452C48.564 28.9817 46.8761 28.3208 45.1666 28.167M43 23.8337C44.4366 23.8337 45.8143 23.263 46.8301 22.2472C47.846 21.2313 48.4166 19.8536 48.4166 18.417C48.4166 16.9804 47.846 15.6027 46.8301 14.5868C45.8143 13.571 44.4366 13.0003 43 13.0003M10.9896 39.0003C9.36464 39.0003 8.07547 37.9798 6.91631 36.552C4.54164 33.627 8.43947 31.287 9.92581 30.1452C11.436 28.9817 13.1216 28.3187 14.8333 28.167M15.9166 23.8337C14.4801 23.8337 13.1023 23.263 12.0865 22.2472C11.0707 21.2313 10.5 19.8536 10.5 18.417C10.5 16.9804 11.0707 15.6027 12.0865 14.5868C13.1023 13.571 14.4801 13.0003 15.9166 13.0003M21.5153 32.7408C19.301 34.1102 13.4965 36.9052 17.0303 40.4022C18.7615 42.1117 20.6833 43.3337 23.1035 43.3337H36.9008C39.321 43.3337 41.2428 42.1117 42.9696 40.4022C46.5056 36.9052 40.7011 34.1102 38.4868 32.7408C35.9363 31.1678 32.9987 30.3348 30.0021 30.3348C27.0056 30.3348 24.068 31.1678 21.5175 32.7408M37.5833 16.2503C37.5833 17.2462 37.3872 18.2323 37.0061 19.1523C36.625 20.0724 36.0664 20.9084 35.3622 21.6126C34.658 22.3167 33.822 22.8753 32.902 23.2564C31.9819 23.6375 30.9958 23.8337 30 23.8337C29.0041 23.8337 28.018 23.6375 27.098 23.2564C26.1779 22.8753 25.3419 22.3167 24.6377 21.6126C23.9336 20.9084 23.375 20.0724 22.9939 19.1523C22.6128 18.2323 22.4166 17.2462 22.4166 16.2503C22.4166 14.2391 23.2156 12.3103 24.6377 10.8881C26.0599 9.46595 27.9887 8.66699 30 8.66699C32.0112 8.66699 33.94 9.46595 35.3622 10.8881C36.7844 12.3103 37.5833 14.2391 37.5833 16.2503Z"
                            stroke="#FFA500"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            shape-rendering="crispEdges"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1387_334"
                          x="0"
                          y="0"
                          width="60"
                          height="60"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1387_334"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1387_334"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter1_d_1387_334"
                          x="3.66699"
                          y="7.16699"
                          width="52.666"
                          height="39.667"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1" />
                          <feGaussianBlur stdDeviation="0.5" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1387_334"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1387_334"
                            result="shape"
                          />
                        </filter>
                        <clipPath id="clip0_1387_334">
                          <rect
                            width="52"
                            height="52"
                            fill="white"
                            transform="translate(4)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
                <div>
                  <h3>89,562</h3>
                  <p>Jobs Candidate</p>
                </div>
              </div>
              <div className="hrp-stat-item">
                <div className="flex justify-center">
                  <div className="hrp-icon">
                    <svg
                      width="52"
                      height="52"
                      viewBox="0 0 52 52"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_1387_336)">
                        <path
                          d="M28.1667 19.4997H40.0834L28.1667 7.58301V19.4997ZM13.0001 4.33301H30.3334L43.3334 17.333V43.333C43.3334 44.4823 42.8769 45.5845 42.0642 46.3971C41.2516 47.2098 40.1494 47.6663 39.0001 47.6663H13.0001C11.8508 47.6663 10.7486 47.2098 9.93595 46.3971C9.12329 45.5845 8.66675 44.4823 8.66675 43.333V8.66634C8.66675 6.26134 10.5951 4.33301 13.0001 4.33301ZM30.3334 43.333V41.1663C30.3334 38.2847 24.5484 36.833 21.6667 36.833C18.7851 36.833 13.0001 38.2847 13.0001 41.1663V43.333H30.3334ZM21.6667 25.9997C20.5175 25.9997 19.4153 26.4562 18.6026 27.2689C17.79 28.0815 17.3334 29.1837 17.3334 30.333C17.3334 31.4823 17.79 32.5845 18.6026 33.3971C19.4153 34.2098 20.5175 34.6663 21.6667 34.6663C22.816 34.6663 23.9182 34.2098 24.7309 33.3971C25.5435 32.5845 26.0001 31.4823 26.0001 30.333C26.0001 29.1837 25.5435 28.0815 24.7309 27.2689C23.9182 26.4562 22.816 25.9997 21.6667 25.9997Z"
                          fill="#FFA500"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1387_336"
                          x="7.66675"
                          y="4.33301"
                          width="36.6667"
                          height="45.333"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1" />
                          <feGaussianBlur stdDeviation="0.5" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1387_336"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1387_336"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>

                  {/* Replace with your icon library */}
                </div>
                <div>
                  <h3>28,166</h3>
                  <p>Active Resume</p>
                </div>
              </div>
              <div className="hrp-stat-item">
                <div className="flex justify-center">
                  <div className="hrp-icon">
                    <svg
                      width="52"
                      height="52"
                      viewBox="0 0 52 52"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1387_338)">
                        <g filter="url(#filter0_d_1387_338)">
                          <path
                            d="M45.5 48.75V13H35.75V3.25H6.5V48.75H0V52H22.75V42.25H29.25V52H52V48.75H45.5ZM19.5 35.75H13V29.25H19.5V35.75ZM19.5 26H13V19.5H19.5V26ZM19.5 16.25H13V9.75H19.5V16.25ZM29.25 35.75H22.75V29.25H29.25V35.75ZM29.25 26H22.75V19.5H29.25V26ZM29.25 16.25H22.75V9.75H29.25V16.25ZM42.25 35.75H35.75V29.25H42.25V35.75ZM42.25 26H35.75V19.5H42.25V26Z"
                            fill="#FFA500"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1387_338"
                          x="-1"
                          y="3.25"
                          width="54"
                          height="50.75"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1" />
                          <feGaussianBlur stdDeviation="0.5" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1387_338"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1387_338"
                            result="shape"
                          />
                        </filter>
                        <clipPath id="clip0_1387_338">
                          <rect width="52" height="52" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  {/* Replace with your icon library */}
                </div>
                <div>
                  <h3>8,966</h3>
                  <p>Companies</p>
                </div>
              </div>
            </div>
          </section>
        </section>
        <section className="animate-on-scroll hrp-container hrp-section-7 hrp-Recruitment fade-in-left">
          <div className="container m-auto">
            <div>
              <div className="flex flex-col items-center justify-center p-10">
                <h2
                  className="md:text-3xl text-center text-xl font-semibold mt-10"
                  style={{ color: "#464646" }}
                >
                  Streamlined Recruitment, Tailored for You
                </h2>
                <p class="text-gray-600 mb-10 text-center hrp-testimonials mt-2 md:w-2/3 m-auto ">
                  Efficient Hiring Solutions to Connect You with the Perfect
                  Talent Faster and Smarter
                </p>
                <div className="relative  hrp-responcive-tablet">
                  <div className="hrp-cercle-Process"></div>
                  <div className="flex relative">
                    <div className="hrp-Process-line-1"></div>
                    <div className="hrp-Process-line-2"></div>
                    <div className="hrp-Process-line-3"></div>
                    <div className="hrp-Process-line-4"></div>
                  </div>
                </div>

                <div className="lg:flex items-center relative hrp-Recruitment-outer-container">
                  <div className="flex relative hrp-Recruitment-container">
                    <div className="flex flex-col items-center active-hrp-Recruitment-cercle hrp-Recruitment-position cursor-pointer	">
                      <div className="xl:w-32 xl:h-32 lg:w-24 lg:h-24 w-24 h-24   rounded-full flex items-center justify-center  border active-hrp-Recruitment-position  text-center  ">
                        Post Job
                      </div>
                    </div>
                    <div className="flex items-center m-auto  hrp-image-responcive">
                      <svg
                        width="121"
                        height="121"
                        viewBox="0 0 121 121"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M63.3124 84.6242C63.7499 85.3273 64.4486 85.8281 65.255 86.0164C66.0615 86.2047 66.9097 86.0652 67.6133 85.6286L92.6385 70.0787C93.3416 69.6412 93.8423 68.9425 94.0306 68.136C94.2189 67.3296 94.0795 66.4814 93.6428 65.7777L78.0929 40.7526C77.8841 40.3886 77.6042 40.0703 77.2697 39.8168C76.9353 39.5633 76.5532 39.3798 76.1463 39.2772C75.7394 39.1745 75.316 39.1549 74.9013 39.2195C74.4866 39.284 74.0892 39.4315 73.7328 39.653C73.3763 39.8745 73.0681 40.1655 72.8266 40.5086C72.585 40.8518 72.4151 41.2401 72.3269 41.6504C72.2387 42.0607 72.234 42.4846 72.3132 42.8967C72.3923 43.3088 72.5537 43.7008 72.7876 44.0492L84.3567 62.6679L51.1258 54.9077C48.2328 54.2321 44.0307 52.3095 41.0372 48.8763C38.1744 45.5977 36.2445 40.7613 37.9084 33.6363C38.0968 32.8293 37.957 31.9804 37.5196 31.2764C37.0821 30.5724 36.383 30.0711 35.5759 29.8826C34.7688 29.6941 33.9199 29.834 33.2159 30.2714C32.512 30.7088 32.0106 31.408 31.8221 32.2151C29.6959 41.3201 32.1601 48.211 36.3288 52.9883C40.3657 57.6151 45.8377 60.091 49.7045 60.9939L82.9354 68.7541L64.3168 80.3233C63.6136 80.7608 63.1129 81.4595 62.9246 82.2659C62.7363 83.0723 62.8758 83.9205 63.3124 84.6242Z"
                          fill="#FFA500"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="flex relative md:mt-0 mt-5">
                    <div className="flex flex-col items-center hrp-Recruitment-cercle hrp-Recruitment-position-2 cursor-pointer 	">
                      <div className="xl:w-32 xl:h-32 lg:w-24 lg:h-24 w-24 h-24  innercircleprocess rounded-full flex items-center justify-center bg-gray-100 text-center">
                        Shortlisted Applicant
                      </div>
                    </div>
                    <div className="flex items-center hrp-image-responcive">
                      <svg
                        width="101"
                        height="101"
                        viewBox="0 0 101 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M58.985 73.0975C59.5709 73.6827 60.3652 74.0114 61.1933 74.0114C62.0215 74.0114 62.8157 73.6827 63.4017 73.0975L84.235 52.2641C84.8202 51.6782 85.1489 50.8839 85.1489 50.0558C85.1489 49.2277 84.8202 48.4334 84.235 47.8475L63.4017 27.0141C63.1156 26.7071 62.7706 26.4609 62.3873 26.2901C62.0039 26.1193 61.5901 26.0274 61.1705 26.02C60.7509 26.0126 60.3341 26.0898 59.945 26.247C59.5559 26.4041 59.2024 26.6381 58.9057 26.9348C58.6089 27.2316 58.375 27.585 58.2178 27.9742C58.0607 28.3633 57.9835 28.7801 57.9909 29.1997C57.9983 29.6193 58.0901 30.0331 58.2609 30.4164C58.4317 30.7997 58.678 31.1447 58.985 31.4308L74.485 46.9308L40.36 46.9308C37.3892 46.9308 32.86 46.0141 29.1642 43.3516C25.6308 40.81 22.6517 36.5391 22.6517 29.2225C22.6517 28.3937 22.3224 27.5988 21.7364 27.0128C21.1503 26.4267 20.3555 26.0975 19.5267 26.0975C18.6979 26.0975 17.903 26.4267 17.317 27.0128C16.7309 27.5988 16.4017 28.3937 16.4017 29.2225C16.4017 38.5725 20.3683 44.7225 25.5142 48.4266C30.4975 52.0141 36.3892 53.1808 40.36 53.1808L74.485 53.1808L58.985 68.6808C58.3998 69.2667 58.0711 70.061 58.0711 70.8891C58.0711 71.7173 58.3998 72.5115 58.985 73.0975Z"
                          fill="#FFA500"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="flex relative md:mt-0 mt-5">
                    <div className="flex flex-col items-center hrp-Recruitment-cercle cursor-pointer	">
                      <div className="xl:w-32 xl:h-32 lg:w-24 lg:h-24 w-24 h-24 innercircleprocess  rounded-full flex items-center justify-center bg-gray-100  text-center">
                        Schedule Interview
                      </div>
                    </div>
                    <div className="flex items-center hrp-image-responcive">
                      <svg
                        width="122"
                        height="122"
                        viewBox="0 0 122 122"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M74.0141 81.7472C74.7224 82.1762 75.5721 82.3065 76.3764 82.1094C77.1808 81.9124 77.874 81.4041 78.3039 80.6963L93.5818 55.5042C94.0108 54.7959 94.1411 53.9462 93.944 53.1419C93.747 52.3375 93.2387 51.6443 92.5309 51.2144L67.3388 35.9365C66.9879 35.7063 66.5942 35.5492 66.1813 35.4746C65.7683 35.3999 65.3445 35.4091 64.9352 35.5018C64.5259 35.5944 64.1395 35.7686 63.7989 36.0138C63.4584 36.259 63.1707 36.5704 62.9531 36.9292C62.7355 37.288 62.5924 37.687 62.5323 38.1024C62.4722 38.5177 62.4964 38.9409 62.6035 39.3467C62.7105 39.7524 62.8982 40.1325 63.1553 40.4642C63.4124 40.7959 63.7336 41.0724 64.0999 41.2772L82.8428 52.644L49.6979 60.7637C46.8124 61.4705 42.1952 61.6579 37.972 59.9512C33.9354 58.3233 30.0256 54.8839 28.2846 47.7774C28.0874 46.9724 27.5785 46.2787 26.8699 45.8489C26.1612 45.4192 25.3108 45.2885 24.5058 45.4857C23.7008 45.6829 23.0071 46.1918 22.5774 46.9005C22.1476 47.6092 22.0169 48.4595 22.2141 49.2645C24.4389 58.346 29.7549 63.3755 35.6343 65.7489C41.3282 68.0477 47.3282 67.779 51.185 66.8342L84.3299 58.7145L72.9632 77.4574C72.5342 78.1657 72.4039 79.0154 72.6009 79.8197C72.798 80.6241 73.3062 81.3173 74.0141 81.7472Z"
                          fill="#FFA500"
                        />
                      </svg>
                    </div>
                  </div>
                  {/* Offer Job */}
                  <div className="flex md:mt-0 mt-5 items-center hrp-Recruitment-cercle hrp-Recruitment-position-4 cursor-pointer	">
                    <div className="xl:w-32 xl:h-32 lg:w-24 lg:h-24 w-24 h-24 innercircleprocess  rounded-full flex items-center justify-center bg-gray-100  text-center">
                      Offer Job
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="animate-on-scroll ">
          <div className=" hrp-departments-main-container">
            <div
              className="hrp-departments-inner-section "
              style={{ backgroundColor: "#307BC4" }}
            >
              <div className=" text-white text-center md:pt-12 pt-3  ">
                <h2 className="md:text-3xl text-xl font-bold py-5">
                  Empowering Excellence Across Every Department
                </h2>
                <p class="text-white-600 mb-10 text-center md:mt-2  md:w-2/3 m-auto ">
                  Delivering specialised Solutions and Expertise to Drive
                  Success in Every Area of Your Business
                </p>
              </div>

              {/* Cards Section */}
            </div>
            <div className="hrp-departments-card-container container m-auto">
              <Slider {...settings}>
                {departments.map((department) => (
                  <div
                    key={department.id}
                    className="bg-white hrp-departments-main-card shadow-md hover:shadow-xl transition-all border-b-4 border-yellow-300  p-4"
                  >
                    <div className="flex justify-center xl:pt-10 lg:pt-5">
                      {department.svg}
                    </div>
                    <p className="text-center font-medium">{department.name}</p>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </section>
        <sction className="hrp-container hrp-section-8 animate-on-scroll  scale-in">
          <div className=" hrp-sub-section ">
            <div className="  pb-16 pt-0 contactus">
              <div className="max-w-4xl mx-auto text-center">
                <h1
                  className="text-3xl font-bold mb-4"
                  style={{ color: "#3E3E3E" }}
                >
                  Contact Us
                </h1>
                <p className="text-gray-600 mb-12">
                  We’re here to help! Whether you have questions, feedback, or
                  need assistance, please reach out to us. Our team is dedicated
                  to providing prompt and effective support to ensure your
                  experience is seamless and satisfying.
                </p>
                <form
                  onSubmit={handleSubmit}
                  id="contactus"
                  className="space-y-6 animated-form"
                  style={{
                    width: "75%",
                    margin: "0 auto",
                  }}
                >
                  <div className="form-group">
                    <input
                      id="name"
                      name="name"
                      type="text"
                      placeholder=""
                      className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-[#FFA500]"
                    />
                    <label htmlFor="name" className="form-input-label">
                      Name
                    </label>
                  </div>
                  <div className="form-group">
                    <input
                      id="company"
                      type="text"
                      name="company"
                      placeholder=""
                      className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-[#FFA500]"
                    />
                    <label htmlFor="company" className="form-input-label">
                      Company
                    </label>
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder=""
                      className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-[#FFA500]"
                    />
                    <label htmlFor="email" className="form-input-label">
                      Email
                    </label>
                  </div>
                  <div className="form-group">
                    <input
                      id="phone"
                      name="phone"
                      type="text"
                      placeholder=""
                      className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-[#FFA500]"
                    />
                    <label htmlFor="phone" className="form-input-label">
                      Phone Number
                    </label>
                  </div>
                  <div className="form-group relative">
                    <textarea
                      id="query"
                      name="query"
                      placeholder=""
                      className="w-full px-4 py-2 focus:outline-none focus:border-[#FFA500] h-32 peer"
                    />
                    <label
                      htmlFor="query"
                      className="form-input-label absolute top-2 left-4 transition-all duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:left-4 peer-focus:-top-2 peer-focus:left-4 peer-focus:text-[#FFA500] text-gray-600"
                    >
                      Query
                    </label>
                  </div>

                  <div style={{ textAlign: "left" }}>
                    <button
                      type="submit"
                      className=" py-3 px-10 btnpostjob text-xl rounded-lg "
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </sction>
      </div>
      <VisitorTracker />
    </>
  );
};
export default HealthRecruiter;
